{
  "generatedAt": "2026-11-02T13:04:38.616Z",
  "source": "UN/LOCODEs of attended inspections, positioned by waykite.com",
  "points": [
    {
      "code": "AEARP",
      "name": "Ahmed Bin Rashid Port",
      "country": "AE",
      "lat": 25.533333,
      "lon": 55.55
    },
    {
      "code": "AEAUH",
      "name": "Abu Dhabi",
      "country": "AE",
      "lat": 24.466667,
      "lon": 54.366667
    },
    {
      "code": "AEDBP",
      "name": "Dibba",
      "country": "AE",
      "lat": 25.616667,
      "lon": 56.266667
    },
    {
      "code": "AEDXB",
      "name": "Dubai",
      "country": "AE",
      "lat": 25.25,
      "lon": 55.266667
    },
    {
      "code": "AEFJR",
      "name": "Al Fujayrah",
      "country": "AE",
      "lat": 25.116667,
      "lon": 56.333333
    },
    {
      "code": "AEHAM",
      "name": "Al Hamriyah",
      "country": "AE",
      "lat": 25.483333,
      "lon": 55.5
    },
    {
      "code": "AEHZP",
      "name": "Hamriya Free Zone Port",
      "country": "AE",
      "lat": 25.3,
      "lon": 55.316667
    },
    {
      "code": "AEJEA",
      "name": "Jebel Ali",
      "country": "AE",
      "lat": 25.016667,
      "lon": 55.05
    },
    {
      "code": "AEKHL",
      "name": "Mina Khalifa/Abu Dhabi",
      "country": "AE",
      "lat": 24.833333,
      "lon": 54.666667
    },
    {
      "code": "AEKLF",
      "name": "Khor al Fakkan",
      "country": "AE",
      "lat": 25.333333,
      "lon": 56.35
    },
    {
      "code": "AEMSA",
      "name": "Mina Saqr",
      "country": "AE",
      "lat": 25.966667,
      "lon": 56.066667
    },
    {
      "code": "AERWP",
      "name": "Ruwais Port",
      "country": "AE",
      "lat": 24.1,
      "lon": 52.716667
    },
    {
      "code": "AESHJ",
      "name": "Sharjah",
      "country": "AE",
      "lat": 25.35,
      "lon": 55.383333
    },
    {
      "code": "AGSJO",
      "name": "Saint John's",
      "country": "AG",
      "lat": 17.116667,
      "lon": -61.85
    },
    {
      "code": "ALDRZ",
      "name": "Durres",
      "country": "AL",
      "lat": 41.316667,
      "lon": 19.45
    },
    {
      "code": "ALROM",
      "name": "Romano Port",
      "country": "AL",
      "lat": 41.366667,
      "lon": 19.416667
    },
    {
      "code": "ALVOA",
      "name": "Vlore",
      "country": "AL",
      "lat": 40.466667,
      "lon": 19.483333
    },
    {
      "code": "AOCAB",
      "name": "Cabinda",
      "country": "AO",
      "lat": -5.533333,
      "lon": 12.2
    },
    {
      "code": "AOCLV",
      "name": "CLOV FPSO",
      "country": "AO",
      "lat": -7.45,
      "lon": 11.566667
    },
    {
      "code": "AOLAD",
      "name": "Luanda",
      "country": "AO",
      "lat": -8.8,
      "lon": 13.25
    },
    {
      "code": "AOLOB",
      "name": "Lobito",
      "country": "AO",
      "lat": -12.333333,
      "lon": 13.566667
    },
    {
      "code": "AOMSZ",
      "name": "Namibe",
      "country": "AO",
      "lat": -15.2,
      "lon": 12.15
    },
    {
      "code": "AOSZA",
      "name": "Soyo",
      "country": "AO",
      "lat": -6.116667,
      "lon": 12.333333
    },
    {
      "code": "ARACF",
      "name": "Arrecifes",
      "country": "AR",
      "lat": -34.083333,
      "lon": -60.116667
    },
    {
      "code": "ARASO",
      "name": "Arroyo Seco",
      "country": "AR",
      "lat": -33.133333,
      "lon": -60.433333
    },
    {
      "code": "ARBDE",
      "name": "Belen de Escobar",
      "country": "AR",
      "lat": -34.333333,
      "lon": -58.816667
    },
    {
      "code": "ARBHI",
      "name": "Bahia Blanca",
      "country": "AR",
      "lat": -38.716667,
      "lon": -62.283333
    },
    {
      "code": "ARBUE",
      "name": "Buenos Aires",
      "country": "AR",
      "lat": -34.6,
      "lon": -58.366667
    },
    {
      "code": "ARCMP",
      "name": "Campana",
      "country": "AR",
      "lat": -34.15,
      "lon": -58.95
    },
    {
      "code": "ARDGU",
      "name": "Del Guazu",
      "country": "AR",
      "lat": -33.9,
      "lon": -58.866667
    },
    {
      "code": "ARDSU",
      "name": "Dock Sur",
      "country": "AR",
      "lat": -34.65,
      "lon": -58.333333
    },
    {
      "code": "ARLPS",
      "name": "Las Palmas",
      "country": "AR",
      "lat": -34.016667,
      "lon": -59.116667
    },
    {
      "code": "ARNEC",
      "name": "Necochea",
      "country": "AR",
      "lat": -38.562222,
      "lon": -58.745278
    },
    {
      "code": "ARPRS",
      "name": "Puerto Rosales/Bahia Blanca",
      "country": "AR",
      "lat": -38.933333,
      "lon": -62.066667
    },
    {
      "code": "ARROS",
      "name": "Rosario",
      "country": "AR",
      "lat": -32.95,
      "lon": -60.65
    },
    {
      "code": "ARSLO",
      "name": "San Lorenzo",
      "country": "AR",
      "lat": -32.65,
      "lon": -60.716667
    },
    {
      "code": "ARZAE",
      "name": "Zarate",
      "country": "AR",
      "lat": -34.1,
      "lon": -59.033333
    },
    {
      "code": "AUADL",
      "name": "Adelaide",
      "country": "AU",
      "lat": -34.916667,
      "lon": 138.583333
    },
    {
      "code": "AUASB",
      "name": "Ashburton",
      "country": "AU",
      "lat": -21.683333,
      "lon": 115
    },
    {
      "code": "AUBEL",
      "name": "Bell Bay",
      "country": "AU",
      "lat": -41.116667,
      "lon": 146.866667
    },
    {
      "code": "AUBNE",
      "name": "Brisbane",
      "country": "AU",
      "lat": -27.466667,
      "lon": 153.016667
    },
    {
      "code": "AUBTB",
      "name": "Botany Bay",
      "country": "AU",
      "lat": -34,
      "lon": 151.233333
    },
    {
      "code": "AUBUY",
      "name": "Bunbury",
      "country": "AU",
      "lat": -33.316667,
      "lon": 115.633333
    },
    {
      "code": "AUBWB",
      "name": "Barrow Island",
      "country": "AU",
      "lat": -20.864444,
      "lon": 115.406111
    },
    {
      "code": "AUCNS",
      "name": "Cairns",
      "country": "AU",
      "lat": -16.916667,
      "lon": 145.783333
    },
    {
      "code": "AUDAM",
      "name": "Dampier",
      "country": "AU",
      "lat": -20.633333,
      "lon": 116.716667
    },
    {
      "code": "AUDPO",
      "name": "Devonport",
      "country": "AU",
      "lat": -41.183333,
      "lon": 146.366667
    },
    {
      "code": "AUDRW",
      "name": "Darwin",
      "country": "AU",
      "lat": -12.45,
      "lon": 130.833333
    },
    {
      "code": "AUEPR",
      "name": "Esperance",
      "country": "AU",
      "lat": -33.866667,
      "lon": 121.9
    },
    {
      "code": "AUGET",
      "name": "Geraldton",
      "country": "AU",
      "lat": -28.783333,
      "lon": 114.6
    },
    {
      "code": "AUGEX",
      "name": "Geelong",
      "country": "AU",
      "lat": -38.15,
      "lon": 144.366667
    },
    {
      "code": "AUGLT",
      "name": "Gladstone",
      "country": "AU",
      "lat": -23.85,
      "lon": 151.25
    },
    {
      "code": "AUGOV",
      "name": "Gove",
      "country": "AU",
      "lat": -12.2,
      "lon": 136.7
    },
    {
      "code": "AUHAS",
      "name": "Hastings",
      "country": "AU",
      "lat": -38.3,
      "lon": 145.25
    },
    {
      "code": "AUHBA",
      "name": "Hobart",
      "country": "AU",
      "lat": -42.866667,
      "lon": 147.3
    },
    {
      "code": "AUHPT",
      "name": "Hay Point",
      "country": "AU",
      "lat": -21.283333,
      "lon": 149.3
    },
    {
      "code": "AUKOI",
      "name": "Koolan Island",
      "country": "AU",
      "lat": -16.125278,
      "lon": 123.738333
    },
    {
      "code": "AUKWI",
      "name": "Kwinana",
      "country": "AU",
      "lat": -32.23013,
      "lon": 115.78128
    },
    {
      "code": "AUMEL",
      "name": "Melbourne",
      "country": "AU",
      "lat": -37.816667,
      "lon": 144.966667
    },
    {
      "code": "AUMKY",
      "name": "Mackay",
      "country": "AU",
      "lat": -21.15,
      "lon": 149.2
    },
    {
      "code": "AUNTL",
      "name": "Newcastle",
      "country": "AU",
      "lat": -32.916667,
      "lon": 151.783333
    },
    {
      "code": "AUPBY",
      "name": "Port Bonython",
      "country": "AU",
      "lat": -33.016667,
      "lon": 137.766667
    },
    {
      "code": "AUPHE",
      "name": "Port Hedland",
      "country": "AU",
      "lat": -20.319444,
      "lon": 118.572222
    },
    {
      "code": "AUPKL",
      "name": "Port Kembla",
      "country": "AU",
      "lat": -34.463384,
      "lon": 150.900029
    },
    {
      "code": "AUSYD",
      "name": "Sydney",
      "country": "AU",
      "lat": -33.85,
      "lon": 151.2
    },
    {
      "code": "AUTSV",
      "name": "Townsville",
      "country": "AU",
      "lat": -19.24782,
      "lon": 146.833407
    },
    {
      "code": "AUWEI",
      "name": "Weipa",
      "country": "AU",
      "lat": -12.666667,
      "lon": 141.866667
    },
    {
      "code": "AUWEP",
      "name": "Westernport",
      "country": "AU",
      "lat": -38.35,
      "lon": 145.233333
    },
    {
      "code": "AUWYN",
      "name": "Wyndham",
      "country": "AU",
      "lat": -15.466667,
      "lon": 128.1
    },
    {
      "code": "AWSNL",
      "name": "Sint Nicolaas",
      "country": "AW",
      "lat": 12.433333,
      "lon": -69.916667
    },
    {
      "code": "AZBAK",
      "name": "Baku",
      "country": "AZ",
      "lat": 40.37767,
      "lon": 49.89201
    },
    {
      "code": "BBBGI",
      "name": "Bridgetown",
      "country": "BB",
      "lat": 13.1,
      "lon": -59.633333
    },
    {
      "code": "BDCGP",
      "name": "Chattogram",
      "country": "BD",
      "lat": 22.333333,
      "lon": 91.833333
    },
    {
      "code": "BDMGL",
      "name": "Mongla",
      "country": "BD",
      "lat": 22.466667,
      "lon": 89.6
    },
    {
      "code": "BEANR",
      "name": "Antwerpen",
      "country": "BE",
      "lat": 51.216667,
      "lon": 4.416667
    },
    {
      "code": "BEGNE",
      "name": "Gent (Ghent)",
      "country": "BE",
      "lat": 51.05,
      "lon": 3.716667
    },
    {
      "code": "BEHEX",
      "name": "Hemiksem",
      "country": "BE",
      "lat": 51.15,
      "lon": 4.35
    },
    {
      "code": "BESCT",
      "name": "Schoten",
      "country": "BE",
      "lat": 51.25,
      "lon": 4.5
    },
    {
      "code": "BEZEE",
      "name": "Zeebrugge",
      "country": "BE",
      "lat": 51.333333,
      "lon": 3.2
    },
    {
      "code": "BEZEL",
      "name": "Zelzate",
      "country": "BE",
      "lat": 51.2,
      "lon": 3.816667
    },
    {
      "code": "BGBOJ",
      "name": "Burgas",
      "country": "BG",
      "lat": 42.483333,
      "lon": 27.483333
    },
    {
      "code": "BGVAR",
      "name": "Varna",
      "country": "BG",
      "lat": 43.183333,
      "lon": 27.966667
    },
    {
      "code": "BHAHD",
      "name": "Al Hidd",
      "country": "BH",
      "lat": 26.233333,
      "lon": 50.65
    },
    {
      "code": "BHBAH",
      "name": "Bahrain International Airport",
      "country": "BH",
      "lat": 26.266667,
      "lon": 50.633333
    },
    {
      "code": "BHKBS",
      "name": "Khalifa Bin Salman Port",
      "country": "BH",
      "lat": 26.2,
      "lon": 50.616667
    },
    {
      "code": "BHMIN",
      "name": "Mina Sulman Port",
      "country": "BH",
      "lat": 26.2,
      "lon": 50.616667
    },
    {
      "code": "BJCOO",
      "name": "Cotonou",
      "country": "BJ",
      "lat": 6.35,
      "lon": 2.433333
    },
    {
      "code": "BNMUA",
      "name": "Muara",
      "country": "BN",
      "lat": 5.033333,
      "lon": 115.066667
    },
    {
      "code": "BQEUX",
      "name": "Sint Eustatius",
      "country": "BQ",
      "lat": 17.483333,
      "lon": -62.966667
    },
    {
      "code": "BRACX",
      "name": "Acu Pt / Sao Joao da Barra",
      "country": "BR",
      "lat": -21.816667,
      "lon": -41.016667
    },
    {
      "code": "BRADR",
      "name": "Angra dos Reis",
      "country": "BR",
      "lat": -23,
      "lon": -44.316667
    },
    {
      "code": "BRAJU",
      "name": "Aracaju",
      "country": "BR",
      "lat": -10.9,
      "lon": -37.033333
    },
    {
      "code": "BRANT",
      "name": "Antonina",
      "country": "BR",
      "lat": -25.416667,
      "lon": -48.7
    },
    {
      "code": "BRARB",
      "name": "Aratu Pt / Candeias",
      "country": "BR",
      "lat": -12.783333,
      "lon": -38.5
    },
    {
      "code": "BRARE",
      "name": "Areia Branca",
      "country": "BR",
      "lat": -4.95,
      "lon": -37.116667
    },
    {
      "code": "BRBAR",
      "name": "Barra dos Coqueiros",
      "country": "BR",
      "lat": -10.9,
      "lon": -37.033333
    },
    {
      "code": "BRBEL",
      "name": "Belem",
      "country": "BR",
      "lat": -1.45,
      "lon": -48.483333
    },
    {
      "code": "BRCDO",
      "name": "Cabedelo Pt / Joao Pessoa",
      "country": "BR",
      "lat": -6.966667,
      "lon": -34.833333
    },
    {
      "code": "BRFOR",
      "name": "Fortaleza",
      "country": "BR",
      "lat": -3.716667,
      "lon": -38.583333
    },
    {
      "code": "BRGIB",
      "name": "Guaiba",
      "country": "BR",
      "lat": -30.1,
      "lon": -51.3
    },
    {
      "code": "BRGUA",
      "name": "Guamare",
      "country": "BR",
      "lat": -5.1,
      "lon": -36.316667
    },
    {
      "code": "BRIAR",
      "name": "Itacoatiara",
      "country": "BR",
      "lat": -3.133333,
      "lon": -58.433333
    },
    {
      "code": "BRIBB",
      "name": "Imbituba",
      "country": "BR",
      "lat": -28.233333,
      "lon": -48.666667
    },
    {
      "code": "BRIOA",
      "name": "Itapoa",
      "country": "BR",
      "lat": -26,
      "lon": -48.6
    },
    {
      "code": "BRIOS",
      "name": "Ilheus",
      "country": "BR",
      "lat": -14.783333,
      "lon": -39.033333
    },
    {
      "code": "BRIQI",
      "name": "Itaqui Pt / Sao Luis",
      "country": "BR",
      "lat": -2.566667,
      "lon": -44.366667
    },
    {
      "code": "BRITJ",
      "name": "Itajai",
      "country": "BR",
      "lat": -26.9,
      "lon": -48.65
    },
    {
      "code": "BRITQ",
      "name": "Itaqui",
      "country": "BR",
      "lat": -29.116667,
      "lon": -56.55
    },
    {
      "code": "BRJUR",
      "name": "Juruti",
      "country": "BR",
      "lat": -2.15,
      "lon": -56.083333
    },
    {
      "code": "BRMAO",
      "name": "Manaus",
      "country": "BR",
      "lat": -3.133333,
      "lon": -60.016667
    },
    {
      "code": "BRMCZ",
      "name": "Maceio",
      "country": "BR",
      "lat": -9.65,
      "lon": -35.7
    },
    {
      "code": "BRMDD",
      "name": "Madre de Deus",
      "country": "BR",
      "lat": -12.733333,
      "lon": -38.6
    },
    {
      "code": "BRMSP",
      "name": "Monte Alegre de Sergipe",
      "country": "BR",
      "lat": -10.016667,
      "lon": -37.55
    },
    {
      "code": "BRPEC",
      "name": "Pecem Pt / Sao Goncalo do Amarante",
      "country": "BR",
      "lat": -3.516667,
      "lon": -38.866667
    },
    {
      "code": "BRPMA",
      "name": "Ponta da Madeira Pt / Sao Luis",
      "country": "BR",
      "lat": -2.533333,
      "lon": -44.35
    },
    {
      "code": "BRPNG",
      "name": "Paranagua",
      "country": "BR",
      "lat": -25.5,
      "lon": -48.516667
    },
    {
      "code": "BRPOA",
      "name": "Porto Alegre",
      "country": "BR",
      "lat": -30.016667,
      "lon": -51.216667
    },
    {
      "code": "BRPOU",
      "name": "Ponta do Ubu Pt / Anchieta",
      "country": "BR",
      "lat": -20.766667,
      "lon": -40.566667
    },
    {
      "code": "BRPRM",
      "name": "Praia Mole Pt / Vitoria",
      "country": "BR",
      "lat": -20.3,
      "lon": -40.216667
    },
    {
      "code": "BRRCH",
      "name": "Barra do Riacho Pt / Aracruz",
      "country": "BR",
      "lat": -19.85,
      "lon": -40.033333
    },
    {
      "code": "BRREC",
      "name": "Recife",
      "country": "BR",
      "lat": -8.05,
      "lon": -34.883333
    },
    {
      "code": "BRRIG",
      "name": "Rio Grande",
      "country": "BR",
      "lat": -32.05,
      "lon": -52.083333
    },
    {
      "code": "BRRIO",
      "name": "Rio de Janeiro",
      "country": "BR",
      "lat": -22.866667,
      "lon": -43.216667
    },
    {
      "code": "BRSFS",
      "name": "Sao Francisco do Sul",
      "country": "BR",
      "lat": -26.233333,
      "lon": -48.633333
    },
    {
      "code": "BRSPB",
      "name": "Itaguai Pt = Sepetiba Pt / Itaguai",
      "country": "BR",
      "lat": -22.866667,
      "lon": -43.766667
    },
    {
      "code": "BRSSA",
      "name": "Salvador",
      "country": "BR",
      "lat": -13,
      "lon": -38.483333
    },
    {
      "code": "BRSSO",
      "name": "Sao Sebastiao",
      "country": "BR",
      "lat": -23.8,
      "lon": -45.4
    },
    {
      "code": "BRSSZ",
      "name": "Santos",
      "country": "BR",
      "lat": -23.933333,
      "lon": -46.316667
    },
    {
      "code": "BRSTM",
      "name": "Santarem",
      "country": "BR",
      "lat": -2.433333,
      "lon": -54.716667
    },
    {
      "code": "BRSUA",
      "name": "Suape Pt / Ipojuca",
      "country": "BR",
      "lat": -8.4,
      "lon": -34.966667
    },
    {
      "code": "BRSVP",
      "name": "Santa Vitoria do Palmar",
      "country": "BR",
      "lat": -33.516667,
      "lon": -53.366667
    },
    {
      "code": "BRTMT",
      "name": "Porto Trombetas / Oriximina",
      "country": "BR",
      "lat": -1.466667,
      "lon": -56.383333
    },
    {
      "code": "BRTRM",
      "name": "Tramandai",
      "country": "BR",
      "lat": -29.983333,
      "lon": -50.116667
    },
    {
      "code": "BRTUB",
      "name": "Tubarao Pt / Vitoria",
      "country": "BR",
      "lat": -20.266667,
      "lon": -40.216667
    },
    {
      "code": "BRVDC",
      "name": "Vila do Conde Pt / Barcarena",
      "country": "BR",
      "lat": -1.516667,
      "lon": -48.716667
    },
    {
      "code": "BRVIX",
      "name": "Vitoria",
      "country": "BR",
      "lat": -20.316667,
      "lon": -40.316667
    },
    {
      "code": "BSFPO",
      "name": "Freeport, Grand Bahama",
      "country": "BS",
      "lat": 26.516667,
      "lon": -78.783333
    },
    {
      "code": "BSNAS",
      "name": "Nassau",
      "country": "BS",
      "lat": 25.083333,
      "lon": -77.35
    },
    {
      "code": "CABCO",
      "name": "Baie Comeau",
      "country": "CA",
      "lat": 49.233333,
      "lon": -68.133333
    },
    {
      "code": "CABEC",
      "name": "Becancour",
      "country": "CA",
      "lat": 46.333333,
      "lon": -72.433333
    },
    {
      "code": "CABEL",
      "name": "Belledune",
      "country": "CA",
      "lat": 47.885833,
      "lon": -65.811389
    },
    {
      "code": "CABLK",
      "name": "Baker Lake",
      "country": "CA",
      "lat": 64.316667,
      "lon": -96.033333
    },
    {
      "code": "CACBC",
      "name": "Come By Chance",
      "country": "CA",
      "lat": 47.85,
      "lon": -53.983333
    },
    {
      "code": "CACPT",
      "name": "Canaport",
      "country": "CA",
      "lat": 45.2,
      "lon": -65.983333
    },
    {
      "code": "CACRO",
      "name": "Crofton",
      "country": "CA",
      "lat": 48.866667,
      "lon": -123.633333
    },
    {
      "code": "CACSC",
      "name": "Cote-Sainte-Catherine",
      "country": "CA",
      "lat": 45.492222,
      "lon": -73.632778
    },
    {
      "code": "CADAR",
      "name": "Dartmouth",
      "country": "CA",
      "lat": 44.666667,
      "lon": -63.566667
    },
    {
      "code": "CAGAE",
      "name": "Grande Anse",
      "country": "CA",
      "lat": 47.8,
      "lon": -65.183333
    },
    {
      "code": "CAGCA",
      "name": "Gros Cacouna",
      "country": "CA",
      "lat": 47.9275,
      "lon": -69.514444
    },
    {
      "code": "CAHAL",
      "name": "Halifax",
      "country": "CA",
      "lat": 44.65,
      "lon": -63.583333
    },
    {
      "code": "CAHAM",
      "name": "Hamilton",
      "country": "CA",
      "lat": 43.25,
      "lon": -79.85
    },
    {
      "code": "CAHMC",
      "name": "Harmac",
      "country": "CA",
      "lat": 49.133333,
      "lon": -123.85
    },
    {
      "code": "CAKTM",
      "name": "Kitimat",
      "country": "CA",
      "lat": 54,
      "lon": -128.683333
    },
    {
      "code": "CAMTR",
      "name": "Montreal",
      "country": "CA",
      "lat": 45.516667,
      "lon": -73.55
    },
    {
      "code": "CAMUL",
      "name": "Mulgrave",
      "country": "CA",
      "lat": 45.612222,
      "lon": -61.391667
    },
    {
      "code": "CANAN",
      "name": "Nanticoke",
      "country": "CA",
      "lat": 42.8,
      "lon": -80.066667
    },
    {
      "code": "CAOSH",
      "name": "Oshawa",
      "country": "CA",
      "lat": 43.866667,
      "lon": -78.816667
    },
    {
      "code": "CAPAF",
      "name": "Port-Alfred",
      "country": "CA",
      "lat": 48.333333,
      "lon": -70.883333
    },
    {
      "code": "CAPCA",
      "name": "Port-Cartier",
      "country": "CA",
      "lat": 50.016667,
      "lon": -66.866667
    },
    {
      "code": "CAPDL",
      "name": "Port-Daniel",
      "country": "CA",
      "lat": 48.183333,
      "lon": -64.983333
    },
    {
      "code": "CAPMO",
      "name": "Port Moody/Vancouver",
      "country": "CA",
      "lat": 49.283333,
      "lon": -122.883333
    },
    {
      "code": "CAPNO",
      "name": "Pointe Noire",
      "country": "CA",
      "lat": 50.15,
      "lon": -66.483333
    },
    {
      "code": "CAPRR",
      "name": "Prince Rupert",
      "country": "CA",
      "lat": 54.316667,
      "lon": -130.333333
    },
    {
      "code": "CAPTU",
      "name": "Point Tupper",
      "country": "CA",
      "lat": 45.6,
      "lon": -61.366667
    },
    {
      "code": "CAQUE",
      "name": "Quebec",
      "country": "CA",
      "lat": 46.816667,
      "lon": -71.216667
    },
    {
      "code": "CARTB",
      "name": "Robert's Bank",
      "country": "CA",
      "lat": 49.066667,
      "lon": -123.166667
    },
    {
      "code": "CASAG",
      "name": "Saguenay",
      "country": "CA",
      "lat": 48.416667,
      "lon": -71.066667
    },
    {
      "code": "CASEB",
      "name": "Seven Islands Bay",
      "country": "CA",
      "lat": 59.416667,
      "lon": -63.75
    },
    {
      "code": "CASEI",
      "name": "Sept-Iles",
      "country": "CA",
      "lat": 50.2,
      "lon": -66.383333
    },
    {
      "code": "CASJB",
      "name": "Saint-John",
      "country": "CA",
      "lat": 45.266667,
      "lon": -66.066667
    },
    {
      "code": "CASJF",
      "name": "Saint-John's",
      "country": "CA",
      "lat": 47.566667,
      "lon": -52.733333
    },
    {
      "code": "CASNI",
      "name": "Sarnia",
      "country": "CA",
      "lat": 42.983333,
      "lon": -82.416667
    },
    {
      "code": "CASOR",
      "name": "Sorel",
      "country": "CA",
      "lat": 46.05,
      "lon": -73.116667
    },
    {
      "code": "CASQA",
      "name": "Squamish",
      "country": "CA",
      "lat": 49.7817,
      "lon": -123.162003
    },
    {
      "code": "CASSM",
      "name": "Sault-Sainte-Marie",
      "country": "CA",
      "lat": 46.516667,
      "lon": -84.35
    },
    {
      "code": "CASTW",
      "name": "Stewart",
      "country": "CA",
      "lat": 55.933333,
      "lon": -130
    },
    {
      "code": "CASYD",
      "name": "Sydney",
      "country": "CA",
      "lat": 46.15,
      "lon": -60.2
    },
    {
      "code": "CATHU",
      "name": "Thunder Bay",
      "country": "CA",
      "lat": 48.4,
      "lon": -89.233333
    },
    {
      "code": "CATOR",
      "name": "Toronto",
      "country": "CA",
      "lat": 43.616667,
      "lon": -79.383333
    },
    {
      "code": "CATRC",
      "name": "Tracy",
      "country": "CA",
      "lat": 46.02503,
      "lon": -73.14124
    },
    {
      "code": "CATRR",
      "name": "Trois-Rivieres (Three Rivers)",
      "country": "CA",
      "lat": 46.35,
      "lon": -72.55
    },
    {
      "code": "CAVAN",
      "name": "Vancouver",
      "country": "CA",
      "lat": 49.283333,
      "lon": -123.116667
    },
    {
      "code": "CAVIC",
      "name": "Victoria",
      "country": "CA",
      "lat": 48.433333,
      "lon": -123.35
    },
    {
      "code": "CAWHH",
      "name": "Whiffen Head",
      "country": "CA",
      "lat": 47.75,
      "lon": -54.033333
    },
    {
      "code": "CAWND",
      "name": "Windsor",
      "country": "CA",
      "lat": 42.316667,
      "lon": -83.033333
    },
    {
      "code": "CDBNW",
      "name": "Banana",
      "country": "CD",
      "lat": -5.983333,
      "lon": 12.383333
    },
    {
      "code": "CDMAT",
      "name": "Matadi",
      "country": "CD",
      "lat": -5.816667,
      "lon": 13.45
    },
    {
      "code": "CGPNR",
      "name": "Pointe Noire",
      "country": "CG",
      "lat": -4.8,
      "lon": 11.85
    },
    {
      "code": "CIABJ",
      "name": "Abidjan",
      "country": "CI",
      "lat": 5.333333,
      "lon": -4.016667
    },
    {
      "code": "CISPY",
      "name": "San-Pedro",
      "country": "CI",
      "lat": 4.733333,
      "lon": -6.616667
    },
    {
      "code": "CLANF",
      "name": "Antofagasta",
      "country": "CL",
      "lat": -23.633333,
      "lon": -70.383333
    },
    {
      "code": "CLCBC",
      "name": "Calbuco",
      "country": "CL",
      "lat": -41.75,
      "lon": -73.133333
    },
    {
      "code": "CLCLD",
      "name": "Caldera",
      "country": "CL",
      "lat": -27.033333,
      "lon": -70.8
    },
    {
      "code": "CLCNL",
      "name": "Coronel",
      "country": "CL",
      "lat": -37.016667,
      "lon": -73.15
    },
    {
      "code": "CLCNX",
      "name": "Cabo Negro",
      "country": "CL",
      "lat": -52.966667,
      "lon": -70.85
    },
    {
      "code": "CLCOL",
      "name": "Caleta Coloso",
      "country": "CL",
      "lat": -23.75,
      "lon": -70.466667
    },
    {
      "code": "CLGYC",
      "name": "Guayacan",
      "country": "CL",
      "lat": -29.983333,
      "lon": -71.366667
    },
    {
      "code": "CLHSO",
      "name": "Huasco",
      "country": "CL",
      "lat": -28.45,
      "lon": -71.216667
    },
    {
      "code": "CLIQQ",
      "name": "Iquique",
      "country": "CL",
      "lat": -20.216667,
      "lon": -70.133333
    },
    {
      "code": "CLLQN",
      "name": "Lirquen",
      "country": "CL",
      "lat": -36.7,
      "lon": -72.983333
    },
    {
      "code": "CLMIC",
      "name": "Michilla",
      "country": "CL",
      "lat": -22.733333,
      "lon": -70.266667
    },
    {
      "code": "CLMJS",
      "name": "Mejillones",
      "country": "CL",
      "lat": -23.1,
      "lon": -70.45
    },
    {
      "code": "CLPAG",
      "name": "Puerto Angamos",
      "country": "CL",
      "lat": -23.083333,
      "lon": -70.45
    },
    {
      "code": "CLPAT",
      "name": "Puerto Patache",
      "country": "CL",
      "lat": -20.8,
      "lon": -70.2
    },
    {
      "code": "CLPCH",
      "name": "Puerto Chacabuco",
      "country": "CL",
      "lat": -45.483333,
      "lon": -72.833333
    },
    {
      "code": "CLPMC",
      "name": "Puerto Montt",
      "country": "CL",
      "lat": -41.466667,
      "lon": -72.95
    },
    {
      "code": "CLPUQ",
      "name": "Punta Arenas",
      "country": "CL",
      "lat": -53.133333,
      "lon": -70.933333
    },
    {
      "code": "CLQTV",
      "name": "Quintero",
      "country": "CL",
      "lat": -32.766667,
      "lon": -71.533333
    },
    {
      "code": "CLSVE",
      "name": "San Vicente",
      "country": "CL",
      "lat": -36.7,
      "lon": -73.133333
    },
    {
      "code": "CLVAP",
      "name": "Valparaiso",
      "country": "CL",
      "lat": -33.033333,
      "lon": -71.633333
    },
    {
      "code": "CLWPU",
      "name": "Puerto Williams",
      "country": "CL",
      "lat": -54.916667,
      "lon": -67.616667
    },
    {
      "code": "CMDLA",
      "name": "Douala",
      "country": "CM",
      "lat": 4.05,
      "lon": 9.683333
    },
    {
      "code": "CMKBI",
      "name": "Kribi",
      "country": "CM",
      "lat": 2.95,
      "lon": 9.916667
    },
    {
      "code": "CMLIM",
      "name": "Limbe",
      "country": "CM",
      "lat": 4.016667,
      "lon": 9.216667
    },
    {
      "code": "CNBEI",
      "name": "Beilun",
      "country": "CN",
      "lat": 29.933333,
      "lon": 121.883333
    },
    {
      "code": "CNBHT",
      "name": "Tieshan",
      "country": "CN",
      "lat": 24.1583,
      "lon": 109.678
    },
    {
      "code": "CNBIH",
      "name": "Beihai Pt",
      "country": "CN",
      "lat": 21.466667,
      "lon": 109.116667
    },
    {
      "code": "CNBIN",
      "name": "Binzhou",
      "country": "CN",
      "lat": 37.380556,
      "lon": 118.0125
    },
    {
      "code": "CNBSD",
      "name": "Baoshan Pt",
      "country": "CN",
      "lat": 31.416667,
      "lon": 121.483333
    },
    {
      "code": "CNBSP",
      "name": "Basuo Pt",
      "country": "CN",
      "lat": 19,
      "lon": 108.616667
    },
    {
      "code": "CNBYQ",
      "name": "Bayuquan",
      "country": "CN",
      "lat": 40.3,
      "lon": 122.083333
    },
    {
      "code": "CNCFD",
      "name": "Caofeidian Pt",
      "country": "CN",
      "lat": 38.95,
      "lon": 118.533333
    },
    {
      "code": "CNCFF",
      "name": "Suidong",
      "country": "CN",
      "lat": 47.41917,
      "lon": 132.1075
    },
    {
      "code": "CNCGS",
      "name": "Changshu Pt",
      "country": "CN",
      "lat": 31.65,
      "lon": 120.716667
    },
    {
      "code": "CNCIG",
      "name": "Chenjiagang",
      "country": "CN",
      "lat": 34.37861,
      "lon": 119.80306
    },
    {
      "code": "CNCJG",
      "name": "Caojing",
      "country": "CN",
      "lat": 30.783333,
      "lon": 121.4
    },
    {
      "code": "CNCOZ",
      "name": "Chaozhou",
      "country": "CN",
      "lat": 23.666667,
      "lon": 116.633333
    },
    {
      "code": "CNCWN",
      "name": "Chiwan Pt",
      "country": "CN",
      "lat": 22.483333,
      "lon": 113.883333
    },
    {
      "code": "CNCZX",
      "name": "Changzhou",
      "country": "CN",
      "lat": 31.783333,
      "lon": 119.966667
    },
    {
      "code": "CNDAL",
      "name": "Dalian",
      "country": "CN",
      "lat": 38.916667,
      "lon": 121.6
    },
    {
      "code": "CNDDG",
      "name": "Dandong",
      "country": "CN",
      "lat": 40.025453,
      "lon": 124.28669
    },
    {
      "code": "CNDFG",
      "name": "Dafeng",
      "country": "CN",
      "lat": 33.183333,
      "lon": 120.466667
    },
    {
      "code": "CNDGG",
      "name": "Dongguan",
      "country": "CN",
      "lat": 23.033333,
      "lon": 113.75
    },
    {
      "code": "CNDJA",
      "name": "Dongjiakou",
      "country": "CN",
      "lat": 35.6,
      "lon": 119.766667
    },
    {
      "code": "CNDMY",
      "name": "Damaiyu",
      "country": "CN",
      "lat": 28.083333,
      "lon": 121.15
    },
    {
      "code": "CNDPG",
      "name": "Dapeng",
      "country": "CN",
      "lat": 22.6,
      "lon": 114.5
    },
    {
      "code": "CNDYN",
      "name": "Dongying",
      "country": "CN",
      "lat": 37.416667,
      "lon": 118.683333
    },
    {
      "code": "CNFAN",
      "name": "Fangcheng Pt",
      "country": "CN",
      "lat": 21.766667,
      "lon": 108.35
    },
    {
      "code": "CNFCH",
      "name": "Fengcheng",
      "country": "CN",
      "lat": 36.7,
      "lon": 121.233333
    },
    {
      "code": "CNFZH",
      "name": "Fuzhou",
      "country": "CN",
      "lat": 26.083333,
      "lon": 119.3
    },
    {
      "code": "CNGGZ",
      "name": "Guangzhou",
      "country": "CN",
      "lat": 23.133333,
      "lon": 113.233333
    },
    {
      "code": "CNGLN",
      "name": "Gaolan",
      "country": "CN",
      "lat": 36.316667,
      "lon": 103.933333
    },
    {
      "code": "CNGUT",
      "name": "Guangdong Terminal",
      "country": "CN",
      "lat": 22.566667,
      "lon": 114.433333
    },
    {
      "code": "CNGZG",
      "name": "Guangzhou Pt",
      "country": "CN",
      "lat": 23.133333,
      "lon": 113.233333
    },
    {
      "code": "CNHKO",
      "name": "Haikou",
      "country": "CN",
      "lat": 20.033333,
      "lon": 110.333333
    },
    {
      "code": "CNHME",
      "name": "Haimen",
      "country": "CN",
      "lat": 28.666667,
      "lon": 121.433333
    },
    {
      "code": "CNHNH",
      "name": "Huanghua",
      "country": "CN",
      "lat": 27.99038,
      "lon": 120.9305
    },
    {
      "code": "CNHUA",
      "name": "Huangpu Pt",
      "country": "CN",
      "lat": 23.083333,
      "lon": 113.416667
    },
    {
      "code": "CNHUI",
      "name": "Huizhou",
      "country": "CN",
      "lat": 23.083333,
      "lon": 114.366667
    },
    {
      "code": "CNJAX",
      "name": "Jiaxing",
      "country": "CN",
      "lat": 30.766667,
      "lon": 120.75
    },
    {
      "code": "CNJGY",
      "name": "Jiangyin",
      "country": "CN",
      "lat": 25.466667,
      "lon": 119.3
    },
    {
      "code": "CNJIJ",
      "name": "Jingjiang",
      "country": "CN",
      "lat": 32.033333,
      "lon": 120.283333
    },
    {
      "code": "CNJLY",
      "name": "Luoyuanwan",
      "country": "CN",
      "lat": 26.416667,
      "lon": 119.7
    },
    {
      "code": "CNJMN",
      "name": "Jiangmen",
      "country": "CN",
      "lat": 22.583333,
      "lon": 113.066667
    },
    {
      "code": "CNJNZ",
      "name": "Jinzhou Pt",
      "country": "CN",
      "lat": 41.116667,
      "lon": 121.15
    },
    {
      "code": "CNJTG",
      "name": "Jingtang Pt",
      "country": "CN",
      "lat": 39.208889,
      "lon": 119.001944
    },
    {
      "code": "CNJYG",
      "name": "Jieyang",
      "country": "CN",
      "lat": 23.55334,
      "lon": 116.36495
    },
    {
      "code": "CNJZK",
      "name": "Jingzhou Pt",
      "country": "CN",
      "lat": 30.3,
      "lon": 112.266667
    },
    {
      "code": "CNLGY",
      "name": "Longyan Pt",
      "country": "CN",
      "lat": 37.433333,
      "lon": 122.633333
    },
    {
      "code": "CNLIC",
      "name": "Licheng",
      "country": "CN",
      "lat": 36.67958,
      "lon": 117.05911
    },
    {
      "code": "CNLKU",
      "name": "Longkou Pt",
      "country": "CN",
      "lat": 37.65,
      "lon": 120.35
    },
    {
      "code": "CNLOH",
      "name": "Luohuang",
      "country": "CN",
      "lat": 29.3482,
      "lon": 106.431895
    },
    {
      "code": "CNLSN",
      "name": "Lanshan Pt",
      "country": "CN",
      "lat": 35.066667,
      "lon": 119.366667
    },
    {
      "code": "CNLUS",
      "name": "Lusi",
      "country": "CN",
      "lat": 32.05,
      "lon": 121.616667
    },
    {
      "code": "CNLYG",
      "name": "Lianyungang",
      "country": "CN",
      "lat": 34.716667,
      "lon": 119.433333
    },
    {
      "code": "CNLZO",
      "name": "Laizhou Pt",
      "country": "CN",
      "lat": 37.166667,
      "lon": 119.95
    },
    {
      "code": "CNMAJ",
      "name": "Majistan/Zhoushan",
      "country": "CN",
      "lat": 30.016667,
      "lon": 122.1
    },
    {
      "code": "CNMCH",
      "name": "Machong",
      "country": "CN",
      "lat": 23.033333,
      "lon": 113.566667
    },
    {
      "code": "CNMMI",
      "name": "Maoming",
      "country": "CN",
      "lat": 21.66182,
      "lon": 110.91783
    },
    {
      "code": "CNNBO",
      "name": "Ningbo",
      "country": "CN",
      "lat": 29.866667,
      "lon": 121.55
    },
    {
      "code": "CNNDE",
      "name": "Ningde",
      "country": "CN",
      "lat": 26.661667,
      "lon": 119.522778
    },
    {
      "code": "CNNJG",
      "name": "Nanjing Pt",
      "country": "CN",
      "lat": 32.168889,
      "lon": 118.95
    },
    {
      "code": "CNNJI",
      "name": "Nanjing",
      "country": "CN",
      "lat": 32.05,
      "lon": 118.766667
    },
    {
      "code": "CNNKL",
      "name": "Niuguling",
      "country": "CN",
      "lat": 22.28713,
      "lon": 113.08587
    },
    {
      "code": "CNNSA",
      "name": "Nansha Pt",
      "country": "CN",
      "lat": 22.75,
      "lon": 113.583333
    },
    {
      "code": "CNNTG",
      "name": "Nantong",
      "country": "CN",
      "lat": 32.016667,
      "lon": 120.85
    },
    {
      "code": "CNPAJ",
      "name": "Panjin",
      "country": "CN",
      "lat": 41.116667,
      "lon": 122.05
    },
    {
      "code": "CNPLI",
      "name": "Penglai Pt",
      "country": "CN",
      "lat": 37.8,
      "lon": 120.75
    },
    {
      "code": "CNPUT",
      "name": "Putian",
      "country": "CN",
      "lat": 24.433333,
      "lon": 119.016667
    },
    {
      "code": "CNQAW",
      "name": "Qianwan",
      "country": "CN",
      "lat": 36.05,
      "lon": 120.216667
    },
    {
      "code": "CNQDG",
      "name": "Qingdao Pt",
      "country": "CN",
      "lat": 36.0833,
      "lon": 120.317
    },
    {
      "code": "CNQIN",
      "name": "Qingdao",
      "country": "CN",
      "lat": 36.05,
      "lon": 120.316667
    },
    {
      "code": "CNQZH",
      "name": "Qinzhou",
      "country": "CN",
      "lat": 21.733333,
      "lon": 108.583333
    },
    {
      "code": "CNQZL",
      "name": "Quanzhou",
      "country": "CN",
      "lat": 24.933333,
      "lon": 118.6
    },
    {
      "code": "CNRDO",
      "name": "Rudong",
      "country": "CN",
      "lat": 31.433333,
      "lon": 119.483333
    },
    {
      "code": "CNRUG",
      "name": "Rugao",
      "country": "CN",
      "lat": 32.38521,
      "lon": 120.5634
    },
    {
      "code": "CNRZH",
      "name": "Rizhao",
      "country": "CN",
      "lat": 35.383333,
      "lon": 119.533333
    },
    {
      "code": "CNSDG",
      "name": "Shuidong Pt",
      "country": "CN",
      "lat": 21.516667,
      "lon": 111
    },
    {
      "code": "CNSGH",
      "name": "Shanghai",
      "country": "CN",
      "lat": 31.233333,
      "lon": 121.483333
    },
    {
      "code": "CNSHA",
      "name": "Shanghai Hongqiao International Apt",
      "country": "CN",
      "lat": 31.198056,
      "lon": 121.336389
    },
    {
      "code": "CNSHD",
      "name": "Shidao Pt",
      "country": "CN",
      "lat": 36.866667,
      "lon": 122.433333
    },
    {
      "code": "CNSHK",
      "name": "Shekou Pt",
      "country": "CN",
      "lat": 22.483333,
      "lon": 113.916667
    },
    {
      "code": "CNSHP",
      "name": "Qinhuangdao Pt",
      "country": "CN",
      "lat": 39.916667,
      "lon": 119.583333
    },
    {
      "code": "CNSNZ",
      "name": "Shenzhen",
      "country": "CN",
      "lat": 22.55,
      "lon": 114.116667
    },
    {
      "code": "CNSON",
      "name": "Songxia Pt",
      "country": "CN",
      "lat": 25.683333,
      "lon": 119.583333
    },
    {
      "code": "CNSTG",
      "name": "Shantou",
      "country": "CN",
      "lat": 23.416667,
      "lon": 116.766667
    },
    {
      "code": "CNSWE",
      "name": "Shanwei",
      "country": "CN",
      "lat": 22.783333,
      "lon": 115.35
    },
    {
      "code": "CNTAC",
      "name": "Taicang Pt",
      "country": "CN",
      "lat": 31.45,
      "lon": 121.1
    },
    {
      "code": "CNTAX",
      "name": "Taixing",
      "country": "CN",
      "lat": 32.166667,
      "lon": 120
    },
    {
      "code": "CNTAZ",
      "name": "Taizhou Pt",
      "country": "CN",
      "lat": 28.6856,
      "lon": 121.45
    },
    {
      "code": "CNTGS",
      "name": "Tangshan Pt",
      "country": "CN",
      "lat": 39.6,
      "lon": 118.183333
    },
    {
      "code": "CNTIS",
      "name": "Taishan",
      "country": "CN",
      "lat": 22.248611,
      "lon": 112.785
    },
    {
      "code": "CNTNJ",
      "name": "Tianjin",
      "country": "CN",
      "lat": 39.033333,
      "lon": 117.2
    },
    {
      "code": "CNTXG",
      "name": "Tianjin Xingang Pt",
      "country": "CN",
      "lat": 38.983333,
      "lon": 117.7
    },
    {
      "code": "CNWEF",
      "name": "Weifang",
      "country": "CN",
      "lat": 36.716667,
      "lon": 119.1
    },
    {
      "code": "CNWEI",
      "name": "Weihai",
      "country": "CN",
      "lat": 37.516667,
      "lon": 122.116667
    },
    {
      "code": "CNWNZ",
      "name": "Wenzhou",
      "country": "CN",
      "lat": 27.910572,
      "lon": 120.853465
    },
    {
      "code": "CNXAM",
      "name": "Xiamen",
      "country": "CN",
      "lat": 24.45,
      "lon": 118.1
    },
    {
      "code": "CNXMG",
      "name": "Xiamen Pt",
      "country": "CN",
      "lat": 24.35,
      "lon": 118.2
    },
    {
      "code": "CNXNA",
      "name": "Xinsha",
      "country": "CN",
      "lat": 22.983333,
      "lon": 113.533333
    },
    {
      "code": "CNXYG",
      "name": "Xiuyu Pt",
      "country": "CN",
      "lat": 25.233333,
      "lon": 118.95
    },
    {
      "code": "CNYAT",
      "name": "Yantai",
      "country": "CN",
      "lat": 37.466667,
      "lon": 121.383333
    },
    {
      "code": "CNYIK",
      "name": "Yinkou",
      "country": "CN",
      "lat": 40.65,
      "lon": 122.216667
    },
    {
      "code": "CNYJI",
      "name": "Yangjiang",
      "country": "CN",
      "lat": 21.833333,
      "lon": 111.966667
    },
    {
      "code": "CNYPG",
      "name": "Yangpu Pt",
      "country": "CN",
      "lat": 19.7,
      "lon": 109.2
    },
    {
      "code": "CNYSA",
      "name": "Yangshan",
      "country": "CN",
      "lat": 30.583333,
      "lon": 122.066667
    },
    {
      "code": "CNYUH",
      "name": "Yuhuan",
      "country": "CN",
      "lat": 28.133333,
      "lon": 121.233333
    },
    {
      "code": "CNYZH",
      "name": "Yangzhou",
      "country": "CN",
      "lat": 32.383333,
      "lon": 119.433333
    },
    {
      "code": "CNZHE",
      "name": "Zhenjiang",
      "country": "CN",
      "lat": 32.183333,
      "lon": 119.45
    },
    {
      "code": "CNZJG",
      "name": "Zhangjiagang",
      "country": "CN",
      "lat": 31.866667,
      "lon": 120.533333
    },
    {
      "code": "CNZNG",
      "name": "Zhanjiang Pt",
      "country": "CN",
      "lat": 21.083333,
      "lon": 110.5
    },
    {
      "code": "CNZOS",
      "name": "Zhoushan",
      "country": "CN",
      "lat": 30,
      "lon": 122.1
    },
    {
      "code": "CNZPU",
      "name": "Zhapu Pt",
      "country": "CN",
      "lat": 30.583333,
      "lon": 121.083333
    },
    {
      "code": "CNZUH",
      "name": "Zhuhai",
      "country": "CN",
      "lat": 22.283333,
      "lon": 113.566667
    },
    {
      "code": "CNZZU",
      "name": "Zhangzhou",
      "country": "CN",
      "lat": 24.516667,
      "lon": 117.65
    },
    {
      "code": "COADZ",
      "name": "San Andres Island",
      "country": "CO",
      "lat": 12.566667,
      "lon": -81.7
    },
    {
      "code": "COBAQ",
      "name": "Barranquilla",
      "country": "CO",
      "lat": 10.966667,
      "lon": -74.766667
    },
    {
      "code": "COBUN",
      "name": "Buenaventura",
      "country": "CO",
      "lat": 3.883333,
      "lon": -77.066667
    },
    {
      "code": "COCOV",
      "name": "Covenas Offshore Terminal",
      "country": "CO",
      "lat": 9.5,
      "lon": -75.733333
    },
    {
      "code": "COCTG",
      "name": "Cartagena",
      "country": "CO",
      "lat": 10.416667,
      "lon": -75.533333
    },
    {
      "code": "COMAM",
      "name": "Mamonal",
      "country": "CO",
      "lat": 10.316667,
      "lon": -75.5
    },
    {
      "code": "COPBO",
      "name": "Puerto Bolivar",
      "country": "CO",
      "lat": 12.255556,
      "lon": -71.966944
    },
    {
      "code": "COPNU",
      "name": "Pueblo Nuevo",
      "country": "CO",
      "lat": 8.5,
      "lon": -75.5
    },
    {
      "code": "COPOC",
      "name": "Pozos Colorados",
      "country": "CO",
      "lat": 11.15,
      "lon": -74.25
    },
    {
      "code": "CORCH",
      "name": "Riohacha",
      "country": "CO",
      "lat": 11.544167,
      "lon": -72.906944
    },
    {
      "code": "COSMR",
      "name": "Santa Marta",
      "country": "CO",
      "lat": 11.25,
      "lon": -74.216667
    },
    {
      "code": "COTCO",
      "name": "Tumaco",
      "country": "CO",
      "lat": 1.816667,
      "lon": -78.75
    },
    {
      "code": "COTLU",
      "name": "Tolu",
      "country": "CO",
      "lat": 9.533333,
      "lon": -75.583333
    },
    {
      "code": "CRCAL",
      "name": "Caldera",
      "country": "CR",
      "lat": 9.95,
      "lon": -84.716667
    },
    {
      "code": "CRLIO",
      "name": "Puerto Limon",
      "country": "CR",
      "lat": 10,
      "lon": -83.033333
    },
    {
      "code": "CRPMN",
      "name": "Puerto Moin",
      "country": "CR",
      "lat": 10,
      "lon": -83.083333
    },
    {
      "code": "CUHAV",
      "name": "La Habana",
      "country": "CU",
      "lat": 23.116667,
      "lon": -82.35
    },
    {
      "code": "CVMIN",
      "name": "Mindelo",
      "country": "CV",
      "lat": 16.883333,
      "lon": -25
    },
    {
      "code": "CVRAI",
      "name": "Praia",
      "country": "CV",
      "lat": 14.916667,
      "lon": -23.516667
    },
    {
      "code": "CVVXE",
      "name": "Sao Vicente",
      "country": "CV",
      "lat": 16.85,
      "lon": -24.966667
    },
    {
      "code": "CWCUR",
      "name": "Curacao",
      "country": "CW",
      "lat": 12.166667,
      "lon": -69
    },
    {
      "code": "CWWIL",
      "name": "Willemstad",
      "country": "CW",
      "lat": 12.1,
      "lon": -68.916667
    },
    {
      "code": "CYAKT",
      "name": "Akrotiri",
      "country": "CY",
      "lat": 34.6,
      "lon": 32.95
    },
    {
      "code": "CYLCA",
      "name": "Larnaca",
      "country": "CY",
      "lat": 34.916667,
      "lon": 33.616667
    },
    {
      "code": "CYLMS",
      "name": "Limassol",
      "country": "CY",
      "lat": 34.683333,
      "lon": 33.05
    },
    {
      "code": "CYMOI",
      "name": "Moni",
      "country": "CY",
      "lat": 34.733333,
      "lon": 33.2
    },
    {
      "code": "CYVAS",
      "name": "Vasilikos",
      "country": "CY",
      "lat": 34.716667,
      "lon": 33.316667
    },
    {
      "code": "DEBBI",
      "name": "Bietigheim-Bissingen",
      "country": "DE",
      "lat": 48.949444,
      "lon": 9.136111
    },
    {
      "code": "DEBKE",
      "name": "Brake",
      "country": "DE",
      "lat": 53.333333,
      "lon": 8.483333
    },
    {
      "code": "DEBRB",
      "name": "Brunsbuttel",
      "country": "DE",
      "lat": 53.891667,
      "lon": 9.158334
    },
    {
      "code": "DEBRE",
      "name": "Bremen",
      "country": "DE",
      "lat": 53.133333,
      "lon": 8.766667
    },
    {
      "code": "DEBRV",
      "name": "Bremerhaven",
      "country": "DE",
      "lat": 53.533333,
      "lon": 8.6
    },
    {
      "code": "DEBXN",
      "name": "Blexen",
      "country": "DE",
      "lat": 53.533333,
      "lon": 8.533333
    },
    {
      "code": "DECGN",
      "name": "Koln",
      "country": "DE",
      "lat": 50.95,
      "lon": 6.933333
    },
    {
      "code": "DECUX",
      "name": "Cuxhaven",
      "country": "DE",
      "lat": 53.883333,
      "lon": 8.7
    },
    {
      "code": "DEDMG",
      "name": "Dormagen",
      "country": "DE",
      "lat": 51.083333,
      "lon": 6.816667
    },
    {
      "code": "DEDUI",
      "name": "Duisburg",
      "country": "DE",
      "lat": 51.466667,
      "lon": 6.75
    },
    {
      "code": "DEDUS",
      "name": "Dusseldorf",
      "country": "DE",
      "lat": 51.233333,
      "lon": 6.783333
    },
    {
      "code": "DEEME",
      "name": "Emden",
      "country": "DE",
      "lat": 53.366667,
      "lon": 7.216667
    },
    {
      "code": "DEGDO",
      "name": "Godorf",
      "country": "DE",
      "lat": 50.85,
      "lon": 6.966667
    },
    {
      "code": "DEGEK",
      "name": "Gelsenkirchen",
      "country": "DE",
      "lat": 51.516667,
      "lon": 7.116667
    },
    {
      "code": "DEHAJ",
      "name": "Hannover",
      "country": "DE",
      "lat": 52.366667,
      "lon": 9.716667
    },
    {
      "code": "DEHAM",
      "name": "Hamburg",
      "country": "DE",
      "lat": 53.516667,
      "lon": 9.933333
    },
    {
      "code": "DEKDU",
      "name": "Krefeld-Uerdingen",
      "country": "DE",
      "lat": 51.333333,
      "lon": 6.566667
    },
    {
      "code": "DELBC",
      "name": "Lubeck",
      "country": "DE",
      "lat": 53.883333,
      "lon": 10.7
    },
    {
      "code": "DELBM",
      "name": "Lubmin",
      "country": "DE",
      "lat": 54.133333,
      "lon": 13.6
    },
    {
      "code": "DEMHG",
      "name": "Mannheim",
      "country": "DE",
      "lat": 49.483333,
      "lon": 8.45
    },
    {
      "code": "DEMLO",
      "name": "Marlow",
      "country": "DE",
      "lat": 54.533333,
      "lon": 13.55
    },
    {
      "code": "DEMSR",
      "name": "Munster",
      "country": "DE",
      "lat": 51.966667,
      "lon": 7.633333
    },
    {
      "code": "DENHA",
      "name": "Nordenham",
      "country": "DE",
      "lat": 53.5,
      "lon": 8.483333
    },
    {
      "code": "DERSK",
      "name": "Rostock",
      "country": "DE",
      "lat": 54.083333,
      "lon": 12.133333
    },
    {
      "code": "DESAS",
      "name": "Sassnitz",
      "country": "DE",
      "lat": 54.516667,
      "lon": 13.65
    },
    {
      "code": "DESTA",
      "name": "Stade",
      "country": "DE",
      "lat": 53.6,
      "lon": 9.483333
    },
    {
      "code": "DEWOL",
      "name": "Wolgast",
      "country": "DE",
      "lat": 54.05,
      "lon": 13.783333
    },
    {
      "code": "DEWVN",
      "name": "Wilhelmshaven",
      "country": "DE",
      "lat": 53.516667,
      "lon": 8.133333
    },
    {
      "code": "DJJIB",
      "name": "Djibouti",
      "country": "DJ",
      "lat": 11.6,
      "lon": 43.133333
    },
    {
      "code": "DKAAB",
      "name": "Abenra",
      "country": "DK",
      "lat": 55.033333,
      "lon": 9.433333
    },
    {
      "code": "DKAAL",
      "name": "Aalborg",
      "country": "DK",
      "lat": 57.05,
      "lon": 9.933333
    },
    {
      "code": "DKAAR",
      "name": "Aarhus",
      "country": "DK",
      "lat": 56.15,
      "lon": 10.216667
    },
    {
      "code": "DKCPH",
      "name": "Kobenhavn",
      "country": "DK",
      "lat": 55.666667,
      "lon": 12.583333
    },
    {
      "code": "DKEBJ",
      "name": "Esbjerg",
      "country": "DK",
      "lat": 55.466667,
      "lon": 8.45
    },
    {
      "code": "DKFDH",
      "name": "Frederikshavn",
      "country": "DK",
      "lat": 57.433333,
      "lon": 10.55
    },
    {
      "code": "DKFRC",
      "name": "Fredericia",
      "country": "DK",
      "lat": 55.566667,
      "lon": 9.766667
    },
    {
      "code": "DKGFH",
      "name": "Gulfhavn",
      "country": "DK",
      "lat": 55.2,
      "lon": 11.266667
    },
    {
      "code": "DKGRE",
      "name": "Grenaa",
      "country": "DK",
      "lat": 56.416667,
      "lon": 10.933333
    },
    {
      "code": "DKKAL",
      "name": "Kalundborg",
      "country": "DK",
      "lat": 55.683333,
      "lon": 11.1
    },
    {
      "code": "DKKOL",
      "name": "Kolding",
      "country": "DK",
      "lat": 55.483333,
      "lon": 9.5
    },
    {
      "code": "DKNBG",
      "name": "Nyborg",
      "country": "DK",
      "lat": 55.316667,
      "lon": 10.8
    },
    {
      "code": "DKODE",
      "name": "Odense",
      "country": "DK",
      "lat": 55.416667,
      "lon": 10.383333
    },
    {
      "code": "DKRNN",
      "name": "Ronne",
      "country": "DK",
      "lat": 55.1,
      "lon": 14.7
    },
    {
      "code": "DKSIT",
      "name": "Stigsnaes Inter Terminal",
      "country": "DK",
      "lat": 55.2,
      "lon": 11.233333
    },
    {
      "code": "DKSKA",
      "name": "Skagen",
      "country": "DK",
      "lat": 57.716667,
      "lon": 10.6
    },
    {
      "code": "DKTYB",
      "name": "Tyboron",
      "country": "DK",
      "lat": 56.7,
      "lon": 8.216667
    },
    {
      "code": "DOBCC",
      "name": "Boca Chica",
      "country": "DO",
      "lat": 18.433333,
      "lon": -69.633333
    },
    {
      "code": "DOHAI",
      "name": "Rio Haina",
      "country": "DO",
      "lat": 18.414169,
      "lon": -70.017743
    },
    {
      "code": "DOMAN",
      "name": "Manzanillo",
      "country": "DO",
      "lat": 19.7,
      "lon": -71.75
    },
    {
      "code": "DOPOP",
      "name": "Puerto Plata",
      "country": "DO",
      "lat": 19.8,
      "lon": -70.7
    },
    {
      "code": "DOSPM",
      "name": "San Pedro de Macoris",
      "country": "DO",
      "lat": 18.45,
      "lon": -69.3
    },
    {
      "code": "DZAAE",
      "name": "Annaba (ex Bone)",
      "country": "DZ",
      "lat": 36.916667,
      "lon": 7.766667
    },
    {
      "code": "DZALG",
      "name": "Alger (Algiers)",
      "country": "DZ",
      "lat": 36.75,
      "lon": 3.05
    },
    {
      "code": "DZAZW",
      "name": "Arzew",
      "country": "DZ",
      "lat": 35.866667,
      "lon": -0.316667
    },
    {
      "code": "DZBHA",
      "name": "Bethioua",
      "country": "DZ",
      "lat": 35.8,
      "lon": -0.266667
    },
    {
      "code": "DZBJA",
      "name": "Bejaia (ex Bougie)",
      "country": "DZ",
      "lat": 36.75,
      "lon": 5.083333
    },
    {
      "code": "DZDJE",
      "name": "Djen-Djen",
      "country": "DZ",
      "lat": 36.816667,
      "lon": 5.883333
    },
    {
      "code": "DZGHZ",
      "name": "Ghazaouet",
      "country": "DZ",
      "lat": 35.1,
      "lon": -1.85
    },
    {
      "code": "DZORN",
      "name": "Oran",
      "country": "DZ",
      "lat": 35.7,
      "lon": -0.633333
    },
    {
      "code": "DZSKI",
      "name": "Skikda (ex Philippeville)",
      "country": "DZ",
      "lat": 36.883333,
      "lon": 6.916667
    },
    {
      "code": "ECESM",
      "name": "Esmeraldas",
      "country": "EC",
      "lat": 0.983333,
      "lon": -79.7
    },
    {
      "code": "ECGYE",
      "name": "Guayaquil",
      "country": "EC",
      "lat": -2.166667,
      "lon": -79.9
    },
    {
      "code": "ECLLD",
      "name": "La Libertad",
      "country": "EC",
      "lat": -2.216667,
      "lon": -80.916667
    },
    {
      "code": "ECMEC",
      "name": "Manta",
      "country": "EC",
      "lat": -0.95,
      "lon": -80.733333
    },
    {
      "code": "ECMTV",
      "name": "Monteverde",
      "country": "EC",
      "lat": -2.033333,
      "lon": -80.716667
    },
    {
      "code": "EEMUG",
      "name": "Muuga",
      "country": "EE",
      "lat": 59.5,
      "lon": 24.966667
    },
    {
      "code": "EEPLA",
      "name": "Paldiski",
      "country": "EE",
      "lat": 59.35,
      "lon": 24.05
    },
    {
      "code": "EEPLS",
      "name": "Paldiski Lounasadam",
      "country": "EE",
      "lat": 59.333333,
      "lon": 24.083333
    },
    {
      "code": "EESLM",
      "name": "Sillamae",
      "country": "EE",
      "lat": 59.416667,
      "lon": 27.733333
    },
    {
      "code": "EETLL",
      "name": "Tallinn",
      "country": "EE",
      "lat": 59.433333,
      "lon": 24.733333
    },
    {
      "code": "EGADA",
      "name": "Al Adabiyah",
      "country": "EG",
      "lat": 29.866667,
      "lon": 32.466667
    },
    {
      "code": "EGAIS",
      "name": "Ain Sukhna",
      "country": "EG",
      "lat": 29.645,
      "lon": 32.334444
    },
    {
      "code": "EGAKI",
      "name": "Abu Kir",
      "country": "EG",
      "lat": 31.316667,
      "lon": 30.066667
    },
    {
      "code": "EGALY",
      "name": "El Iskandariya (Alexandria)",
      "country": "EG",
      "lat": 31.183333,
      "lon": 29.916667
    },
    {
      "code": "EGDAM",
      "name": "Dumyat (Damietta)",
      "country": "EG",
      "lat": 31.416667,
      "lon": 31.816667
    },
    {
      "code": "EGEDK",
      "name": "El Dekheila",
      "country": "EG",
      "lat": 31.1419,
      "lon": 29.7935
    },
    {
      "code": "EGPSD",
      "name": "Port Said",
      "country": "EG",
      "lat": 31.266667,
      "lon": 32.3
    },
    {
      "code": "EGPSE",
      "name": "Port Said East",
      "country": "EG",
      "lat": 31.216667,
      "lon": 32.35
    },
    {
      "code": "EGSKT",
      "name": "Sidi Kerir Terminal",
      "country": "EG",
      "lat": 31.056714,
      "lon": 29.670447
    },
    {
      "code": "EGSUZ",
      "name": "As Suways (Suez)",
      "country": "EG",
      "lat": 29.966667,
      "lon": 32.516667
    },
    {
      "code": "ERMSW",
      "name": "Massawa (Mitsiwa)",
      "country": "ER",
      "lat": 15.6,
      "lon": 39.45
    },
    {
      "code": "ESACE",
      "name": "Lanzarote",
      "country": "ES",
      "lat": 28.966667,
      "lon": -13.533333
    },
    {
      "code": "ESAGP",
      "name": "Malaga",
      "country": "ES",
      "lat": 36.716667,
      "lon": -4.416667
    },
    {
      "code": "ESALC",
      "name": "Alicante",
      "country": "ES",
      "lat": 38.333333,
      "lon": -0.483333
    },
    {
      "code": "ESALG",
      "name": "Algeciras",
      "country": "ES",
      "lat": 36.133333,
      "lon": -5.433333
    },
    {
      "code": "ESALK",
      "name": "Alcudia",
      "country": "ES",
      "lat": 39.866667,
      "lon": 3.116667
    },
    {
      "code": "ESAVS",
      "name": "Aviles",
      "country": "ES",
      "lat": 43.6,
      "lon": -5.933333
    },
    {
      "code": "ESBCN",
      "name": "Barcelona",
      "country": "ES",
      "lat": 41.35,
      "lon": 2.166667
    },
    {
      "code": "ESBIO",
      "name": "Bilbao",
      "country": "ES",
      "lat": 43.25,
      "lon": -2.966667
    },
    {
      "code": "ESCAD",
      "name": "Cadiz",
      "country": "ES",
      "lat": 36.533333,
      "lon": -6.3
    },
    {
      "code": "ESCAR",
      "name": "Cartagena",
      "country": "ES",
      "lat": 37.6,
      "lon": -0.983333
    },
    {
      "code": "ESCAS",
      "name": "Castellon de la Plana",
      "country": "ES",
      "lat": 39.983333,
      "lon": -0.033333
    },
    {
      "code": "ESCCN",
      "name": "Corcubion",
      "country": "ES",
      "lat": 42.95,
      "lon": -9.183333
    },
    {
      "code": "ESCEU",
      "name": "Ceuta",
      "country": "ES",
      "lat": 35.9,
      "lon": -5.316667
    },
    {
      "code": "ESCRS",
      "name": "Carboneras",
      "country": "ES",
      "lat": 36.983333,
      "lon": -1.883333
    },
    {
      "code": "ESFRO",
      "name": "Ferrol",
      "country": "ES",
      "lat": 43.483333,
      "lon": -8.25
    },
    {
      "code": "ESFUE",
      "name": "Puerto del Rosario-Fuerteventura",
      "country": "ES",
      "lat": 28.5,
      "lon": -13.85
    },
    {
      "code": "ESGAR",
      "name": "Garrucha",
      "country": "ES",
      "lat": 37.183333,
      "lon": -1.816667
    },
    {
      "code": "ESGIJ",
      "name": "Gijon",
      "country": "ES",
      "lat": 43.533333,
      "lon": -5.666667
    },
    {
      "code": "ESHUV",
      "name": "Huelva",
      "country": "ES",
      "lat": 37.25,
      "lon": -6.95
    },
    {
      "code": "ESIBZ",
      "name": "Ibiza",
      "country": "ES",
      "lat": 38.9,
      "lon": 1.433333
    },
    {
      "code": "ESLCG",
      "name": "La Coruna (A Coruna)",
      "country": "ES",
      "lat": 43.366667,
      "lon": -8.383333
    },
    {
      "code": "ESLEI",
      "name": "Almeria",
      "country": "ES",
      "lat": 36.833333,
      "lon": -2.45
    },
    {
      "code": "ESLPA",
      "name": "Las Palmas de Gran Canaria",
      "country": "ES",
      "lat": 28.1,
      "lon": -15.416667
    },
    {
      "code": "ESMAH",
      "name": "Mahon, Menorca",
      "country": "ES",
      "lat": 39.883333,
      "lon": 4.25
    },
    {
      "code": "ESMGR",
      "name": "Mugardos",
      "country": "ES",
      "lat": 43.466667,
      "lon": -8.25
    },
    {
      "code": "ESMOT",
      "name": "Motril",
      "country": "ES",
      "lat": 36.75,
      "lon": -3.516667
    },
    {
      "code": "ESMPG",
      "name": "Marin, Pontevedra",
      "country": "ES",
      "lat": 42.4,
      "lon": -8.7
    },
    {
      "code": "ESMRJ",
      "name": "Madridejos",
      "country": "ES",
      "lat": 39.466667,
      "lon": -3.533333
    },
    {
      "code": "ESPAS",
      "name": "Pasajes",
      "country": "ES",
      "lat": 43.333333,
      "lon": -1.933333
    },
    {
      "code": "ESPMI",
      "name": "Palma de Mallorca",
      "country": "ES",
      "lat": 39.566667,
      "lon": 2.633333
    },
    {
      "code": "ESSAG",
      "name": "Sagunto",
      "country": "ES",
      "lat": 39.683333,
      "lon": -0.266667
    },
    {
      "code": "ESSAT",
      "name": "Salinetas",
      "country": "ES",
      "lat": 27.979511,
      "lon": -15.377629
    },
    {
      "code": "ESSCI",
      "name": "San Ciprian",
      "country": "ES",
      "lat": 43.707141,
      "lon": -7.462028
    },
    {
      "code": "ESSCT",
      "name": "Santa Cruz de Tenerife",
      "country": "ES",
      "lat": 28.466667,
      "lon": -16.233333
    },
    {
      "code": "ESSDR",
      "name": "Santander",
      "country": "ES",
      "lat": 43.466667,
      "lon": -3.783333
    },
    {
      "code": "ESSPC",
      "name": "Santa Cruz de La Palma",
      "country": "ES",
      "lat": 28.683333,
      "lon": -17.75
    },
    {
      "code": "ESSVQ",
      "name": "Sevilla",
      "country": "ES",
      "lat": 37.366667,
      "lon": -6
    },
    {
      "code": "ESTAR",
      "name": "Tarragona",
      "country": "ES",
      "lat": 41.1,
      "lon": 1.233333
    },
    {
      "code": "ESVGO",
      "name": "Vigo",
      "country": "ES",
      "lat": 42.233333,
      "lon": -8.716667
    },
    {
      "code": "ESVIL",
      "name": "Villagarcia de Arosa",
      "country": "ES",
      "lat": 42.6,
      "lon": -8.75
    },
    {
      "code": "ESVLC",
      "name": "Valencia",
      "country": "ES",
      "lat": 39.45,
      "lon": -0.316667
    },
    {
      "code": "FIHEL",
      "name": "Helsinki",
      "country": "FI",
      "lat": 60.166667,
      "lon": 24.933333
    },
    {
      "code": "FIHMN",
      "name": "Hamina (Fredrikshamn)",
      "country": "FI",
      "lat": 60.566667,
      "lon": 27.2
    },
    {
      "code": "FIINK",
      "name": "Inkoo (Inga)",
      "country": "FI",
      "lat": 60.016667,
      "lon": 23.916667
    },
    {
      "code": "FIKAS",
      "name": "Kasko (Kaskinen)",
      "country": "FI",
      "lat": 60.616667,
      "lon": 21.883333
    },
    {
      "code": "FIKEM",
      "name": "Kemi/Tornio (Kemi/Tornea)",
      "country": "FI",
      "lat": 65.733333,
      "lon": 24.566667
    },
    {
      "code": "FIKOK",
      "name": "Kokkola (Karleby)",
      "country": "FI",
      "lat": 63.833333,
      "lon": 23.116667
    },
    {
      "code": "FIKTK",
      "name": "Kotka",
      "country": "FI",
      "lat": 60.466667,
      "lon": 26.916667
    },
    {
      "code": "FINLI",
      "name": "Nadendal (Naantali)",
      "country": "FI",
      "lat": 60.45,
      "lon": 22.033333
    },
    {
      "code": "FIOUL",
      "name": "Uleaborg (Oulu)",
      "country": "FI",
      "lat": 65.016667,
      "lon": 25.466667
    },
    {
      "code": "FIPOR",
      "name": "Pori (Bjorneborg)",
      "country": "FI",
      "lat": 61.483333,
      "lon": 21.8
    },
    {
      "code": "FIPRS",
      "name": "Pietarsaari (Jakobstad)",
      "country": "FI",
      "lat": 63.683333,
      "lon": 22.783333
    },
    {
      "code": "FIPRV",
      "name": "Porvoo (Borga)",
      "country": "FI",
      "lat": 60.4,
      "lon": 25.666667
    },
    {
      "code": "FIRAA",
      "name": "Raahe (Brahestad)",
      "country": "FI",
      "lat": 64.683333,
      "lon": 24.483333
    },
    {
      "code": "FIRAU",
      "name": "Raumo (Rauma)",
      "country": "FI",
      "lat": 61.133333,
      "lon": 21.5
    },
    {
      "code": "FISKV",
      "name": "Skoldvik (Kilpilahti)",
      "country": "FI",
      "lat": 60.3,
      "lon": 25.55
    },
    {
      "code": "FISUL",
      "name": "Sunila",
      "country": "FI",
      "lat": 60.483333,
      "lon": 26.95
    },
    {
      "code": "FIUKI",
      "name": "Uusikaupunki (Nystad)",
      "country": "FI",
      "lat": 60.8,
      "lon": 21.416667
    },
    {
      "code": "FIVAA",
      "name": "Vasa (Vaasa)",
      "country": "FI",
      "lat": 63.1,
      "lon": 21.6
    },
    {
      "code": "FJLTK",
      "name": "Lautoka",
      "country": "FJ",
      "lat": -17.616667,
      "lon": 177.45
    },
    {
      "code": "FJMAL",
      "name": "Malau (Labasa)",
      "country": "FJ",
      "lat": -16.366667,
      "lon": 179.383333
    },
    {
      "code": "FJSUV",
      "name": "Suva",
      "country": "FJ",
      "lat": -18.133333,
      "lon": 178.45
    },
    {
      "code": "FJVUD",
      "name": "Vuda",
      "country": "FJ",
      "lat": -17.6,
      "lon": 177.5
    },
    {
      "code": "FOFUG",
      "name": "Fuglafjordur",
      "country": "FO",
      "lat": 62.25,
      "lon": -6.8
    },
    {
      "code": "FOTHO",
      "name": "Thorshavn",
      "country": "FO",
      "lat": 62.016667,
      "lon": -6.766667
    },
    {
      "code": "FRAJA",
      "name": "Ajaccio",
      "country": "FR",
      "lat": 41.933333,
      "lon": 8.733333
    },
    {
      "code": "FRAMS",
      "name": "Ambes",
      "country": "FR",
      "lat": 45,
      "lon": -0.533333
    },
    {
      "code": "FRBAY",
      "name": "Bayonne",
      "country": "FR",
      "lat": 43.5,
      "lon": -1.483333
    },
    {
      "code": "FRBES",
      "name": "Brest",
      "country": "FR",
      "lat": 48.4,
      "lon": -4.483333
    },
    {
      "code": "FRBIA",
      "name": "Bastia",
      "country": "FR",
      "lat": 42.7,
      "lon": 9.45
    },
    {
      "code": "FRBOD",
      "name": "Bordeaux",
      "country": "FR",
      "lat": 44.833333,
      "lon": -0.583333
    },
    {
      "code": "FRBYE",
      "name": "Blaye",
      "country": "FR",
      "lat": 45.133333,
      "lon": -0.666667
    },
    {
      "code": "FRCER",
      "name": "Cherbourg-en-Cotentin",
      "country": "FR",
      "lat": 49.633333,
      "lon": -1.616667
    },
    {
      "code": "FRCFR",
      "name": "Caen",
      "country": "FR",
      "lat": 49.183333,
      "lon": -0.366667
    },
    {
      "code": "FRCOZ",
      "name": "Caronte",
      "country": "FR",
      "lat": 43.4,
      "lon": 5.016667
    },
    {
      "code": "FRCQF",
      "name": "Calais",
      "country": "FR",
      "lat": 50.95,
      "lon": 1.85
    },
    {
      "code": "FRDKK",
      "name": "Dunkerque",
      "country": "FR",
      "lat": 51.033333,
      "lon": 2.383333
    },
    {
      "code": "FRDON",
      "name": "Donges",
      "country": "FR",
      "lat": 47.3,
      "lon": -2.066667
    },
    {
      "code": "FRDPE",
      "name": "Dieppe",
      "country": "FR",
      "lat": 49.916667,
      "lon": 1.083333
    },
    {
      "code": "FRDRZ",
      "name": "Douarnenez",
      "country": "FR",
      "lat": 48.1,
      "lon": -4.333333
    },
    {
      "code": "FRETB",
      "name": "Berre-l'Etang",
      "country": "FR",
      "lat": 43.466667,
      "lon": 5.166667
    },
    {
      "code": "FRFEC",
      "name": "Fecamp",
      "country": "FR",
      "lat": 49.75,
      "lon": 0.383333
    },
    {
      "code": "FRFOS",
      "name": "Fos-sur-Mer",
      "country": "FR",
      "lat": 43.433333,
      "lon": 4.933333
    },
    {
      "code": "FRGLO",
      "name": "Gonfreville-l'Orcher",
      "country": "FR",
      "lat": 49.5,
      "lon": 0.233333
    },
    {
      "code": "FRLAV",
      "name": "Lavera",
      "country": "FR",
      "lat": 43.383333,
      "lon": 5.033333
    },
    {
      "code": "FRLEH",
      "name": "Le Havre",
      "country": "FR",
      "lat": 49.5,
      "lon": 0.1
    },
    {
      "code": "FRLPE",
      "name": "la Pallice",
      "country": "FR",
      "lat": 46.166667,
      "lon": -1.216667
    },
    {
      "code": "FRLRH",
      "name": "La Rochelle",
      "country": "FR",
      "lat": 46.166667,
      "lon": -1.15
    },
    {
      "code": "FRLRT",
      "name": "Lorient",
      "country": "FR",
      "lat": 47.75,
      "lon": -3.366667
    },
    {
      "code": "FRMRS",
      "name": "Marseille",
      "country": "FR",
      "lat": 43.3,
      "lon": 5.4
    },
    {
      "code": "FRMTX",
      "name": "Montoir-de-Bretagne",
      "country": "FR",
      "lat": 47.333333,
      "lon": -2.15
    },
    {
      "code": "FRNOU",
      "name": "Port-la-Nouvelle",
      "country": "FR",
      "lat": 43.016667,
      "lon": 3.05
    },
    {
      "code": "FRNTE",
      "name": "Nantes",
      "country": "FR",
      "lat": 47.216667,
      "lon": -1.55
    },
    {
      "code": "FRPAP",
      "name": "Pauillac",
      "country": "FR",
      "lat": 45.2,
      "lon": -0.75
    },
    {
      "code": "FRPDB",
      "name": "Port-de-Bouc",
      "country": "FR",
      "lat": 43.4,
      "lon": 4.983333
    },
    {
      "code": "FRPJE",
      "name": "Port-Jerome",
      "country": "FR",
      "lat": 49.466667,
      "lon": 0.533333
    },
    {
      "code": "FRSET",
      "name": "Sete",
      "country": "FR",
      "lat": 43.4,
      "lon": 3.7
    },
    {
      "code": "FRSML",
      "name": "Saint-Malo",
      "country": "FR",
      "lat": 48.65,
      "lon": -2.016667
    },
    {
      "code": "FRSNR",
      "name": "Saint-Nazaire",
      "country": "FR",
      "lat": 47.283333,
      "lon": -2.2
    },
    {
      "code": "FRURO",
      "name": "Rouen",
      "country": "FR",
      "lat": 49.45,
      "lon": 1.1
    },
    {
      "code": "GALBV",
      "name": "Libreville",
      "country": "GA",
      "lat": 0.383333,
      "lon": 9.45
    },
    {
      "code": "GAOWE",
      "name": "Owendo",
      "country": "GA",
      "lat": 0.283333,
      "lon": 9.5
    },
    {
      "code": "GAPOG",
      "name": "Port Gentil",
      "country": "GA",
      "lat": -0.7,
      "lon": 8.8
    },
    {
      "code": "GBABD",
      "name": "Aberdeen",
      "country": "GB",
      "lat": 57.133333,
      "lon": -2.1
    },
    {
      "code": "GBAVO",
      "name": "Avonmouth",
      "country": "GB",
      "lat": 51.5,
      "lon": -2.683333
    },
    {
      "code": "GBBAD",
      "name": "Barry Dock",
      "country": "GB",
      "lat": 51.383333,
      "lon": -3.25
    },
    {
      "code": "GBBEL",
      "name": "Belfast",
      "country": "GB",
      "lat": 54.983333,
      "lon": -5.916667
    },
    {
      "code": "GBBFB",
      "name": "Braefoot Bay",
      "country": "GB",
      "lat": 56.05,
      "lon": -3.316667
    },
    {
      "code": "GBBHK",
      "name": "Bromborough",
      "country": "GB",
      "lat": 53.333333,
      "lon": -2.983333
    },
    {
      "code": "GBBIF",
      "name": "Barrow in Furness",
      "country": "GB",
      "lat": 54.116667,
      "lon": -3.233333
    },
    {
      "code": "GBBLY",
      "name": "Blyth",
      "country": "GB",
      "lat": 55.116667,
      "lon": -1.5
    },
    {
      "code": "GBBRK",
      "name": "Birkenhead",
      "country": "GB",
      "lat": 53.4,
      "lon": -3.033333
    },
    {
      "code": "GBBRS",
      "name": "Bristol",
      "country": "GB",
      "lat": 51.45,
      "lon": -2.583333
    },
    {
      "code": "GBCAN",
      "name": "Canvey Island",
      "country": "GB",
      "lat": 51.516667,
      "lon": 0.566667
    },
    {
      "code": "GBCDF",
      "name": "Cardiff",
      "country": "GB",
      "lat": 51.5,
      "lon": -3.2
    },
    {
      "code": "GBCLY",
      "name": "Clydebank",
      "country": "GB",
      "lat": 55.9,
      "lon": -4.4
    },
    {
      "code": "GBCRT",
      "name": "Carrington",
      "country": "GB",
      "lat": 53.433333,
      "lon": -2.383333
    },
    {
      "code": "GBDAG",
      "name": "Dagenham",
      "country": "GB",
      "lat": 51.55,
      "lon": 0.166667
    },
    {
      "code": "GBDUN",
      "name": "Dundee",
      "country": "GB",
      "lat": 56.5,
      "lon": -2.966667
    },
    {
      "code": "GBDVR",
      "name": "Dover",
      "country": "GB",
      "lat": 51.116667,
      "lon": 1.333333
    },
    {
      "code": "GBEAM",
      "name": "Eastham",
      "country": "GB",
      "lat": 53.3,
      "lon": -2.966667
    },
    {
      "code": "GBELL",
      "name": "Ellesmere Port",
      "country": "GB",
      "lat": 53.279,
      "lon": -2.897
    },
    {
      "code": "GBFAL",
      "name": "Falmouth",
      "country": "GB",
      "lat": 50.15,
      "lon": -5.066667
    },
    {
      "code": "GBFAW",
      "name": "Fawley",
      "country": "GB",
      "lat": 50.816667,
      "lon": -1.333333
    },
    {
      "code": "GBFNT",
      "name": "Finnart",
      "country": "GB",
      "lat": 56.666667,
      "lon": -4.416667
    },
    {
      "code": "GBFXT",
      "name": "Felixstowe",
      "country": "GB",
      "lat": 51.95,
      "lon": 1.316667
    },
    {
      "code": "GBGLD",
      "name": "Glasson Dock",
      "country": "GB",
      "lat": 53.983333,
      "lon": -2.85
    },
    {
      "code": "GBGLW",
      "name": "Glasgow",
      "country": "GB",
      "lat": 55.833333,
      "lon": -4.25
    },
    {
      "code": "GBGRG",
      "name": "Grangemouth",
      "country": "GB",
      "lat": 56,
      "lon": -3.716667
    },
    {
      "code": "GBGSY",
      "name": "Grimsby",
      "country": "GB",
      "lat": 53.583333,
      "lon": -0.066667
    },
    {
      "code": "GBGTY",
      "name": "Great Yarmouth",
      "country": "GB",
      "lat": 52.616667,
      "lon": 1.733333
    },
    {
      "code": "GBHAM",
      "name": "Hamble",
      "country": "GB",
      "lat": 50.85966,
      "lon": -1.32432
    },
    {
      "code": "GBHPT",
      "name": "Hound Point",
      "country": "GB",
      "lat": 56.033333,
      "lon": -3.3
    },
    {
      "code": "GBHRW",
      "name": "Harwich",
      "country": "GB",
      "lat": 51.95,
      "lon": 1.283333
    },
    {
      "code": "GBHUL",
      "name": "Hull",
      "country": "GB",
      "lat": 53.733333,
      "lon": -0.316667
    },
    {
      "code": "GBIMM",
      "name": "Immingham",
      "country": "GB",
      "lat": 53.6,
      "lon": -0.216667
    },
    {
      "code": "GBINV",
      "name": "Inverness",
      "country": "GB",
      "lat": 57.483333,
      "lon": -4.216667
    },
    {
      "code": "GBIOG",
      "name": "Isle of Grain",
      "country": "GB",
      "lat": 51.45,
      "lon": 0.7
    },
    {
      "code": "GBIVG",
      "name": "Invergordon",
      "country": "GB",
      "lat": 57.7,
      "lon": -4.166667
    },
    {
      "code": "GBLAR",
      "name": "Larne",
      "country": "GB",
      "lat": 54.85,
      "lon": -5.8
    },
    {
      "code": "GBLDY",
      "name": "Londonderry",
      "country": "GB",
      "lat": 55,
      "lon": -7.316667
    },
    {
      "code": "GBLER",
      "name": "Lerwick",
      "country": "GB",
      "lat": 60.15,
      "lon": -1.15
    },
    {
      "code": "GBLHS",
      "name": "Loch Striven",
      "country": "GB",
      "lat": 55.933333,
      "lon": -5.066667
    },
    {
      "code": "GBLIV",
      "name": "Liverpool",
      "country": "GB",
      "lat": 53.416667,
      "lon": -3
    },
    {
      "code": "GBLON",
      "name": "London",
      "country": "GB",
      "lat": 51.5,
      "lon": -0.083333
    },
    {
      "code": "GBLWT",
      "name": "West Thurrock",
      "country": "GB",
      "lat": 51.4836,
      "lon": 0.282
    },
    {
      "code": "GBMLF",
      "name": "Milford Haven",
      "country": "GB",
      "lat": 51.716667,
      "lon": -5.033333
    },
    {
      "code": "GBMME",
      "name": "Teesside",
      "country": "GB",
      "lat": 54.566667,
      "lon": -1.233333
    },
    {
      "code": "GBMYN",
      "name": "Maydown",
      "country": "GB",
      "lat": 55.016667,
      "lon": -7.25
    },
    {
      "code": "GBNCL",
      "name": "Newcastle upon Tyne",
      "country": "GB",
      "lat": 54.966667,
      "lon": -1.6
    },
    {
      "code": "GBNGG",
      "name": "Nigg",
      "country": "GB",
      "lat": 57.716667,
      "lon": -4
    },
    {
      "code": "GBNHV",
      "name": "Newhaven",
      "country": "GB",
      "lat": 50.783333,
      "lon": 0.05
    },
    {
      "code": "GBNPT",
      "name": "Newport",
      "country": "GB",
      "lat": 51.55,
      "lon": -2.983333
    },
    {
      "code": "GBNRW",
      "name": "Norwich",
      "country": "GB",
      "lat": 52.628611,
      "lon": 1.292778
    },
    {
      "code": "GBPEM",
      "name": "Pembroke",
      "country": "GB",
      "lat": 51.666667,
      "lon": -4.9
    },
    {
      "code": "GBPFT",
      "name": "Purfleet",
      "country": "GB",
      "lat": 51.48,
      "lon": 0.25
    },
    {
      "code": "GBPHD",
      "name": "Peterhead",
      "country": "GB",
      "lat": 57.5,
      "lon": -1.783333
    },
    {
      "code": "GBPLY",
      "name": "Plymouth",
      "country": "GB",
      "lat": 50.4,
      "lon": -4.116667
    },
    {
      "code": "GBPME",
      "name": "Portsmouth",
      "country": "GB",
      "lat": 50.808935,
      "lon": -1.08898
    },
    {
      "code": "GBPRU",
      "name": "Portbury",
      "country": "GB",
      "lat": 51.466667,
      "lon": -2.716667
    },
    {
      "code": "GBPTB",
      "name": "Port Talbot",
      "country": "GB",
      "lat": 51.6,
      "lon": -3.783333
    },
    {
      "code": "GBPTL",
      "name": "Portland",
      "country": "GB",
      "lat": 50.5675,
      "lon": -2.443333
    },
    {
      "code": "GBRER",
      "name": "Redcar",
      "country": "GB",
      "lat": 54.6,
      "lon": -1.05
    },
    {
      "code": "GBROY",
      "name": "Rosyth",
      "country": "GB",
      "lat": 56.033333,
      "lon": -3.433333
    },
    {
      "code": "GBSCR",
      "name": "Scrabster",
      "country": "GB",
      "lat": 58.616667,
      "lon": -3.55
    },
    {
      "code": "GBSED",
      "name": "Salt End",
      "country": "GB",
      "lat": 53.733333,
      "lon": -0.233333
    },
    {
      "code": "GBSFW",
      "name": "Scapa Flow",
      "country": "GB",
      "lat": 58.883333,
      "lon": -3.066667
    },
    {
      "code": "GBSFY",
      "name": "Salford",
      "country": "GB",
      "lat": 53.483333,
      "lon": -2.266667
    },
    {
      "code": "GBSHO",
      "name": "Shoreham",
      "country": "GB",
      "lat": 51.316667,
      "lon": 0.183333
    },
    {
      "code": "GBSHV",
      "name": "Shell Haven",
      "country": "GB",
      "lat": 51.5052,
      "lon": 0.4902
    },
    {
      "code": "GBSOU",
      "name": "Southampton",
      "country": "GB",
      "lat": 50.9,
      "lon": -1.4
    },
    {
      "code": "GBSOW",
      "name": "Stanlow",
      "country": "GB",
      "lat": 52.583333,
      "lon": -2.3
    },
    {
      "code": "GBSTO",
      "name": "Stornoway",
      "country": "GB",
      "lat": 58.216667,
      "lon": -6.366667
    },
    {
      "code": "GBSUN",
      "name": "Sunderland",
      "country": "GB",
      "lat": 54.9,
      "lon": -1.383333
    },
    {
      "code": "GBSWD",
      "name": "Southwold",
      "country": "GB",
      "lat": 52.327,
      "lon": 1.68
    },
    {
      "code": "GBTEE",
      "name": "Teesport",
      "country": "GB",
      "lat": 54.583333,
      "lon": -1.15
    },
    {
      "code": "GBTHP",
      "name": "Thamesport",
      "country": "GB",
      "lat": 51.433333,
      "lon": 0.7
    },
    {
      "code": "GBTIL",
      "name": "Tilbury",
      "country": "GB",
      "lat": 51.46,
      "lon": 0.345
    },
    {
      "code": "GBTNR",
      "name": "Saint Helier",
      "country": "GB",
      "lat": 49.183333,
      "lon": -2.1
    },
    {
      "code": "GBTRA",
      "name": "Tranmere",
      "country": "GB",
      "lat": 53.366667,
      "lon": -3.016667
    },
    {
      "code": "GBTTL",
      "name": "Tetney Terminal",
      "country": "GB",
      "lat": 53.483333,
      "lon": 0.016667
    },
    {
      "code": "GBTYN",
      "name": "Tyne",
      "country": "GB",
      "lat": 55,
      "lon": -1.433333
    },
    {
      "code": "GBWHV",
      "name": "Whitehaven",
      "country": "GB",
      "lat": 54.548,
      "lon": -3.5855
    },
    {
      "code": "GBXSS",
      "name": "Seal Sands",
      "country": "GB",
      "lat": 54.633333,
      "lon": -1.133333
    },
    {
      "code": "GEBUS",
      "name": "Batumi",
      "country": "GE",
      "lat": 41.65,
      "lon": 41.65
    },
    {
      "code": "GEKUL",
      "name": "Kulevi",
      "country": "GE",
      "lat": 42.266667,
      "lon": 41.633333
    },
    {
      "code": "GEPTI",
      "name": "Poti",
      "country": "GE",
      "lat": 42.14597,
      "lon": 41.671528
    },
    {
      "code": "GFDDC",
      "name": "Degrad des Cannes",
      "country": "GF",
      "lat": 4.866667,
      "lon": -52.266667
    },
    {
      "code": "GHTEM",
      "name": "Tema",
      "country": "GH",
      "lat": 5.631944,
      "lon": 0.015556
    },
    {
      "code": "GHTKD",
      "name": "Takoradi",
      "country": "GH",
      "lat": 4.883333,
      "lon": -1.733333
    },
    {
      "code": "GIGIB",
      "name": "Gibraltar",
      "country": "GI",
      "lat": 36.14425,
      "lon": -5.3576
    },
    {
      "code": "GMBJL",
      "name": "Banjul",
      "country": "GM",
      "lat": 13.45,
      "lon": -16.566667
    },
    {
      "code": "GNBFA",
      "name": "Boffa",
      "country": "GN",
      "lat": 10.183333,
      "lon": -14.033333
    },
    {
      "code": "GNBRP",
      "name": "Port de Boke",
      "country": "GN",
      "lat": 10.516667,
      "lon": -14.716667
    },
    {
      "code": "GNBTY",
      "name": "Benty",
      "country": "GN",
      "lat": 9.166667,
      "lon": -13.2
    },
    {
      "code": "GNCKY",
      "name": "Conakry",
      "country": "GN",
      "lat": 9.519444,
      "lon": -13.716667
    },
    {
      "code": "GNKMC",
      "name": "Kamsar",
      "country": "GN",
      "lat": 10.666667,
      "lon": -14.583333
    },
    {
      "code": "GNKMR",
      "name": "Port-Kamsar",
      "country": "GN",
      "lat": 10.65,
      "lon": -14.616667
    },
    {
      "code": "GPPTP",
      "name": "Point-a-Pitre Apt",
      "country": "GP",
      "lat": 16.233333,
      "lon": -61.533333
    },
    {
      "code": "GQLUB",
      "name": "Luba",
      "country": "GQ",
      "lat": 3.5,
      "lon": 8.566667
    },
    {
      "code": "GQPET",
      "name": "Punta Europa Terminal",
      "country": "GQ",
      "lat": 3.783333,
      "lon": 8.716667
    },
    {
      "code": "GQSSG",
      "name": "Malabo",
      "country": "GQ",
      "lat": 3.75,
      "lon": 8.783333
    },
    {
      "code": "GRAGT",
      "name": "Agio Theodoroi",
      "country": "GR",
      "lat": 37.916667,
      "lon": 23.116667
    },
    {
      "code": "GRASS",
      "name": "Aspropirgos",
      "country": "GR",
      "lat": 38.066667,
      "lon": 23.583333
    },
    {
      "code": "GRAXD",
      "name": "Alexandroupolis",
      "country": "GR",
      "lat": 40.85,
      "lon": 25.866667
    },
    {
      "code": "GRCHQ",
      "name": "Chania",
      "country": "GR",
      "lat": 35.516667,
      "lon": 24.016667
    },
    {
      "code": "GREEU",
      "name": "Eleusina",
      "country": "GR",
      "lat": 38.033333,
      "lon": 23.533333
    },
    {
      "code": "GRFLS",
      "name": "Eleusis",
      "country": "GR",
      "lat": 38.033333,
      "lon": 23.533333
    },
    {
      "code": "GRGPA",
      "name": "Patras",
      "country": "GR",
      "lat": 38.233333,
      "lon": 21.716667
    },
    {
      "code": "GRJKH",
      "name": "Chios",
      "country": "GR",
      "lat": 38.366667,
      "lon": 26.133333
    },
    {
      "code": "GRKLX",
      "name": "Kalamata",
      "country": "GR",
      "lat": 37.033333,
      "lon": 22.116667
    },
    {
      "code": "GRLAV",
      "name": "Lavrion (Laurium)",
      "country": "GR",
      "lat": 37.716667,
      "lon": 24.066667
    },
    {
      "code": "GRNEA",
      "name": "Neapolis",
      "country": "GR",
      "lat": 36.5,
      "lon": 23.066667
    },
    {
      "code": "GRPIR",
      "name": "Piraeus",
      "country": "GR",
      "lat": 37.933333,
      "lon": 23.616667
    },
    {
      "code": "GRPME",
      "name": "Pachi",
      "country": "GR",
      "lat": 37.966667,
      "lon": 23.35
    },
    {
      "code": "GRREV",
      "name": "Revithoussa",
      "country": "GR",
      "lat": 37.95,
      "lon": 23.383333
    },
    {
      "code": "GRSKG",
      "name": "Thessaloniki",
      "country": "GR",
      "lat": 40.633333,
      "lon": 22.95
    },
    {
      "code": "GRSTN",
      "name": "Saint Nicolas",
      "country": "GR",
      "lat": 38.35,
      "lon": 22.683333
    },
    {
      "code": "GRVAB",
      "name": "Vatika Bay",
      "country": "GR",
      "lat": 36.5,
      "lon": 23.033333
    },
    {
      "code": "GRVOL",
      "name": "Volos",
      "country": "GR",
      "lat": 39.366667,
      "lon": 22.95
    },
    {
      "code": "GTPRQ",
      "name": "Puerto Quetzal",
      "country": "GT",
      "lat": 13.916667,
      "lon": -90.8
    },
    {
      "code": "GTSNJ",
      "name": "San Jose",
      "country": "GT",
      "lat": 13.924189,
      "lon": -90.821922
    },
    {
      "code": "GTSTC",
      "name": "Puerto Santo Tomas de Castilla",
      "country": "GT",
      "lat": 15.7,
      "lon": -88.616667
    },
    {
      "code": "GUGUM",
      "name": "Guam",
      "country": "GU",
      "lat": 13.5,
      "lon": 144.8
    },
    {
      "code": "GWOXB",
      "name": "Bissau",
      "country": "GW",
      "lat": 11.85,
      "lon": -15.583333
    },
    {
      "code": "GYGEO",
      "name": "Georgetown",
      "country": "GY",
      "lat": 6.833333,
      "lon": -58.166667
    },
    {
      "code": "HKHKG",
      "name": "Hong Kong",
      "country": "HK",
      "lat": 22.316667,
      "lon": 114.166667
    },
    {
      "code": "HKKWN",
      "name": "Kowloon",
      "country": "HK",
      "lat": 22.3,
      "lon": 114.166667
    },
    {
      "code": "HKLAM",
      "name": "Lamma Island",
      "country": "HK",
      "lat": 22.2,
      "lon": 114.116667
    },
    {
      "code": "HKTSI",
      "name": "Tsing Yi",
      "country": "HK",
      "lat": 22.35,
      "lon": 114.1
    },
    {
      "code": "HNPCR",
      "name": "Puerto Cortes",
      "country": "HN",
      "lat": 15.833333,
      "lon": -87.95
    },
    {
      "code": "HNSLO",
      "name": "San Lorenzo",
      "country": "HN",
      "lat": 13.4,
      "lon": -87.45
    },
    {
      "code": "HRBAK",
      "name": "Bakar",
      "country": "HR",
      "lat": 45.3,
      "lon": 14.516667
    },
    {
      "code": "HRKRK",
      "name": "Krk",
      "country": "HR",
      "lat": 45.033333,
      "lon": 14.583333
    },
    {
      "code": "HROMI",
      "name": "Omisalj",
      "country": "HR",
      "lat": 45.216667,
      "lon": 14.55
    },
    {
      "code": "HRPLE",
      "name": "Ploce",
      "country": "HR",
      "lat": 43.05,
      "lon": 17.433333
    },
    {
      "code": "HRPLM",
      "name": "Plomin",
      "country": "HR",
      "lat": 45.133333,
      "lon": 14.166667
    },
    {
      "code": "HRRJK",
      "name": "Rijeka",
      "country": "HR",
      "lat": 45.333333,
      "lon": 14.4
    },
    {
      "code": "HTPAP",
      "name": "Port-au-Prince",
      "country": "HT",
      "lat": 18.55,
      "lon": -72.35
    },
    {
      "code": "IDADB",
      "name": "Adang Bay",
      "country": "ID",
      "lat": -1.745833,
      "lon": 116.334444
    },
    {
      "code": "IDAMA",
      "name": "Amamapare, Ij",
      "country": "ID",
      "lat": -4.816667,
      "lon": 136.966667
    },
    {
      "code": "IDBAH",
      "name": "Bahudopi",
      "country": "ID",
      "lat": -2.783333,
      "lon": 122.1
    },
    {
      "code": "IDBAL",
      "name": "Balongan Terminal",
      "country": "ID",
      "lat": -6.383333,
      "lon": 108.4
    },
    {
      "code": "IDBDJ",
      "name": "Banjarmasin",
      "country": "ID",
      "lat": -3.333333,
      "lon": 114.583333
    },
    {
      "code": "IDBEN",
      "name": "Benete",
      "country": "ID",
      "lat": -8.866667,
      "lon": 116.716667
    },
    {
      "code": "IDBKS",
      "name": "Bengkulu, Sumatra",
      "country": "ID",
      "lat": -3.783333,
      "lon": 102.25
    },
    {
      "code": "IDBLW",
      "name": "Belawan, Sumatra",
      "country": "ID",
      "lat": 3.783333,
      "lon": 98.683333
    },
    {
      "code": "IDBPN",
      "name": "Balikpapan",
      "country": "ID",
      "lat": -1.283333,
      "lon": 116.833333
    },
    {
      "code": "IDBTM",
      "name": "Batam Island",
      "country": "ID",
      "lat": 1.083333,
      "lon": 104.033333
    },
    {
      "code": "IDBUT",
      "name": "Bunati",
      "country": "ID",
      "lat": -3.75,
      "lon": 115.616667
    },
    {
      "code": "IDBXT",
      "name": "Bontang, Kl",
      "country": "ID",
      "lat": 0.1,
      "lon": 117.483333
    },
    {
      "code": "IDCIG",
      "name": "Cigading",
      "country": "ID",
      "lat": -6.016667,
      "lon": 105.966667
    },
    {
      "code": "IDCXP",
      "name": "Cilacap (Tjilatjap)",
      "country": "ID",
      "lat": -7.733333,
      "lon": 109
    },
    {
      "code": "IDDUM",
      "name": "Dumai, Sumatra",
      "country": "ID",
      "lat": 1.683333,
      "lon": 101.45
    },
    {
      "code": "IDFTG",
      "name": "Pelabuhan Futong Terminal",
      "country": "ID",
      "lat": 0.816667,
      "lon": 102.4
    },
    {
      "code": "IDGRE",
      "name": "Gresik, Java",
      "country": "ID",
      "lat": -7.15,
      "lon": 112.65
    },
    {
      "code": "IDJEP",
      "name": "Jepara",
      "country": "ID",
      "lat": -6.583333,
      "lon": 110.65
    },
    {
      "code": "IDJKT",
      "name": "Jakarta, Java",
      "country": "ID",
      "lat": -6.133333,
      "lon": 106.833333
    },
    {
      "code": "IDKAB",
      "name": "Kabil",
      "country": "ID",
      "lat": 1.05,
      "lon": 104.133333
    },
    {
      "code": "IDKBU",
      "name": "Kotabaru",
      "country": "ID",
      "lat": -3.2412,
      "lon": 116.2259
    },
    {
      "code": "IDKDI",
      "name": "Kendari, Sulawesi",
      "country": "ID",
      "lat": -3.966667,
      "lon": 122.583333
    },
    {
      "code": "IDKDW",
      "name": "Kendawangan",
      "country": "ID",
      "lat": -2.533333,
      "lon": 110.2
    },
    {
      "code": "IDKLR",
      "name": "Kaliorang",
      "country": "ID",
      "lat": 0.816667,
      "lon": 117.866667
    },
    {
      "code": "IDKSO",
      "name": "Kalbut Situbondo",
      "country": "ID",
      "lat": -7.616667,
      "lon": 113.883333
    },
    {
      "code": "IDLSW",
      "name": "Lhokseumawe",
      "country": "ID",
      "lat": 5.166667,
      "lon": 97.133333
    },
    {
      "code": "IDMAK",
      "name": "Makassar",
      "country": "ID",
      "lat": -5.116667,
      "lon": 119.4
    },
    {
      "code": "IDMKJ",
      "name": "Mangkajang",
      "country": "ID",
      "lat": 2.133333,
      "lon": 117.733333
    },
    {
      "code": "IDMRK",
      "name": "Merak, Java",
      "country": "ID",
      "lat": -5.919167,
      "lon": 105.997222
    },
    {
      "code": "IDMUB",
      "name": "Muara Berau",
      "country": "ID",
      "lat": 6.1121,
      "lon": 106.8012
    },
    {
      "code": "IDNNX",
      "name": "Nunukan",
      "country": "ID",
      "lat": 4.134475,
      "lon": 117.64517
    },
    {
      "code": "IDNPL",
      "name": "North Pulau Laut",
      "country": "ID",
      "lat": -3.216667,
      "lon": 116.266667
    },
    {
      "code": "IDOBI",
      "name": "Obi Island",
      "country": "ID",
      "lat": -1.533889,
      "lon": 127.779167
    },
    {
      "code": "IDPLM",
      "name": "Palembang, Sumatra",
      "country": "ID",
      "lat": -2.983333,
      "lon": 104.766667
    },
    {
      "code": "IDPNJ",
      "name": "Panjang",
      "country": "ID",
      "lat": -5.466667,
      "lon": 105.316667
    },
    {
      "code": "IDPTK",
      "name": "Padang Tikar",
      "country": "ID",
      "lat": -0.666667,
      "lon": 109.266667
    },
    {
      "code": "IDPUM",
      "name": "Pomalaa, Sulawesi",
      "country": "ID",
      "lat": -4.033333,
      "lon": 121.583333
    },
    {
      "code": "IDSKI",
      "name": "Sangkulirang, Kalimantan",
      "country": "ID",
      "lat": 0.978056,
      "lon": 118.028611
    },
    {
      "code": "IDSRG",
      "name": "Semarang",
      "country": "ID",
      "lat": -6.966667,
      "lon": 110.483333
    },
    {
      "code": "IDSRI",
      "name": "Samarinda, Kalimantan",
      "country": "ID",
      "lat": -0.516667,
      "lon": 117.116667
    },
    {
      "code": "IDSTU",
      "name": "Satui",
      "country": "ID",
      "lat": -3.7818,
      "lon": 115.4575
    },
    {
      "code": "IDSUB",
      "name": "Surabaya",
      "country": "ID",
      "lat": -7.233333,
      "lon": 112.75
    },
    {
      "code": "IDTAB",
      "name": "Taboneo",
      "country": "ID",
      "lat": -3.683333,
      "lon": 114.416667
    },
    {
      "code": "IDTAN",
      "name": "Tanjunguban",
      "country": "ID",
      "lat": 1.05,
      "lon": 104.233333
    },
    {
      "code": "IDTBA",
      "name": "Tanjung Bara, Kl",
      "country": "ID",
      "lat": 0.544722,
      "lon": 117.643333
    },
    {
      "code": "IDTBN",
      "name": "Tuban, Jv",
      "country": "ID",
      "lat": -6.733333,
      "lon": 112.15
    },
    {
      "code": "IDTBR",
      "name": "Telukbayur",
      "country": "ID",
      "lat": -1,
      "lon": 100.366667
    },
    {
      "code": "IDTNK",
      "name": "Tanahkuning",
      "country": "ID",
      "lat": 2.616667,
      "lon": 117.783333
    },
    {
      "code": "IDTPN",
      "name": "Tanjung Pemancingan",
      "country": "ID",
      "lat": -3.183333,
      "lon": 116.266667
    },
    {
      "code": "IDTPP",
      "name": "Tanjung Priok",
      "country": "ID",
      "lat": -6.1,
      "lon": 106.883333
    },
    {
      "code": "IDTRH",
      "name": "Tarahan",
      "country": "ID",
      "lat": -5.566667,
      "lon": 105.366667
    },
    {
      "code": "IDTSE",
      "name": "Tanjung Sekong, Jv",
      "country": "ID",
      "lat": -5.916667,
      "lon": 106
    },
    {
      "code": "IDWED",
      "name": "Weda",
      "country": "ID",
      "lat": 0.333333,
      "lon": 127.883333
    },
    {
      "code": "IEAUG",
      "name": "Aughinish Island",
      "country": "IE",
      "lat": 52.62593,
      "lon": -9.06246
    },
    {
      "code": "IEBTH",
      "name": "Bantry Harbour",
      "country": "IE",
      "lat": 51.683333,
      "lon": -9.45
    },
    {
      "code": "IEDRO",
      "name": "Drogheda",
      "country": "IE",
      "lat": 53.716667,
      "lon": -6.3
    },
    {
      "code": "IEDUB",
      "name": "Dublin",
      "country": "IE",
      "lat": 53.347906,
      "lon": -6.234294
    },
    {
      "code": "IEFEN",
      "name": "Fenit",
      "country": "IE",
      "lat": 52.266667,
      "lon": -9.866667
    },
    {
      "code": "IEFOV",
      "name": "Foynes",
      "country": "IE",
      "lat": 52.616667,
      "lon": -9.116667
    },
    {
      "code": "IEGRN",
      "name": "Greenore",
      "country": "IE",
      "lat": 54.033333,
      "lon": -6.133333
    },
    {
      "code": "IEGWY",
      "name": "Galway",
      "country": "IE",
      "lat": 53.266667,
      "lon": -9.05
    },
    {
      "code": "IEORK",
      "name": "Cork",
      "country": "IE",
      "lat": 51.85,
      "lon": -8.266667
    },
    {
      "code": "IERIN",
      "name": "Ringaskiddy",
      "country": "IE",
      "lat": 51.833333,
      "lon": -8.316667
    },
    {
      "code": "IESNN",
      "name": "Shannon",
      "country": "IE",
      "lat": 52.7,
      "lon": -8.85
    },
    {
      "code": "IETAR",
      "name": "Tarbert",
      "country": "IE",
      "lat": 52.583333,
      "lon": -9.366667
    },
    {
      "code": "IEWAT",
      "name": "Waterford",
      "country": "IE",
      "lat": 52.25,
      "lon": -7.1
    },
    {
      "code": "ILAKL",
      "name": "Ashkelon",
      "country": "IL",
      "lat": 31.666667,
      "lon": 34.5
    },
    {
      "code": "ILHAD",
      "name": "Hadera",
      "country": "IL",
      "lat": 32.466667,
      "lon": 34.9
    },
    {
      "code": "ILHFA",
      "name": "Haifa",
      "country": "IL",
      "lat": 32.8,
      "lon": 34.983333
    },
    {
      "code": "IMDGS",
      "name": "Douglas",
      "country": "IM",
      "lat": 54.166667,
      "lon": -4.483333
    },
    {
      "code": "INBHU",
      "name": "Bhavnagar",
      "country": "IN",
      "lat": 21.766667,
      "lon": 72.133333
    },
    {
      "code": "INBOM",
      "name": "Mumbai (ex Bombay)",
      "country": "IN",
      "lat": 18.966667,
      "lon": 72.816667
    },
    {
      "code": "INCOK",
      "name": "Kochi",
      "country": "IN",
      "lat": 9.966667,
      "lon": 76.266667
    },
    {
      "code": "INDAH",
      "name": "Dahej",
      "country": "IN",
      "lat": 21.7,
      "lon": 72.533333
    },
    {
      "code": "INDMQ",
      "name": "Dhamra Port",
      "country": "IN",
      "lat": 20.816667,
      "lon": 86.95
    },
    {
      "code": "INENR",
      "name": "Ennore",
      "country": "IN",
      "lat": 13.261389,
      "lon": 80.3425
    },
    {
      "code": "INGGV",
      "name": "Gangavaram",
      "country": "IN",
      "lat": 17.65,
      "lon": 83.25
    },
    {
      "code": "INGPR",
      "name": "Gopalpur",
      "country": "IN",
      "lat": 19.301944,
      "lon": 84.966667
    },
    {
      "code": "INHAL",
      "name": "Haldia",
      "country": "IN",
      "lat": 22.016667,
      "lon": 88.083333
    },
    {
      "code": "INHZA",
      "name": "Hazira Port/Surat",
      "country": "IN",
      "lat": 21.083333,
      "lon": 72.616667
    },
    {
      "code": "INIXY",
      "name": "Kandla",
      "country": "IN",
      "lat": 23.033333,
      "lon": 70.216667
    },
    {
      "code": "INJGD",
      "name": "Jaigad",
      "country": "IN",
      "lat": 17.3,
      "lon": 73.216667
    },
    {
      "code": "INKAK",
      "name": "Kakinada",
      "country": "IN",
      "lat": 17,
      "lon": 82.316667
    },
    {
      "code": "INKRI",
      "name": "Krishnapatnam",
      "country": "IN",
      "lat": 14.253175,
      "lon": 80.124812
    },
    {
      "code": "INKRK",
      "name": "Karaikal",
      "country": "IN",
      "lat": 10.833333,
      "lon": 79.866667
    },
    {
      "code": "INMAA",
      "name": "Chennai (ex Madras)",
      "country": "IN",
      "lat": 13.083333,
      "lon": 80.283333
    },
    {
      "code": "INMRM",
      "name": "Marmugao (Marmagao)",
      "country": "IN",
      "lat": 15.4,
      "lon": 73.783333
    },
    {
      "code": "INMUN",
      "name": "Mundra",
      "country": "IN",
      "lat": 22.728333,
      "lon": 69.706667
    },
    {
      "code": "INNML",
      "name": "New Mangalore",
      "country": "IN",
      "lat": 12.916667,
      "lon": 74.816667
    },
    {
      "code": "INOKH",
      "name": "Okha",
      "country": "IN",
      "lat": 22.468056,
      "lon": 69.079722
    },
    {
      "code": "INPAV",
      "name": "Pipavav (Victor) Port",
      "country": "IN",
      "lat": 20.933333,
      "lon": 71.516667
    },
    {
      "code": "INPPT",
      "name": "Paradip Port",
      "country": "IN",
      "lat": 20.25,
      "lon": 86.583333
    },
    {
      "code": "INSAL",
      "name": "Salaya",
      "country": "IN",
      "lat": 22.31038,
      "lon": 69.60376
    },
    {
      "code": "INSIK",
      "name": "Sika",
      "country": "IN",
      "lat": 22.433333,
      "lon": 69.833333
    },
    {
      "code": "INTUN",
      "name": "Tuna",
      "country": "IN",
      "lat": 22.98673,
      "lon": 70.08075
    },
    {
      "code": "INTUT",
      "name": "Tuticorin",
      "country": "IN",
      "lat": 8.783333,
      "lon": 78.133333
    },
    {
      "code": "INVAD",
      "name": "Vadinar",
      "country": "IN",
      "lat": 22.466667,
      "lon": 69.666667
    },
    {
      "code": "INVIG",
      "name": "Vizagapatanam",
      "country": "IN",
      "lat": 17.7,
      "lon": 83.3
    },
    {
      "code": "INVTZ",
      "name": "Visakhapatnam",
      "country": "IN",
      "lat": 17.7,
      "lon": 83.3
    },
    {
      "code": "IQBSR",
      "name": "Basra",
      "country": "IQ",
      "lat": 30.516667,
      "lon": 47.833333
    },
    {
      "code": "IQKAZ",
      "name": "Khor al Zubair",
      "country": "IQ",
      "lat": 30.158333,
      "lon": 47.908334
    },
    {
      "code": "IQUQR",
      "name": "Umm Qasr Port",
      "country": "IQ",
      "lat": 30.033333,
      "lon": 47.933333
    },
    {
      "code": "ISHEL",
      "name": "Helguvik",
      "country": "IS",
      "lat": 64.033333,
      "lon": -22.55
    },
    {
      "code": "ISREY",
      "name": "Reykjavik",
      "country": "IS",
      "lat": 64.15,
      "lon": -21.95
    },
    {
      "code": "ISRFJ",
      "name": "Reydarfjordur",
      "country": "IS",
      "lat": 65.033333,
      "lon": -14.1
    },
    {
      "code": "ISSTR",
      "name": "Straumsvik",
      "country": "IS",
      "lat": 64.05,
      "lon": -22.05
    },
    {
      "code": "ITAOI",
      "name": "Ancona",
      "country": "IT",
      "lat": 43.633333,
      "lon": 13.5
    },
    {
      "code": "ITAUG",
      "name": "Augusta",
      "country": "IT",
      "lat": 37.216667,
      "lon": 15.216667
    },
    {
      "code": "ITBDS",
      "name": "Brindisi",
      "country": "IT",
      "lat": 40.633333,
      "lon": 17.933333
    },
    {
      "code": "ITCAG",
      "name": "Cagliari",
      "country": "IT",
      "lat": 39.216667,
      "lon": 9.116667
    },
    {
      "code": "ITCTA",
      "name": "Catania",
      "country": "IT",
      "lat": 37.5,
      "lon": 15.1
    },
    {
      "code": "ITCVV",
      "name": "Civitavecchia",
      "country": "IT",
      "lat": 42.1,
      "lon": 11.8
    },
    {
      "code": "ITFAL",
      "name": "Falconara",
      "country": "IT",
      "lat": 43.6296,
      "lon": 13.3968
    },
    {
      "code": "ITFCO",
      "name": "Fiumicino Apt/Roma",
      "country": "IT",
      "lat": 41.766667,
      "lon": 12.233333
    },
    {
      "code": "ITFOL",
      "name": "Follonica",
      "country": "IT",
      "lat": 42.916667,
      "lon": 10.75
    },
    {
      "code": "ITFSA",
      "name": "Fusina",
      "country": "IT",
      "lat": 45.416667,
      "lon": 12.233333
    },
    {
      "code": "ITGAE",
      "name": "Gaeta",
      "country": "IT",
      "lat": 41.2,
      "lon": 13.583333
    },
    {
      "code": "ITGEA",
      "name": "Gela",
      "country": "IT",
      "lat": 37.066667,
      "lon": 14.25
    },
    {
      "code": "ITGHE",
      "name": "Porto Marghera",
      "country": "IT",
      "lat": 45.45,
      "lon": 12.25
    },
    {
      "code": "ITGOA",
      "name": "Genova",
      "country": "IT",
      "lat": 44.416667,
      "lon": 8.95
    },
    {
      "code": "ITLIV",
      "name": "Livorno",
      "country": "IT",
      "lat": 43.55,
      "lon": 10.316667
    },
    {
      "code": "ITMFR",
      "name": "Manfredonia",
      "country": "IT",
      "lat": 41.633333,
      "lon": 15.916667
    },
    {
      "code": "ITMLZ",
      "name": "Milazzo",
      "country": "IT",
      "lat": 38.216667,
      "lon": 15.25
    },
    {
      "code": "ITMNF",
      "name": "Monfalcone",
      "country": "IT",
      "lat": 45.783333,
      "lon": 13.55
    },
    {
      "code": "ITMNP",
      "name": "Monopoli",
      "country": "IT",
      "lat": 40.955,
      "lon": 17.308
    },
    {
      "code": "ITNLS",
      "name": "Nalles",
      "country": "IT",
      "lat": 46.533333,
      "lon": 11.2
    },
    {
      "code": "ITOTN",
      "name": "Ortona",
      "country": "IT",
      "lat": 42.35,
      "lon": 14.416667
    },
    {
      "code": "ITPFX",
      "name": "Sarroch (Porto Foxi)",
      "country": "IT",
      "lat": 39.05,
      "lon": 9
    },
    {
      "code": "ITPIO",
      "name": "Piombino",
      "country": "IT",
      "lat": 42.933,
      "lon": 10.557
    },
    {
      "code": "ITPMA",
      "name": "Marghera",
      "country": "IT",
      "lat": 45.45,
      "lon": 12.216667
    },
    {
      "code": "ITPRL",
      "name": "Priolo Gargallo",
      "country": "IT",
      "lat": 37.15,
      "lon": 15.183333
    },
    {
      "code": "ITPVT",
      "name": "Porto Levante",
      "country": "IT",
      "lat": 45.05,
      "lon": 12.366667
    },
    {
      "code": "ITPZL",
      "name": "Pozzallo",
      "country": "IT",
      "lat": 36.716667,
      "lon": 14.85
    },
    {
      "code": "ITQOS",
      "name": "Oristano",
      "country": "IT",
      "lat": 39.9,
      "lon": 8.6
    },
    {
      "code": "ITRAN",
      "name": "Ravenna",
      "country": "IT",
      "lat": 44.430951,
      "lon": 12.222624
    },
    {
      "code": "ITRVO",
      "name": "Rovigo",
      "country": "IT",
      "lat": 45.066667,
      "lon": 11.766667
    },
    {
      "code": "ITSPA",
      "name": "Santa Panagia",
      "country": "IT",
      "lat": 37.1,
      "lon": 15.25
    },
    {
      "code": "ITSPE",
      "name": "La Spezia",
      "country": "IT",
      "lat": 44.116667,
      "lon": 9.833333
    },
    {
      "code": "ITSVN",
      "name": "Savona",
      "country": "IT",
      "lat": 44.283333,
      "lon": 8.5
    },
    {
      "code": "ITTAR",
      "name": "Taranto",
      "country": "IT",
      "lat": 40.483333,
      "lon": 17.233333
    },
    {
      "code": "ITTRS",
      "name": "Trieste",
      "country": "IT",
      "lat": 45.651,
      "lon": 13.746
    },
    {
      "code": "ITVCE",
      "name": "Venezia",
      "country": "IT",
      "lat": 45.433333,
      "lon": 12.333333
    },
    {
      "code": "ITVDL",
      "name": "Vado Ligure",
      "country": "IT",
      "lat": 44.266667,
      "lon": 8.45
    },
    {
      "code": "ITVSO",
      "name": "Vasto",
      "country": "IT",
      "lat": 42.116667,
      "lon": 14.716667
    },
    {
      "code": "ITVVA",
      "name": "Vibo Valentia",
      "country": "IT",
      "lat": 38.723,
      "lon": 16.13
    },
    {
      "code": "ITZ8V",
      "name": "Zovencedo",
      "country": "IT",
      "lat": 45.416667,
      "lon": 11.5
    },
    {
      "code": "JMKIN",
      "name": "Kingston",
      "country": "JM",
      "lat": 17.966667,
      "lon": -76.783333
    },
    {
      "code": "JMMBJ",
      "name": "Montego Bay",
      "country": "JM",
      "lat": 18.466667,
      "lon": -77.933333
    },
    {
      "code": "JMPEV",
      "name": "Port Esquivel",
      "country": "JM",
      "lat": 17.883333,
      "lon": -77.133333
    },
    {
      "code": "JOAQB",
      "name": "'Aqaba",
      "country": "JO",
      "lat": 29.533333,
      "lon": 35
    },
    {
      "code": "JOAQJ",
      "name": "Al 'Aqabah",
      "country": "JO",
      "lat": 29.533333,
      "lon": 35
    },
    {
      "code": "JPAXT",
      "name": "Akita",
      "country": "JP",
      "lat": 39.781389,
      "lon": 140.015
    },
    {
      "code": "JPCHB",
      "name": "Chiba",
      "country": "JP",
      "lat": 35.583333,
      "lon": 140.066667
    },
    {
      "code": "JPCTA",
      "name": "Chita",
      "country": "JP",
      "lat": 34.996556,
      "lon": 136.864722
    },
    {
      "code": "JPFKY",
      "name": "Fukuyama, Hiroshima",
      "country": "JP",
      "lat": 34.489296,
      "lon": 133.369084
    },
    {
      "code": "JPFTS",
      "name": "Futtsu, Chiba",
      "country": "JP",
      "lat": 35.304083,
      "lon": 139.857028
    },
    {
      "code": "JPHAT",
      "name": "Hatsukaichi",
      "country": "JP",
      "lat": 34.35,
      "lon": 132.333333
    },
    {
      "code": "JPHBI",
      "name": "Hibiki-Nada",
      "country": "JP",
      "lat": 34,
      "lon": 130.5
    },
    {
      "code": "JPHHE",
      "name": "Hachinohe",
      "country": "JP",
      "lat": 40.533333,
      "lon": 141.55
    },
    {
      "code": "JPHHR",
      "name": "Higashiharima",
      "country": "JP",
      "lat": 34.7,
      "lon": 134.833333
    },
    {
      "code": "JPHIB",
      "name": "Hibi",
      "country": "JP",
      "lat": 34.45,
      "lon": 133.933333
    },
    {
      "code": "JPHIC",
      "name": "Hitachinaka",
      "country": "JP",
      "lat": 36.396694,
      "lon": 140.534667
    },
    {
      "code": "JPHIJ",
      "name": "Hiroshima",
      "country": "JP",
      "lat": 34.35,
      "lon": 132.466667
    },
    {
      "code": "JPHIM",
      "name": "Himeji",
      "country": "JP",
      "lat": 34.75,
      "lon": 134.633333
    },
    {
      "code": "JPHIS",
      "name": "Hikoshima",
      "country": "JP",
      "lat": 33.94195,
      "lon": 130.911
    },
    {
      "code": "JPHKT",
      "name": "Hakata/Fukuoka",
      "country": "JP",
      "lat": 33.6,
      "lon": 130.416667
    },
    {
      "code": "JPHRH",
      "name": "Hirohata",
      "country": "JP",
      "lat": 34.766667,
      "lon": 134.633333
    },
    {
      "code": "JPHTC",
      "name": "Hitachi",
      "country": "JP",
      "lat": 36.5,
      "lon": 140.633333
    },
    {
      "code": "JPIHA",
      "name": "Niihama",
      "country": "JP",
      "lat": 33.983333,
      "lon": 133.283333
    },
    {
      "code": "JPIMI",
      "name": "Imari",
      "country": "JP",
      "lat": 33.283333,
      "lon": 129.883333
    },
    {
      "code": "JPISI",
      "name": "Ishikari",
      "country": "JP",
      "lat": 43.216667,
      "lon": 141.283333
    },
    {
      "code": "JPISM",
      "name": "Ishinomaki",
      "country": "JP",
      "lat": 38.4,
      "lon": 141.316667
    },
    {
      "code": "JPIWK",
      "name": "Iwakuni",
      "country": "JP",
      "lat": 34.183333,
      "lon": 132.25
    },
    {
      "code": "JPJTS",
      "name": "Joetsu",
      "country": "JP",
      "lat": 37.15,
      "lon": 138.233333
    },
    {
      "code": "JPKAI",
      "name": "Kainan",
      "country": "JP",
      "lat": 34.1575,
      "lon": 135.239694
    },
    {
      "code": "JPKGA",
      "name": "Kakogawa",
      "country": "JP",
      "lat": 34.7,
      "lon": 134.833333
    },
    {
      "code": "JPKII",
      "name": "Kiire",
      "country": "JP",
      "lat": 31.383333,
      "lon": 130.55
    },
    {
      "code": "JPKIJ",
      "name": "Niigata",
      "country": "JP",
      "lat": 37.916667,
      "lon": 139.05
    },
    {
      "code": "JPKIK",
      "name": "Kikuma",
      "country": "JP",
      "lat": 34.033333,
      "lon": 132.833333
    },
    {
      "code": "JPKKJ",
      "name": "Kitakyushu",
      "country": "JP",
      "lat": 33.833333,
      "lon": 130.833333
    },
    {
      "code": "JPKKW",
      "name": "Kanokawa",
      "country": "JP",
      "lat": 34.183333,
      "lon": 132.433333
    },
    {
      "code": "JPKMT",
      "name": "Kimitsu",
      "country": "JP",
      "lat": 35.330528,
      "lon": 139.902472
    },
    {
      "code": "JPKNU",
      "name": "Kinuura",
      "country": "JP",
      "lat": 34.85,
      "lon": 136.95
    },
    {
      "code": "JPKNZ",
      "name": "Kanazawa",
      "country": "JP",
      "lat": 36.616667,
      "lon": 136.6
    },
    {
      "code": "JPKOJ",
      "name": "Kagoshima",
      "country": "JP",
      "lat": 31.583333,
      "lon": 130.566667
    },
    {
      "code": "JPKRE",
      "name": "Kure, Hiroshima",
      "country": "JP",
      "lat": 34.233333,
      "lon": 132.55
    },
    {
      "code": "JPKSA",
      "name": "Kasaoka",
      "country": "JP",
      "lat": 34.507139,
      "lon": 133.507361
    },
    {
      "code": "JPKSM",
      "name": "Kashima, Ibaraki",
      "country": "JP",
      "lat": 35.933333,
      "lon": 140.7
    },
    {
      "code": "JPKUD",
      "name": "Kudamatsu",
      "country": "JP",
      "lat": 34,
      "lon": 131.866667
    },
    {
      "code": "JPKUH",
      "name": "Kushiro",
      "country": "JP",
      "lat": 42.983333,
      "lon": 144.366667
    },
    {
      "code": "JPKWN",
      "name": "Kawanoe",
      "country": "JP",
      "lat": 34.01654,
      "lon": 133.57844
    },
    {
      "code": "JPKWS",
      "name": "Kawasaki",
      "country": "JP",
      "lat": 35.5,
      "lon": 139.766667
    },
    {
      "code": "JPMAI",
      "name": "Maizuru",
      "country": "JP",
      "lat": 35.516667,
      "lon": 135.333333
    },
    {
      "code": "JPMII",
      "name": "Miike, Fukuoka",
      "country": "JP",
      "lat": 33,
      "lon": 130.416667
    },
    {
      "code": "JPMIZ",
      "name": "Mizushima",
      "country": "JP",
      "lat": 34.5,
      "lon": 133.75
    },
    {
      "code": "JPMKS",
      "name": "Mitsukoshima",
      "country": "JP",
      "lat": 34.183333,
      "lon": 132.516667
    },
    {
      "code": "JPMMI",
      "name": "Misumi, Shimane",
      "country": "JP",
      "lat": 34.775722,
      "lon": 131.964389
    },
    {
      "code": "JPMNG",
      "name": "Matsunaga",
      "country": "JP",
      "lat": 34.4468,
      "lon": 133.25697
    },
    {
      "code": "JPMOJ",
      "name": "Moji/Kitakyushu",
      "country": "JP",
      "lat": 33.9,
      "lon": 130.966667
    },
    {
      "code": "JPMTS",
      "name": "Matsuura, Nagasaki",
      "country": "JP",
      "lat": 32.933333,
      "lon": 129.6
    },
    {
      "code": "JPMUR",
      "name": "Muroran",
      "country": "JP",
      "lat": 42.35,
      "lon": 140.966667
    },
    {
      "code": "JPMUT",
      "name": "Mutsuogawara",
      "country": "JP",
      "lat": 40.933889,
      "lon": 141.381389
    },
    {
      "code": "JPMYJ",
      "name": "Matsuyama",
      "country": "JP",
      "lat": 33.85,
      "lon": 132.7
    },
    {
      "code": "JPNAH",
      "name": "Naha, Okinawa",
      "country": "JP",
      "lat": 26.216667,
      "lon": 127.683333
    },
    {
      "code": "JPNAO",
      "name": "Naoetsu",
      "country": "JP",
      "lat": 37.183333,
      "lon": 138.25
    },
    {
      "code": "JPNAS",
      "name": "Naoshima",
      "country": "JP",
      "lat": 34.459806,
      "lon": 133.995639
    },
    {
      "code": "JPNGO",
      "name": "Nagoya, Aichi",
      "country": "JP",
      "lat": 35.066667,
      "lon": 136.866667
    },
    {
      "code": "JPNGS",
      "name": "Nagasaki",
      "country": "JP",
      "lat": 32.716667,
      "lon": 129.85
    },
    {
      "code": "JPNIH",
      "name": "Niigatahigashi",
      "country": "JP",
      "lat": 38.016667,
      "lon": 139.233333
    },
    {
      "code": "JPNNO",
      "name": "Nanao",
      "country": "JP",
      "lat": 37.05,
      "lon": 136.983333
    },
    {
      "code": "JPNSR",
      "name": "Noshiro",
      "country": "JP",
      "lat": 40.216667,
      "lon": 140
    },
    {
      "code": "JPOIT",
      "name": "Oita",
      "country": "JP",
      "lat": 33.25,
      "lon": 131.666667
    },
    {
      "code": "JPONA",
      "name": "Onahama",
      "country": "JP",
      "lat": 36.933333,
      "lon": 140.9
    },
    {
      "code": "JPOSA",
      "name": "Osaka",
      "country": "JP",
      "lat": 34.666667,
      "lon": 135.5
    },
    {
      "code": "JPSAE",
      "name": "Saiki",
      "country": "JP",
      "lat": 32.966667,
      "lon": 131.933333
    },
    {
      "code": "JPSAG",
      "name": "Saganoseki",
      "country": "JP",
      "lat": 33.25,
      "lon": 131.866667
    },
    {
      "code": "JPSAK",
      "name": "Sakai",
      "country": "JP",
      "lat": 34.573333,
      "lon": 135.483
    },
    {
      "code": "JPSBK",
      "name": "Sakaisenboku",
      "country": "JP",
      "lat": 34.55,
      "lon": 135.433333
    },
    {
      "code": "JPSBS",
      "name": "Shibushi",
      "country": "JP",
      "lat": 31.466667,
      "lon": 131.1
    },
    {
      "code": "JPSDJ",
      "name": "Sendai, Miyagi",
      "country": "JP",
      "lat": 38.133333,
      "lon": 140.916667
    },
    {
      "code": "JPSDU",
      "name": "Sodegaura",
      "country": "JP",
      "lat": 35.43,
      "lon": 139.954417
    },
    {
      "code": "JPSHS",
      "name": "Shimonoseki",
      "country": "JP",
      "lat": 33.933333,
      "lon": 130.933333
    },
    {
      "code": "JPSKD",
      "name": "Sakaide",
      "country": "JP",
      "lat": 34.333333,
      "lon": 133.85
    },
    {
      "code": "JPSKM",
      "name": "Shikama",
      "country": "JP",
      "lat": 34.800111,
      "lon": 134.665806
    },
    {
      "code": "JPSKT",
      "name": "Sakata",
      "country": "JP",
      "lat": 38.933333,
      "lon": 139.816667
    },
    {
      "code": "JPSMT",
      "name": "Shimotsu",
      "country": "JP",
      "lat": 34.125361,
      "lon": 135.155944
    },
    {
      "code": "JPSMZ",
      "name": "Shimizu",
      "country": "JP",
      "lat": 35.016667,
      "lon": 138.5
    },
    {
      "code": "JPSOM",
      "name": "Soma",
      "country": "JP",
      "lat": 37.783333,
      "lon": 140.916667
    },
    {
      "code": "JPSSB",
      "name": "Sasebo",
      "country": "JP",
      "lat": 33.166667,
      "lon": 129.716667
    },
    {
      "code": "JPSUZ",
      "name": "Susaki",
      "country": "JP",
      "lat": 33.383333,
      "lon": 133.3
    },
    {
      "code": "JPTBN",
      "name": "Tachibana",
      "country": "JP",
      "lat": 33.866667,
      "lon": 134.666667
    },
    {
      "code": "JPTBT",
      "name": "Tobata/Kitakyushu",
      "country": "JP",
      "lat": 33.883333,
      "lon": 130.833333
    },
    {
      "code": "JPTHR",
      "name": "Takehara",
      "country": "JP",
      "lat": 34.34175,
      "lon": 132.906917
    },
    {
      "code": "JPTKA",
      "name": "Tokai",
      "country": "JP",
      "lat": 35.023056,
      "lon": 136.902194
    },
    {
      "code": "JPTKY",
      "name": "Tokuyama",
      "country": "JP",
      "lat": 34.033333,
      "lon": 131.816667
    },
    {
      "code": "JPTMI",
      "name": "Tsukumi",
      "country": "JP",
      "lat": 33.083333,
      "lon": 131.866667
    },
    {
      "code": "JPTMK",
      "name": "Tomakomai",
      "country": "JP",
      "lat": 42.633333,
      "lon": 141.633333
    },
    {
      "code": "JPTND",
      "name": "Tonda",
      "country": "JP",
      "lat": 34.033333,
      "lon": 131.75
    },
    {
      "code": "JPTOK",
      "name": "Tokachi",
      "country": "JP",
      "lat": 42.25,
      "lon": 143.3
    },
    {
      "code": "JPTOS",
      "name": "Toyamashinko",
      "country": "JP",
      "lat": 36.760833,
      "lon": 137.192778
    },
    {
      "code": "JPTRG",
      "name": "Tsuruga",
      "country": "JP",
      "lat": 35.65,
      "lon": 136.066667
    },
    {
      "code": "JPTYO",
      "name": "Tokyo",
      "country": "JP",
      "lat": 35.683333,
      "lon": 139.75
    },
    {
      "code": "JPUBJ",
      "name": "Ube",
      "country": "JP",
      "lat": 33.933333,
      "lon": 131.233333
    },
    {
      "code": "JPUKB",
      "name": "Kobe",
      "country": "JP",
      "lat": 34.683333,
      "lon": 135.166667
    },
    {
      "code": "JPUSK",
      "name": "Usuki",
      "country": "JP",
      "lat": 33.126111,
      "lon": 131.80525
    },
    {
      "code": "JPYAN",
      "name": "Yanai",
      "country": "JP",
      "lat": 33.95,
      "lon": 132.133333
    },
    {
      "code": "JPYKK",
      "name": "Yokkaichi",
      "country": "JP",
      "lat": 34.966667,
      "lon": 136.633333
    },
    {
      "code": "JPYOK",
      "name": "Yokohama",
      "country": "JP",
      "lat": 35.45,
      "lon": 139.65
    },
    {
      "code": "JPYOS",
      "name": "Yokosuka",
      "country": "JP",
      "lat": 35.283333,
      "lon": 139.666667
    },
    {
      "code": "JPYWT",
      "name": "Yawata/Kitakyushu",
      "country": "JP",
      "lat": 33.85,
      "lon": 130.8
    },
    {
      "code": "KEMBA",
      "name": "Mombasa",
      "country": "KE",
      "lat": -4.066667,
      "lon": 39.666667
    },
    {
      "code": "KHKOS",
      "name": "Kampong Saom",
      "country": "KH",
      "lat": 10.6,
      "lon": 103.516667
    },
    {
      "code": "KMYVA",
      "name": "Moroni",
      "country": "KM",
      "lat": -11.7,
      "lon": 43.25
    },
    {
      "code": "KPGEN",
      "name": "Gensan",
      "country": "KP",
      "lat": 39.166667,
      "lon": 127.45
    },
    {
      "code": "KRBOR",
      "name": "Boryeong",
      "country": "KR",
      "lat": 36.316667,
      "lon": 126.5
    },
    {
      "code": "KRDBL",
      "name": "Daebul/Yeongam-gun",
      "country": "KR",
      "lat": 34.75,
      "lon": 126.433333
    },
    {
      "code": "KRGSO",
      "name": "Goseong-gun",
      "country": "KR",
      "lat": 34.966667,
      "lon": 128.316667
    },
    {
      "code": "KRINC",
      "name": "Incheon",
      "country": "KR",
      "lat": 37.45,
      "lon": 126.616667
    },
    {
      "code": "KRKAN",
      "name": "Gwangyang",
      "country": "KR",
      "lat": 34.933333,
      "lon": 127.7
    },
    {
      "code": "KRKJE",
      "name": "Geoje",
      "country": "KR",
      "lat": 34.85,
      "lon": 128.583333
    },
    {
      "code": "KRKPO",
      "name": "Pohang",
      "country": "KR",
      "lat": 36.033333,
      "lon": 129.366667
    },
    {
      "code": "KRKUV",
      "name": "Gunsan",
      "country": "KR",
      "lat": 35.983333,
      "lon": 126.716667
    },
    {
      "code": "KRKWA",
      "name": "Kwangyang",
      "country": "KR",
      "lat": 33.5,
      "lon": 126.533333
    },
    {
      "code": "KRMAS",
      "name": "Masan",
      "country": "KR",
      "lat": 35.2,
      "lon": 128.566667
    },
    {
      "code": "KRMIP",
      "name": "Mipo/Ulsan",
      "country": "KR",
      "lat": 35.516667,
      "lon": 129.433333
    },
    {
      "code": "KRMOK",
      "name": "Mokpo",
      "country": "KR",
      "lat": 34.8,
      "lon": 126.383333
    },
    {
      "code": "KRMUK",
      "name": "Mukho/Donghae",
      "country": "KR",
      "lat": 37.533333,
      "lon": 129.1
    },
    {
      "code": "KROKK",
      "name": "Okgye/Gangneung",
      "country": "KR",
      "lat": 37.6,
      "lon": 129.033333
    },
    {
      "code": "KROKP",
      "name": "Okpo/Geoje",
      "country": "KR",
      "lat": 34.883333,
      "lon": 128.7
    },
    {
      "code": "KRONS",
      "name": "Onsan/Ulsan",
      "country": "KR",
      "lat": 35.433333,
      "lon": 129.35
    },
    {
      "code": "KRPTK",
      "name": "Pyeongtaek",
      "country": "KR",
      "lat": 36.966667,
      "lon": 127.1
    },
    {
      "code": "KRPUS",
      "name": "Busan",
      "country": "KR",
      "lat": 35.133333,
      "lon": 129.05
    },
    {
      "code": "KRSCP",
      "name": "Samcheonpo/Sacheon",
      "country": "KR",
      "lat": 34.916667,
      "lon": 128.066667
    },
    {
      "code": "KRSUK",
      "name": "Samcheok",
      "country": "KR",
      "lat": 37.433333,
      "lon": 129.183333
    },
    {
      "code": "KRTAN",
      "name": "Taean-gun",
      "country": "KR",
      "lat": 36.716667,
      "lon": 126.266667
    },
    {
      "code": "KRTGH",
      "name": "Donghae",
      "country": "KR",
      "lat": 37.483333,
      "lon": 129.116667
    },
    {
      "code": "KRTJI",
      "name": "Dangjin",
      "country": "KR",
      "lat": 36.966667,
      "lon": 126.783333
    },
    {
      "code": "KRTSN",
      "name": "Daesan/Seosan",
      "country": "KR",
      "lat": 37,
      "lon": 126.366667
    },
    {
      "code": "KRTYG",
      "name": "Tongyeong",
      "country": "KR",
      "lat": 34.833333,
      "lon": 128.416667
    },
    {
      "code": "KRUSN",
      "name": "Ulsan",
      "country": "KR",
      "lat": 35.533333,
      "lon": 129.316667
    },
    {
      "code": "KRYOS",
      "name": "Yeosu",
      "country": "KR",
      "lat": 34.75,
      "lon": 127.716667
    },
    {
      "code": "KWKWI",
      "name": "Kuwait",
      "country": "KW",
      "lat": 29.35,
      "lon": 47.933333
    },
    {
      "code": "KWMEA",
      "name": "Mina' al Ahmadi",
      "country": "KW",
      "lat": 29.066667,
      "lon": 48.15
    },
    {
      "code": "KWMZR",
      "name": "Mina Al Zour",
      "country": "KW",
      "lat": 28.716667,
      "lon": 48.4
    },
    {
      "code": "LBBEY",
      "name": "Beirut",
      "country": "LB",
      "lat": 33.833333,
      "lon": 35.483333
    },
    {
      "code": "LBCHK",
      "name": "Chekka",
      "country": "LB",
      "lat": 34.32889,
      "lon": 35.74444
    },
    {
      "code": "LBJIE",
      "name": "Jieh",
      "country": "LB",
      "lat": 33.67006,
      "lon": 35.4253
    },
    {
      "code": "LBKYE",
      "name": "Tripoli",
      "country": "LB",
      "lat": 34.45,
      "lon": 35.833333
    },
    {
      "code": "LBZHR",
      "name": "Zahrani Terminal",
      "country": "LB",
      "lat": 33.533333,
      "lon": 35.316667
    },
    {
      "code": "LBZUK",
      "name": "Zouk",
      "country": "LB",
      "lat": 33.966667,
      "lon": 35.633333
    },
    {
      "code": "LCCAS",
      "name": "Castries",
      "country": "LC",
      "lat": 14.016667,
      "lon": -60.966667
    },
    {
      "code": "LCCDS",
      "name": "Cul de Sac",
      "country": "LC",
      "lat": 13.983333,
      "lon": -61.016667
    },
    {
      "code": "LCVIF",
      "name": "Vieux Fort",
      "country": "LC",
      "lat": 13.716667,
      "lon": -60.966667
    },
    {
      "code": "LKCMB",
      "name": "Colombo",
      "country": "LK",
      "lat": 6.916667,
      "lon": 79.85
    },
    {
      "code": "LKGAL",
      "name": "Galle",
      "country": "LK",
      "lat": 6.033056,
      "lon": 80.228333
    },
    {
      "code": "LKHBA",
      "name": "Hambantota",
      "country": "LK",
      "lat": 6.116667,
      "lon": 81.116667
    },
    {
      "code": "LKTRR",
      "name": "Trincomalee",
      "country": "LK",
      "lat": 8.55,
      "lon": 81.216667
    },
    {
      "code": "LRGRE",
      "name": "Greenville",
      "country": "LR",
      "lat": 4.983333,
      "lon": -9.05
    },
    {
      "code": "LRMLW",
      "name": "Monrovia",
      "country": "LR",
      "lat": 6.3,
      "lon": -10.8
    },
    {
      "code": "LRUCN",
      "name": "Buchanan",
      "country": "LR",
      "lat": 5.866667,
      "lon": -10.066667
    },
    {
      "code": "LTKLJ",
      "name": "Klaipeda",
      "country": "LT",
      "lat": 55.716667,
      "lon": 21.116667
    },
    {
      "code": "LVLPX",
      "name": "Liepaja",
      "country": "LV",
      "lat": 56.516667,
      "lon": 21.016667
    },
    {
      "code": "LVRIX",
      "name": "Riga",
      "country": "LV",
      "lat": 56.95,
      "lon": 24.1
    },
    {
      "code": "LVVNT",
      "name": "Ventspils",
      "country": "LV",
      "lat": 57.4,
      "lon": 21.533333
    },
    {
      "code": "LYLMQ",
      "name": "Marsa Brega",
      "country": "LY",
      "lat": 30.378099,
      "lon": 19.576401
    },
    {
      "code": "LYMRA",
      "name": "Misurata",
      "country": "LY",
      "lat": 32.37535,
      "lon": 15.09254
    },
    {
      "code": "MAAGA",
      "name": "Agadir",
      "country": "MA",
      "lat": 30.433333,
      "lon": -9.633333
    },
    {
      "code": "MACAS",
      "name": "Casablanca",
      "country": "MA",
      "lat": 33.583333,
      "lon": -7.6
    },
    {
      "code": "MAEUN",
      "name": "Laayoune (El Aaiun)",
      "country": "MA",
      "lat": 27.083333,
      "lon": -13.433333
    },
    {
      "code": "MAJFL",
      "name": "Jorf Lasfar",
      "country": "MA",
      "lat": 33.116667,
      "lon": -8.616667
    },
    {
      "code": "MAMOH",
      "name": "Mohammedia",
      "country": "MA",
      "lat": 33.716667,
      "lon": -7.4
    },
    {
      "code": "MANDR",
      "name": "Nador",
      "country": "MA",
      "lat": 35.283333,
      "lon": -2.933333
    },
    {
      "code": "MAPTM",
      "name": "Tanger Med",
      "country": "MA",
      "lat": 35.9,
      "lon": -5.516667
    },
    {
      "code": "MASFI",
      "name": "Safi",
      "country": "MA",
      "lat": 32.3,
      "lon": -9.25
    },
    {
      "code": "MATNG",
      "name": "Tangier",
      "country": "MA",
      "lat": 35.783333,
      "lon": -5.816667
    },
    {
      "code": "MEBAR",
      "name": "Bar",
      "country": "ME",
      "lat": 42.083333,
      "lon": 19.083333
    },
    {
      "code": "MGEHL",
      "name": "Ehoala",
      "country": "MG",
      "lat": -25.066667,
      "lon": 46.95
    },
    {
      "code": "MGNOS",
      "name": "Nosy-Be",
      "country": "MG",
      "lat": -13.333333,
      "lon": 48.25
    },
    {
      "code": "MGTMM",
      "name": "Tamatave (Toamasina)",
      "country": "MG",
      "lat": -18.113537,
      "lon": 49.392262
    },
    {
      "code": "MGTOA",
      "name": "Toamasina",
      "country": "MG",
      "lat": -18.166667,
      "lon": 49.416667
    },
    {
      "code": "MMRGN",
      "name": "Yangon",
      "country": "MM",
      "lat": 16.766667,
      "lon": 96.166667
    },
    {
      "code": "MPROP",
      "name": "Rota",
      "country": "MP",
      "lat": 14.133333,
      "lon": 145.15
    },
    {
      "code": "MPSPN",
      "name": "Saipan",
      "country": "MP",
      "lat": 15.2,
      "lon": 145.683333
    },
    {
      "code": "MPTIQ",
      "name": "Tinian",
      "country": "MP",
      "lat": 14.966667,
      "lon": 145.616667
    },
    {
      "code": "MQFDF",
      "name": "Fort-de-France",
      "country": "MQ",
      "lat": 14.6,
      "lon": -61.05
    },
    {
      "code": "MRNDB",
      "name": "Nouadhibou",
      "country": "MR",
      "lat": 20.916667,
      "lon": -17.05
    },
    {
      "code": "MRNKC",
      "name": "Nouakchott",
      "country": "MR",
      "lat": 18.033333,
      "lon": -16.033333
    },
    {
      "code": "MTDIS",
      "name": "Malta Freeport Distripark",
      "country": "MT",
      "lat": 35.833333,
      "lon": 14.533333
    },
    {
      "code": "MTMAR",
      "name": "Marsaxlokk",
      "country": "MT",
      "lat": 35.833333,
      "lon": 14.533333
    },
    {
      "code": "MTMLA",
      "name": "Valletta",
      "country": "MT",
      "lat": 35.883333,
      "lon": 14.5
    },
    {
      "code": "MUPLU",
      "name": "Port Louis",
      "country": "MU",
      "lat": -20.15,
      "lon": 57.5
    },
    {
      "code": "MVMLE",
      "name": "Male",
      "country": "MV",
      "lat": 4.166667,
      "lon": 73.5
    },
    {
      "code": "MXATM",
      "name": "Altamira",
      "country": "MX",
      "lat": 22.4,
      "lon": -97.916667
    },
    {
      "code": "MXCOA",
      "name": "Coatzacoalcos",
      "country": "MX",
      "lat": 18.133333,
      "lon": -94.4
    },
    {
      "code": "MXDBT",
      "name": "Dos Bocas Terminal",
      "country": "MX",
      "lat": 18.5,
      "lon": -93.183333
    },
    {
      "code": "MXESE",
      "name": "Ensenada",
      "country": "MX",
      "lat": 31.85,
      "lon": -116.6
    },
    {
      "code": "MXGYM",
      "name": "Guaymas",
      "country": "MX",
      "lat": 27.916667,
      "lon": -110.883333
    },
    {
      "code": "MXLAP",
      "name": "La Paz",
      "country": "MX",
      "lat": 24.133333,
      "lon": -110.3
    },
    {
      "code": "MXLZC",
      "name": "Lazaro Cardenas",
      "country": "MX",
      "lat": 17.95,
      "lon": -102.183333
    },
    {
      "code": "MXMZT",
      "name": "Mazatlan",
      "country": "MX",
      "lat": 23.4,
      "lon": -106.4
    },
    {
      "code": "MXPAJ",
      "name": "Pajaritos",
      "country": "MX",
      "lat": 18.116667,
      "lon": -94.383333
    },
    {
      "code": "MXPGO",
      "name": "Progreso",
      "country": "MX",
      "lat": 21.266667,
      "lon": -89.65
    },
    {
      "code": "MXPMD",
      "name": "Puerto Madero",
      "country": "MX",
      "lat": 14.716667,
      "lon": -92.416667
    },
    {
      "code": "MXRST",
      "name": "Rosarito Terminal",
      "country": "MX",
      "lat": 32.333333,
      "lon": -117.1
    },
    {
      "code": "MXSRL",
      "name": "Santa Rosalia",
      "country": "MX",
      "lat": 27.333333,
      "lon": -112.283333
    },
    {
      "code": "MXTAM",
      "name": "Tampico",
      "country": "MX",
      "lat": 22.25,
      "lon": -97.866667
    },
    {
      "code": "MXTPB",
      "name": "Topolobampo",
      "country": "MX",
      "lat": 25.6,
      "lon": -109.05
    },
    {
      "code": "MXTUX",
      "name": "Tuxpan",
      "country": "MX",
      "lat": 20.95,
      "lon": -97.4
    },
    {
      "code": "MXVER",
      "name": "Veracruz",
      "country": "MX",
      "lat": 19.2,
      "lon": -96.083333
    },
    {
      "code": "MXZLO",
      "name": "Manzanillo",
      "country": "MX",
      "lat": 19.05,
      "lon": -104.3
    },
    {
      "code": "MYBKI",
      "name": "Kota Kinabalu, Sabah",
      "country": "MY",
      "lat": 5.966667,
      "lon": 116.066667
    },
    {
      "code": "MYBTU",
      "name": "Bintulu, Sarawak",
      "country": "MY",
      "lat": 3.266667,
      "lon": 113.066667
    },
    {
      "code": "MYBWH",
      "name": "Bagan Luar (Butterworth)",
      "country": "MY",
      "lat": 5.4,
      "lon": 100.366667
    },
    {
      "code": "MYKAP",
      "name": "Kapar",
      "country": "MY",
      "lat": 3.133333,
      "lon": 101.366667
    },
    {
      "code": "MYKET",
      "name": "Kertih",
      "country": "MY",
      "lat": 4.516667,
      "lon": 103.45
    },
    {
      "code": "MYKUA",
      "name": "Kuantan (Tanjong Gelang)",
      "country": "MY",
      "lat": 3.966667,
      "lon": 103.433333
    },
    {
      "code": "MYLBU",
      "name": "Labuan, Sabah",
      "country": "MY",
      "lat": 5.3,
      "lon": 115.22
    },
    {
      "code": "MYLDU",
      "name": "Lahad Datu, Sabah",
      "country": "MY",
      "lat": 5.016667,
      "lon": 118.316667
    },
    {
      "code": "MYLUM",
      "name": "Lumut",
      "country": "MY",
      "lat": 4.233333,
      "lon": 100.633333
    },
    {
      "code": "MYMKZ",
      "name": "Malacca",
      "country": "MY",
      "lat": 2.188889,
      "lon": 102.251111
    },
    {
      "code": "MYPDI",
      "name": "Port Dickson",
      "country": "MY",
      "lat": 2.533333,
      "lon": 101.783333
    },
    {
      "code": "MYPEN",
      "name": "Penang (Georgetown)",
      "country": "MY",
      "lat": 5.416667,
      "lon": 100.316667
    },
    {
      "code": "MYPGG",
      "name": "Pengerang",
      "country": "MY",
      "lat": 1.366667,
      "lon": 104.116667
    },
    {
      "code": "MYPGU",
      "name": "Pasir Gudang, Johor",
      "country": "MY",
      "lat": 1.45,
      "lon": 103.89
    },
    {
      "code": "MYPKG",
      "name": "Port Klang (Pelabuhan Klang)",
      "country": "MY",
      "lat": 3,
      "lon": 101.4
    },
    {
      "code": "MYSDK",
      "name": "Sandakan, Sabah",
      "country": "MY",
      "lat": 5.833333,
      "lon": 118.116667
    },
    {
      "code": "MYSIP",
      "name": "Samalaju",
      "country": "MY",
      "lat": 3.95,
      "lon": 113.533333
    },
    {
      "code": "MYTBI",
      "name": "Tanjong Bin",
      "country": "MY",
      "lat": 1.333333,
      "lon": 103.55
    },
    {
      "code": "MYTPP",
      "name": "Tanjung Pelepas",
      "country": "MY",
      "lat": 1.366667,
      "lon": 103.55
    },
    {
      "code": "MYTRB",
      "name": "Teluk Rubiah",
      "country": "MY",
      "lat": 4.167431,
      "lon": 100.618585
    },
    {
      "code": "MYTWU",
      "name": "Tawau, Sabah",
      "country": "MY",
      "lat": 4.25,
      "lon": 117.883333
    },
    {
      "code": "MYXPQ",
      "name": "Port Klang (Ferry Port)",
      "country": "MY",
      "lat": 3.016667,
      "lon": 101.366667
    },
    {
      "code": "MZBEW",
      "name": "Beira",
      "country": "MZ",
      "lat": -19.833333,
      "lon": 34.833333
    },
    {
      "code": "MZMAT",
      "name": "Matola",
      "country": "MZ",
      "lat": -25.966667,
      "lon": 32.466667
    },
    {
      "code": "MZMNC",
      "name": "Nacala",
      "country": "MZ",
      "lat": -14.533333,
      "lon": 40.666667
    },
    {
      "code": "MZMPM",
      "name": "Maputo",
      "country": "MZ",
      "lat": -25.962778,
      "lon": 32.544722
    },
    {
      "code": "MZMZB",
      "name": "Mocimboa da Praia",
      "country": "MZ",
      "lat": -11.333333,
      "lon": 40.35
    },
    {
      "code": "MZPOL",
      "name": "Pemba",
      "country": "MZ",
      "lat": -12.966667,
      "lon": 40.5
    },
    {
      "code": "MZUEL",
      "name": "Quelimane",
      "country": "MZ",
      "lat": -17.883333,
      "lon": 36.883333
    },
    {
      "code": "NALUD",
      "name": "Luderitz",
      "country": "NA",
      "lat": -26.65,
      "lon": 15.166667
    },
    {
      "code": "NAWVB",
      "name": "Walvis Bay",
      "country": "NA",
      "lat": -22.95,
      "lon": 14.5
    },
    {
      "code": "NCNEP",
      "name": "Nepoui",
      "country": "NC",
      "lat": -21.316667,
      "lon": 165
    },
    {
      "code": "NCNOU",
      "name": "Noumea",
      "country": "NC",
      "lat": -22.266667,
      "lon": 166.45
    },
    {
      "code": "NGAPP",
      "name": "Apapa",
      "country": "NG",
      "lat": 6.437371,
      "lon": 3.393122
    },
    {
      "code": "NGBON",
      "name": "Bonny",
      "country": "NG",
      "lat": 4.4516,
      "lon": 7.17074
    },
    {
      "code": "NGCBQ",
      "name": "Calabar",
      "country": "NG",
      "lat": 4.966667,
      "lon": 8.316667
    },
    {
      "code": "NGESC",
      "name": "Escravos",
      "country": "NG",
      "lat": 5.5,
      "lon": 5
    },
    {
      "code": "NGKOK",
      "name": "Koko",
      "country": "NG",
      "lat": 6,
      "lon": 5.466667
    },
    {
      "code": "NGLKK",
      "name": "Ibeju - Lekki",
      "country": "NG",
      "lat": 6.433333,
      "lon": 4
    },
    {
      "code": "NGLOS",
      "name": "Lagos",
      "country": "NG",
      "lat": 6.4,
      "lon": 3.4
    },
    {
      "code": "NGOGH",
      "name": "Oghara",
      "country": "NG",
      "lat": 5.583333,
      "lon": 6.1
    },
    {
      "code": "NGONN",
      "name": "Onne",
      "country": "NG",
      "lat": 4.716667,
      "lon": 7.15
    },
    {
      "code": "NGPHC",
      "name": "Port Harcourt",
      "country": "NG",
      "lat": 4.766667,
      "lon": 7
    },
    {
      "code": "NGTIN",
      "name": "Tincan/Lagos",
      "country": "NG",
      "lat": 6.434439,
      "lon": 3.348686
    },
    {
      "code": "NGWAR",
      "name": "Warri",
      "country": "NG",
      "lat": 5.516667,
      "lon": 5.733333
    },
    {
      "code": "NICIO",
      "name": "Corinto",
      "country": "NI",
      "lat": 12.483333,
      "lon": -87.166667
    },
    {
      "code": "NIPSN",
      "name": "Puerto Sandino",
      "country": "NI",
      "lat": 12.183333,
      "lon": -86.75
    },
    {
      "code": "NLAMS",
      "name": "Amsterdam",
      "country": "NL",
      "lat": 52.4,
      "lon": 4.816667
    },
    {
      "code": "NLBON",
      "name": "Born",
      "country": "NL",
      "lat": 51.033333,
      "lon": 5.816667
    },
    {
      "code": "NLBOR",
      "name": "Borssele",
      "country": "NL",
      "lat": 51.416667,
      "lon": 3.716667
    },
    {
      "code": "NLBUD",
      "name": "Budel",
      "country": "NL",
      "lat": 51.2725,
      "lon": 5.5744
    },
    {
      "code": "NLCUY",
      "name": "Cuijk",
      "country": "NL",
      "lat": 51.733333,
      "lon": 5.883333
    },
    {
      "code": "NLDOR",
      "name": "Dordrecht",
      "country": "NL",
      "lat": 51.783333,
      "lon": 4.633333
    },
    {
      "code": "NLDRU",
      "name": "Druten",
      "country": "NL",
      "lat": 51.8889,
      "lon": 5.6044
    },
    {
      "code": "NLDZL",
      "name": "Delfzijl",
      "country": "NL",
      "lat": 52.516667,
      "lon": 6.933333
    },
    {
      "code": "NLEEM",
      "name": "Eemshaven",
      "country": "NL",
      "lat": 53.45,
      "lon": 6.833333
    },
    {
      "code": "NLEUR",
      "name": "Europoort",
      "country": "NL",
      "lat": 51.95,
      "lon": 4.116667
    },
    {
      "code": "NLIJM",
      "name": "IJmuiden/Velsen",
      "country": "NL",
      "lat": 52.466667,
      "lon": 4.6
    },
    {
      "code": "NLMOE",
      "name": "Moerdijk",
      "country": "NL",
      "lat": 51.683333,
      "lon": 4.566667
    },
    {
      "code": "NLRAS",
      "name": "Ravenstein",
      "country": "NL",
      "lat": 51.797022,
      "lon": 5.651578
    },
    {
      "code": "NLRTM",
      "name": "Rotterdam",
      "country": "NL",
      "lat": 51.916667,
      "lon": 4.5
    },
    {
      "code": "NLSLU",
      "name": "Sluiskil",
      "country": "NL",
      "lat": 51.283333,
      "lon": 3.833333
    },
    {
      "code": "NLTHO",
      "name": "Tholen",
      "country": "NL",
      "lat": 51.53167,
      "lon": 4.22083
    },
    {
      "code": "NLTIE",
      "name": "Tiel",
      "country": "NL",
      "lat": 51.88667,
      "lon": 5.42917
    },
    {
      "code": "NLTNZ",
      "name": "Terneuzen",
      "country": "NL",
      "lat": 51.466667,
      "lon": 3.816667
    },
    {
      "code": "NLVKR",
      "name": "Volkerak",
      "country": "NL",
      "lat": 51.666667,
      "lon": 4.283333
    },
    {
      "code": "NLVLI",
      "name": "Vlissingen",
      "country": "NL",
      "lat": 51.45,
      "lon": 3.7
    },
    {
      "code": "NLZWI",
      "name": "Zwijndrecht",
      "country": "NL",
      "lat": 51.82399,
      "lon": 4.61258
    },
    {
      "code": "NOAES",
      "name": "Alesund",
      "country": "NO",
      "lat": 62.466667,
      "lon": 6.15
    },
    {
      "code": "NOARD",
      "name": "Ardalstangen",
      "country": "NO",
      "lat": 61.233333,
      "lon": 7.7
    },
    {
      "code": "NOARE",
      "name": "Arendal",
      "country": "NO",
      "lat": 58.45,
      "lon": 8.766667
    },
    {
      "code": "NOAVE",
      "name": "Averoy",
      "country": "NO",
      "lat": 63.05,
      "lon": 7.666667
    },
    {
      "code": "NOBGO",
      "name": "Bergen",
      "country": "NO",
      "lat": 60.383333,
      "lon": 5.316667
    },
    {
      "code": "NOBOE",
      "name": "Boneset - Karmoy",
      "country": "NO",
      "lat": 59.366667,
      "lon": 5.283333
    },
    {
      "code": "NOBVK",
      "name": "Brevik",
      "country": "NO",
      "lat": 59.05,
      "lon": 9.7
    },
    {
      "code": "NOELN",
      "name": "Elnesvagen",
      "country": "NO",
      "lat": 62.85,
      "lon": 7.133333
    },
    {
      "code": "NOFAN",
      "name": "Farsund",
      "country": "NO",
      "lat": 58.083333,
      "lon": 6.8
    },
    {
      "code": "NOFRK",
      "name": "Fredrikstad",
      "country": "NO",
      "lat": 59.2,
      "lon": 10.916667
    },
    {
      "code": "NOFRO",
      "name": "Floro",
      "country": "NO",
      "lat": 61.6,
      "lon": 5.016667
    },
    {
      "code": "NOGLO",
      "name": "Glomfjord",
      "country": "NO",
      "lat": 66.8,
      "lon": 13.933333
    },
    {
      "code": "NOHAU",
      "name": "Haugesund",
      "country": "NO",
      "lat": 59.4,
      "lon": 5.25
    },
    {
      "code": "NOHFT",
      "name": "Hammerfest",
      "country": "NO",
      "lat": 70.65,
      "lon": 23.666667
    },
    {
      "code": "NOHRD",
      "name": "Harstad",
      "country": "NO",
      "lat": 68.783333,
      "lon": 16.533333
    },
    {
      "code": "NOHRY",
      "name": "Heroya",
      "country": "NO",
      "lat": 59.116667,
      "lon": 9.616667
    },
    {
      "code": "NOHSO",
      "name": "Husoy - Karmoy",
      "country": "NO",
      "lat": 59.333333,
      "lon": 5.3
    },
    {
      "code": "NOHVG",
      "name": "Honningsvag",
      "country": "NO",
      "lat": 70.966667,
      "lon": 25.966667
    },
    {
      "code": "NOKAR",
      "name": "Karsto",
      "country": "NO",
      "lat": 59.266667,
      "lon": 5.516667
    },
    {
      "code": "NOKSU",
      "name": "Kristiansund",
      "country": "NO",
      "lat": 63.1,
      "lon": 7.733333
    },
    {
      "code": "NOKVD",
      "name": "Kvinesdal",
      "country": "NO",
      "lat": 58.31215,
      "lon": 6.96187
    },
    {
      "code": "NOMJF",
      "name": "Mosjoen",
      "country": "NO",
      "lat": 65.833333,
      "lon": 13.2
    },
    {
      "code": "NOMON",
      "name": "Mongstad",
      "country": "NO",
      "lat": 60.816667,
      "lon": 5.016667
    },
    {
      "code": "NOMQN",
      "name": "Mo i Rana",
      "country": "NO",
      "lat": 66.316667,
      "lon": 14.133333
    },
    {
      "code": "NONVK",
      "name": "Narvik",
      "country": "NO",
      "lat": 68.416667,
      "lon": 17.416667
    },
    {
      "code": "NOOSL",
      "name": "Oslo",
      "country": "NO",
      "lat": 59.9,
      "lon": 10.733333
    },
    {
      "code": "NOOSY",
      "name": "Namsos",
      "country": "NO",
      "lat": 64.45,
      "lon": 11.5
    },
    {
      "code": "NORAF",
      "name": "Rafnes",
      "country": "NO",
      "lat": 59.1,
      "lon": 9.566667
    },
    {
      "code": "NORIV",
      "name": "Risavika",
      "country": "NO",
      "lat": 58.933333,
      "lon": 5.6
    },
    {
      "code": "NOSLG",
      "name": "Slagentangen",
      "country": "NO",
      "lat": 59.316667,
      "lon": 10.5
    },
    {
      "code": "NOSPG",
      "name": "Sarpsborg",
      "country": "NO",
      "lat": 59.266667,
      "lon": 11.1
    },
    {
      "code": "NOSTU",
      "name": "Stura",
      "country": "NO",
      "lat": 60.616667,
      "lon": 4.866667
    },
    {
      "code": "NOSUN",
      "name": "Sunndalsora",
      "country": "NO",
      "lat": 62.666667,
      "lon": 8.55
    },
    {
      "code": "NOSVG",
      "name": "Stavanger",
      "country": "NO",
      "lat": 58.966667,
      "lon": 5.75
    },
    {
      "code": "NOTBO",
      "name": "Tjeldbergodden",
      "country": "NO",
      "lat": 63.466667,
      "lon": 9
    },
    {
      "code": "NOTOS",
      "name": "Tromso",
      "country": "NO",
      "lat": 69.666667,
      "lon": 18.966667
    },
    {
      "code": "NOTRD",
      "name": "Trondheim",
      "country": "NO",
      "lat": 63.433333,
      "lon": 10.4
    },
    {
      "code": "NOVAE",
      "name": "Valsneset",
      "country": "NO",
      "lat": 63.816667,
      "lon": 9.633333
    },
    {
      "code": "NZBLU",
      "name": "Bluff",
      "country": "NZ",
      "lat": -46.6,
      "lon": 168.316667
    },
    {
      "code": "NZDUD",
      "name": "Dunedin",
      "country": "NZ",
      "lat": -45.866667,
      "lon": 170.5
    },
    {
      "code": "NZLYT",
      "name": "Lyttelton",
      "country": "NZ",
      "lat": -43.6,
      "lon": 172.716667
    },
    {
      "code": "NZMAP",
      "name": "Marsden Point",
      "country": "NZ",
      "lat": -35.833333,
      "lon": 174.5
    },
    {
      "code": "NZNPL",
      "name": "New Plymouth",
      "country": "NZ",
      "lat": -39.05,
      "lon": 174.016667
    },
    {
      "code": "NZTRG",
      "name": "Tauranga",
      "country": "NZ",
      "lat": -37.683333,
      "lon": 176.166667
    },
    {
      "code": "NZWRE",
      "name": "Whangarei",
      "country": "NZ",
      "lat": -35.833333,
      "lon": 174.483333
    },
    {
      "code": "OMDQM",
      "name": "Duqm",
      "country": "OM",
      "lat": 19.65,
      "lon": 57.7
    },
    {
      "code": "OMKHS",
      "name": "Khasab",
      "country": "OM",
      "lat": 26.216667,
      "lon": 56.233333
    },
    {
      "code": "OMQAL",
      "name": "Qalhat",
      "country": "OM",
      "lat": 22.683333,
      "lon": 59.4
    },
    {
      "code": "OMSLL",
      "name": "Salalah",
      "country": "OM",
      "lat": 16.951111,
      "lon": 54.029167
    },
    {
      "code": "OMSOH",
      "name": "Sohar",
      "country": "OM",
      "lat": 24.516667,
      "lon": 56.633333
    },
    {
      "code": "PABLB",
      "name": "Balboa",
      "country": "PA",
      "lat": 8.95,
      "lon": -79.566667
    },
    {
      "code": "PACHG",
      "name": "Chiriqui Grande",
      "country": "PA",
      "lat": 8.95,
      "lon": -82.116667
    },
    {
      "code": "PACTB",
      "name": "Cristobal",
      "country": "PA",
      "lat": 9.35,
      "lon": -79.9
    },
    {
      "code": "PAONX",
      "name": "Colon",
      "country": "PA",
      "lat": 9.35,
      "lon": -79.866667
    },
    {
      "code": "PAPBM",
      "name": "Bahia Las Minas",
      "country": "PA",
      "lat": 9.4,
      "lon": -79.833333
    },
    {
      "code": "PAPTY",
      "name": "Panama, Ciudad de",
      "country": "PA",
      "lat": 8.966667,
      "lon": -79.533333
    },
    {
      "code": "PATBG",
      "name": "Taboguilla",
      "country": "PA",
      "lat": 8.8,
      "lon": -79.5
    },
    {
      "code": "PECHM",
      "name": "Chimbote",
      "country": "PE",
      "lat": -9.083333,
      "lon": -78.616667
    },
    {
      "code": "PECHY",
      "name": "Chancay",
      "country": "PE",
      "lat": -11.566667,
      "lon": -77.266667
    },
    {
      "code": "PECLL",
      "name": "Callao",
      "country": "PE",
      "lat": -12.05,
      "lon": -77.133333
    },
    {
      "code": "PECON",
      "name": "Conchan",
      "country": "PE",
      "lat": -6.416667,
      "lon": -78.666667
    },
    {
      "code": "PEEEN",
      "name": "Eten",
      "country": "PE",
      "lat": -6.90806,
      "lon": -79.86417
    },
    {
      "code": "PELPP",
      "name": "La Pampilla",
      "country": "PE",
      "lat": -11.933333,
      "lon": -77.133333
    },
    {
      "code": "PEMLQ",
      "name": "Mollendo",
      "country": "PE",
      "lat": -17.016667,
      "lon": -72.016667
    },
    {
      "code": "PEMRI",
      "name": "Matarani",
      "country": "PE",
      "lat": -17,
      "lon": -72.106389
    },
    {
      "code": "PEPIO",
      "name": "Pisco",
      "country": "PE",
      "lat": -13.709981,
      "lon": -76.203206
    },
    {
      "code": "PEPLO",
      "name": "Punta Lobitos",
      "country": "PE",
      "lat": -10.083333,
      "lon": -78.183333
    },
    {
      "code": "PEPMC",
      "name": "Pampa Melchorita",
      "country": "PE",
      "lat": -13.2585,
      "lon": -76.313
    },
    {
      "code": "PEPUB",
      "name": "Bayovar",
      "country": "PE",
      "lat": -5.85,
      "lon": -81.066667
    },
    {
      "code": "PESNX",
      "name": "San Nicolas",
      "country": "PE",
      "lat": -15.266667,
      "lon": -75.233333
    },
    {
      "code": "PESVY",
      "name": "Salaverry",
      "country": "PE",
      "lat": -8.233333,
      "lon": -78.983333
    },
    {
      "code": "PETYL",
      "name": "Talara",
      "country": "PE",
      "lat": -4.583333,
      "lon": -81.283333
    },
    {
      "code": "PGLAE",
      "name": "Lae",
      "country": "PG",
      "lat": -6.733333,
      "lon": 147
    },
    {
      "code": "PGLNV",
      "name": "Lihir Island",
      "country": "PG",
      "lat": -3.162456,
      "lon": 152.578125
    },
    {
      "code": "PGPOM",
      "name": "Port Moresby",
      "country": "PG",
      "lat": -9.466667,
      "lon": 147.133333
    },
    {
      "code": "PGRAB",
      "name": "Rabaul",
      "country": "PG",
      "lat": -4.2,
      "lon": 152.183333
    },
    {
      "code": "PHAJU",
      "name": "Ajuy",
      "country": "PH",
      "lat": 11.166667,
      "lon": 123.033333
    },
    {
      "code": "PHBGS",
      "name": "Balingasag",
      "country": "PH",
      "lat": 8.75,
      "lon": 124.783333
    },
    {
      "code": "PHBTG",
      "name": "Batangas/Luzon",
      "country": "PH",
      "lat": 13.75,
      "lon": 121.05
    },
    {
      "code": "PHCEB",
      "name": "Cebu",
      "country": "PH",
      "lat": 10.293,
      "lon": 123.902
    },
    {
      "code": "PHCGY",
      "name": "Cagayan de Oro, Mindanao",
      "country": "PH",
      "lat": 8.5,
      "lon": 124.666667
    },
    {
      "code": "PHCLP",
      "name": "Calapan/Batangas",
      "country": "PH",
      "lat": 13.416667,
      "lon": 121.183333
    },
    {
      "code": "PHDNO",
      "name": "Danao",
      "country": "PH",
      "lat": 10.533333,
      "lon": 124.033333
    },
    {
      "code": "PHDVO",
      "name": "Davao, Mindanao",
      "country": "PH",
      "lat": 7.066667,
      "lon": 125.616667
    },
    {
      "code": "PHGES",
      "name": "General Santos",
      "country": "PH",
      "lat": 6.116667,
      "lon": 125.15
    },
    {
      "code": "PHGUN",
      "name": "Guiuan",
      "country": "PH",
      "lat": 11.033333,
      "lon": 125.716667
    },
    {
      "code": "PHILO",
      "name": "Iloilo, Panay",
      "country": "PH",
      "lat": 10.7,
      "lon": 122.583333
    },
    {
      "code": "PHLUG",
      "name": "Lugait",
      "country": "PH",
      "lat": 8.333333,
      "lon": 124.25
    },
    {
      "code": "PHMAU",
      "name": "Mauban",
      "country": "PH",
      "lat": 14.183333,
      "lon": 121.716667
    },
    {
      "code": "PHMNL",
      "name": "Manila",
      "country": "PH",
      "lat": 14.583333,
      "lon": 120.966667
    },
    {
      "code": "PHMSC",
      "name": "Masinloc/Sual",
      "country": "PH",
      "lat": 15.55,
      "lon": 119.95
    },
    {
      "code": "PHMVS",
      "name": "Mariveles, Luzon",
      "country": "PH",
      "lat": 14.433333,
      "lon": 120.483333
    },
    {
      "code": "PHMXI",
      "name": "Mati, Mindanao",
      "country": "PH",
      "lat": 6.95,
      "lon": 126.216667
    },
    {
      "code": "PHPGB",
      "name": "Pagbilao",
      "country": "PH",
      "lat": 13.966667,
      "lon": 121.683333
    },
    {
      "code": "PHPRO",
      "name": "Poro/San Fernando",
      "country": "PH",
      "lat": 11.96,
      "lon": 124.3325
    },
    {
      "code": "PHRTB",
      "name": "Rio Tuba",
      "country": "PH",
      "lat": 8.516667,
      "lon": 117.433333
    },
    {
      "code": "PHSFS",
      "name": "Subic Bay",
      "country": "PH",
      "lat": 14.8,
      "lon": 120.266667
    },
    {
      "code": "PHSUA",
      "name": "Sual",
      "country": "PH",
      "lat": 16.06682,
      "lon": 120.09414
    },
    {
      "code": "PHSUG",
      "name": "Surigao, Mindanao",
      "country": "PH",
      "lat": 9.783333,
      "lon": 125.5
    },
    {
      "code": "PHTGO",
      "name": "Tagoloan",
      "country": "PH",
      "lat": 8.533333,
      "lon": 124.75
    },
    {
      "code": "PHVNV",
      "name": "Villanueva",
      "country": "PH",
      "lat": 8.583333,
      "lon": 124.766667
    },
    {
      "code": "PKBQM",
      "name": "Muhammad Bin Qasim/Karachi",
      "country": "PK",
      "lat": 24.766667,
      "lon": 67.333333
    },
    {
      "code": "PKKHI",
      "name": "Karachi",
      "country": "PK",
      "lat": 24.783333,
      "lon": 66.983333
    },
    {
      "code": "PLGDN",
      "name": "Gdansk",
      "country": "PL",
      "lat": 54.35,
      "lon": 18.666667
    },
    {
      "code": "PLGDY",
      "name": "Gdynia",
      "country": "PL",
      "lat": 54.5,
      "lon": 18.55
    },
    {
      "code": "PLPLC",
      "name": "Police",
      "country": "PL",
      "lat": 53.566667,
      "lon": 14.566667
    },
    {
      "code": "PLSWI",
      "name": "Swinoujscie",
      "country": "PL",
      "lat": 53.9,
      "lon": 14.25
    },
    {
      "code": "PLSZZ",
      "name": "Szczecin",
      "country": "PL",
      "lat": 53.416667,
      "lon": 14.55
    },
    {
      "code": "PRGUY",
      "name": "Guayanilla",
      "country": "PR",
      "lat": 17.966667,
      "lon": -66.816667
    },
    {
      "code": "PRLAM",
      "name": "Las Mareas (Guayama)",
      "country": "PR",
      "lat": 17.925,
      "lon": -66.19
    },
    {
      "code": "PRPSE",
      "name": "Ponce",
      "country": "PR",
      "lat": 18.010833,
      "lon": -66.613611
    },
    {
      "code": "PRPYA",
      "name": "Puerto Yabucoa",
      "country": "PR",
      "lat": 18.05,
      "lon": -65.833333
    },
    {
      "code": "PRSJU",
      "name": "San Juan",
      "country": "PR",
      "lat": 18.45,
      "lon": -66.083333
    },
    {
      "code": "PTAVE",
      "name": "Aveiro",
      "country": "PT",
      "lat": 40.633333,
      "lon": -8.65
    },
    {
      "code": "PTCNL",
      "name": "Canical",
      "country": "PT",
      "lat": 32.733333,
      "lon": -16.733333
    },
    {
      "code": "PTFNC",
      "name": "Funchal, Madeira",
      "country": "PT",
      "lat": 32.633333,
      "lon": -16.9
    },
    {
      "code": "PTLEI",
      "name": "Leixoes",
      "country": "PT",
      "lat": 41.183333,
      "lon": -8.683333
    },
    {
      "code": "PTLIS",
      "name": "Lisboa",
      "country": "PT",
      "lat": 38.716667,
      "lon": -9.133333
    },
    {
      "code": "PTPDL",
      "name": "Ponta Delgada",
      "country": "PT",
      "lat": 37.733333,
      "lon": -25.666667
    },
    {
      "code": "PTPRV",
      "name": "Praia da Vitoria",
      "country": "PT",
      "lat": 38.733333,
      "lon": -27.066667
    },
    {
      "code": "PTSET",
      "name": "Setubal",
      "country": "PT",
      "lat": 38.533333,
      "lon": -8.9
    },
    {
      "code": "PTSIE",
      "name": "Sines",
      "country": "PT",
      "lat": 37.95,
      "lon": -8.866667
    },
    {
      "code": "PWROR",
      "name": "Koror",
      "country": "PW",
      "lat": 7.34333,
      "lon": 134.48042
    },
    {
      "code": "QAHMD",
      "name": "BGN/PCGN1956 - HAMAD",
      "country": "QA",
      "lat": 25,
      "lon": 51.616667
    },
    {
      "code": "QARLF",
      "name": "Ras Laffan",
      "country": "QA",
      "lat": 25.933333,
      "lon": 51.533333
    },
    {
      "code": "QAUMS",
      "name": "Umm Sa'id (Mesaieed)",
      "country": "QA",
      "lat": 24.983333,
      "lon": 51.533333
    },
    {
      "code": "RELPT",
      "name": "Le Port",
      "country": "RE",
      "lat": -20.933333,
      "lon": 55.316667
    },
    {
      "code": "REPD2",
      "name": "Pointe des Galets",
      "country": "RE",
      "lat": -20.916667,
      "lon": 55.283333
    },
    {
      "code": "ROCND",
      "name": "Constanta",
      "country": "RO",
      "lat": 44.183333,
      "lon": 28.65
    },
    {
      "code": "ROMID",
      "name": "Midia",
      "country": "RO",
      "lat": 44.333333,
      "lon": 28.616667
    },
    {
      "code": "RUKGD",
      "name": "Kaliningrad",
      "country": "RU",
      "lat": 54.7,
      "lon": 20.483333
    },
    {
      "code": "RUKZP",
      "name": "Kavkaz",
      "country": "RU",
      "lat": 45.416667,
      "lon": 36.766667
    },
    {
      "code": "RUMCX",
      "name": "Makhachkala",
      "country": "RU",
      "lat": 42.966667,
      "lon": 47.5
    },
    {
      "code": "RUMMK",
      "name": "Murmansk",
      "country": "RU",
      "lat": 68.983333,
      "lon": 33.05
    },
    {
      "code": "RUNIA",
      "name": "Nikolayevsk-na-Amure",
      "country": "RU",
      "lat": 53.133333,
      "lon": 140.733333
    },
    {
      "code": "RUNJK",
      "name": "Nakhodka",
      "country": "RU",
      "lat": 42.8,
      "lon": 132.883333
    },
    {
      "code": "RUNVS",
      "name": "Novorossiysk",
      "country": "RU",
      "lat": 44.716667,
      "lon": 37.766667
    },
    {
      "code": "RUPRI",
      "name": "Primorsk (Koivisto)",
      "country": "RU",
      "lat": 60.366667,
      "lon": 28.633333
    },
    {
      "code": "RUROV",
      "name": "Rostov",
      "country": "RU",
      "lat": 47.2225,
      "lon": 39.71
    },
    {
      "code": "RURTW",
      "name": "Saratov",
      "country": "RU",
      "lat": 51.54048,
      "lon": 45.9901
    },
    {
      "code": "RUSAB",
      "name": "Sabetta",
      "country": "RU",
      "lat": 71.25,
      "lon": 72.083333
    },
    {
      "code": "RUTAG",
      "name": "Taganrog",
      "country": "RU",
      "lat": 47.2,
      "lon": 38.95
    },
    {
      "code": "RUTAM",
      "name": "Taman'",
      "country": "RU",
      "lat": 45.216667,
      "lon": 36.716667
    },
    {
      "code": "RUTUA",
      "name": "Tuapse",
      "country": "RU",
      "lat": 44.1,
      "lon": 39.066667
    },
    {
      "code": "RUULU",
      "name": "Ust'-Luga",
      "country": "RU",
      "lat": 59.666667,
      "lon": 28.316667
    },
    {
      "code": "RUVLG",
      "name": "Volga",
      "country": "RU",
      "lat": 57.95,
      "lon": 38.4
    },
    {
      "code": "RUVNN",
      "name": "Vanino",
      "country": "RU",
      "lat": 49.083333,
      "lon": 140.283333
    },
    {
      "code": "SADMM",
      "name": "Ad Dammam",
      "country": "SA",
      "lat": 26.5,
      "lon": 50.2
    },
    {
      "code": "SAGIZ",
      "name": "Jizan",
      "country": "SA",
      "lat": 16.9,
      "lon": 42.5
    },
    {
      "code": "SAJBI",
      "name": "Al Jubayl Industrial City",
      "country": "SA",
      "lat": 27.083333,
      "lon": 49.7
    },
    {
      "code": "SAJED",
      "name": "Jeddah",
      "country": "SA",
      "lat": 21.466667,
      "lon": 39.166667
    },
    {
      "code": "SAJUB",
      "name": "Jubail",
      "country": "SA",
      "lat": 27.016667,
      "lon": 49.666667
    },
    {
      "code": "SAKAC",
      "name": "King Abdullah City",
      "country": "SA",
      "lat": 22.4,
      "lon": 39.083333
    },
    {
      "code": "SARAZ",
      "name": "Ras Al-Khair",
      "country": "SA",
      "lat": 27.55,
      "lon": 49.2
    },
    {
      "code": "SARTA",
      "name": "Ras Tanura",
      "country": "SA",
      "lat": 26.633333,
      "lon": 50.15
    },
    {
      "code": "SAYBI",
      "name": "Yanbu Industrial City",
      "country": "SA",
      "lat": 23.933333,
      "lon": 38.25
    },
    {
      "code": "SAYNB",
      "name": "Yanbu commercial city",
      "country": "SA",
      "lat": 24.066667,
      "lon": 38.05
    },
    {
      "code": "SBHIR",
      "name": "Honiara, Guadalcanal Is",
      "country": "SB",
      "lat": -9.416667,
      "lon": 159.95
    },
    {
      "code": "SCPOV",
      "name": "Port Victoria",
      "country": "SC",
      "lat": -4.623333,
      "lon": 55.464167
    },
    {
      "code": "SDPZU",
      "name": "Port Sudan",
      "country": "SD",
      "lat": 19.6,
      "lon": 37.233333
    },
    {
      "code": "SEBAA",
      "name": "Balsta",
      "country": "SE",
      "lat": 59.583333,
      "lon": 17.5
    },
    {
      "code": "SEBRO",
      "name": "Brofjorden",
      "country": "SE",
      "lat": 58.35,
      "lon": 11.383333
    },
    {
      "code": "SEGOT",
      "name": "Goteborg",
      "country": "SE",
      "lat": 57.716667,
      "lon": 11.966667
    },
    {
      "code": "SEGVX",
      "name": "Gavle",
      "country": "SE",
      "lat": 60.666667,
      "lon": 17.166667
    },
    {
      "code": "SEHAD",
      "name": "Halmstad",
      "country": "SE",
      "lat": 56.666667,
      "lon": 12.85
    },
    {
      "code": "SEHEL",
      "name": "Helsingborg",
      "country": "SE",
      "lat": 56.035278,
      "lon": 12.687778
    },
    {
      "code": "SEHLD",
      "name": "Holmsund",
      "country": "SE",
      "lat": 63.70602,
      "lon": 20.36409
    },
    {
      "code": "SEHUS",
      "name": "Husum",
      "country": "SE",
      "lat": 63.333333,
      "lon": 19.166667
    },
    {
      "code": "SEKAA",
      "name": "Karlskrona",
      "country": "SE",
      "lat": 56.166667,
      "lon": 15.583333
    },
    {
      "code": "SEKAN",
      "name": "Karlshamn",
      "country": "SE",
      "lat": 56.166667,
      "lon": 14.85
    },
    {
      "code": "SEKLR",
      "name": "Kalmar",
      "country": "SE",
      "lat": 56.666667,
      "lon": 16.366667
    },
    {
      "code": "SELLA",
      "name": "Lulea",
      "country": "SE",
      "lat": 65.583333,
      "lon": 22.15
    },
    {
      "code": "SEMMA",
      "name": "Malmo",
      "country": "SE",
      "lat": 55.6,
      "lon": 13
    },
    {
      "code": "SEMON",
      "name": "Monsteras",
      "country": "SE",
      "lat": 57.033333,
      "lon": 16.433333
    },
    {
      "code": "SENRK",
      "name": "Norrkoping",
      "country": "SE",
      "lat": 58.6,
      "lon": 16.183333
    },
    {
      "code": "SENYN",
      "name": "Nynashamn",
      "country": "SE",
      "lat": 58.9,
      "lon": 17.95
    },
    {
      "code": "SEOER",
      "name": "Ornskoldsvik",
      "country": "SE",
      "lat": 63.3,
      "lon": 18.716667
    },
    {
      "code": "SEOSK",
      "name": "Oskarshamn",
      "country": "SE",
      "lat": 57.266667,
      "lon": 16.433333
    },
    {
      "code": "SEOXE",
      "name": "Oxelosund",
      "country": "SE",
      "lat": 58.666667,
      "lon": 17.1
    },
    {
      "code": "SEPIT",
      "name": "Pitea",
      "country": "SE",
      "lat": 65.333333,
      "lon": 21.5
    },
    {
      "code": "SEROR",
      "name": "Ronnskar",
      "country": "SE",
      "lat": 64.66667,
      "lon": 21.26667
    },
    {
      "code": "SESDL",
      "name": "Sundsvall",
      "country": "SE",
      "lat": 62.383333,
      "lon": 17.3
    },
    {
      "code": "SESKE",
      "name": "Skelleftehamn",
      "country": "SE",
      "lat": 64.683333,
      "lon": 21.233333
    },
    {
      "code": "SESLI",
      "name": "Slite",
      "country": "SE",
      "lat": 57.716667,
      "lon": 18.8
    },
    {
      "code": "SESOE",
      "name": "Sodertalje",
      "country": "SE",
      "lat": 59.2,
      "lon": 17.616667
    },
    {
      "code": "SESOL",
      "name": "Solvesborg",
      "country": "SE",
      "lat": 56.05,
      "lon": 14.55
    },
    {
      "code": "SESOO",
      "name": "Soderhamn",
      "country": "SE",
      "lat": 61.3,
      "lon": 17.083333
    },
    {
      "code": "SESTE",
      "name": "Stenungsund",
      "country": "SE",
      "lat": 58.75,
      "lon": 11.816667
    },
    {
      "code": "SESTO",
      "name": "Stockholm",
      "country": "SE",
      "lat": 59.333333,
      "lon": 18.05
    },
    {
      "code": "SETRG",
      "name": "Trelleborg",
      "country": "SE",
      "lat": 55.366667,
      "lon": 13.166667
    },
    {
      "code": "SEUDD",
      "name": "Uddevalla",
      "country": "SE",
      "lat": 58.366667,
      "lon": 11.933333
    },
    {
      "code": "SEVAG",
      "name": "Varberg",
      "country": "SE",
      "lat": 57.108889,
      "lon": 12.2325
    },
    {
      "code": "SEVBY",
      "name": "Visby",
      "country": "SE",
      "lat": 57.633333,
      "lon": 18.3
    },
    {
      "code": "SEVST",
      "name": "Vasteras",
      "country": "SE",
      "lat": 59.616667,
      "lon": 16.55
    },
    {
      "code": "SEVVK",
      "name": "Vastervik",
      "country": "SE",
      "lat": 57.75,
      "lon": 16.633333
    },
    {
      "code": "SGJUR",
      "name": "Jurong",
      "country": "SG",
      "lat": 1.333333,
      "lon": 103.7
    },
    {
      "code": "SGSIN",
      "name": "Singapore",
      "country": "SG",
      "lat": 1.283333,
      "lon": 103.85
    },
    {
      "code": "SIKOP",
      "name": "Koper",
      "country": "SI",
      "lat": 45.55,
      "lon": 13.733333
    },
    {
      "code": "SLFNA",
      "name": "Freetown",
      "country": "SL",
      "lat": 8.5,
      "lon": -13.233333
    },
    {
      "code": "SNDKR",
      "name": "Dakar",
      "country": "SN",
      "lat": 14.683333,
      "lon": -17.433333
    },
    {
      "code": "SNXLS",
      "name": "Saint Louis",
      "country": "SN",
      "lat": 16.033333,
      "lon": -16.5
    },
    {
      "code": "SRPBM",
      "name": "Paramaribo",
      "country": "SR",
      "lat": 5.833333,
      "lon": -55.166667
    },
    {
      "code": "SVAQJ",
      "name": "Acajutla",
      "country": "SV",
      "lat": 13.583333,
      "lon": -89.833333
    },
    {
      "code": "SXPHI",
      "name": "Philipsburg",
      "country": "SX",
      "lat": 18.016667,
      "lon": -63.033333
    },
    {
      "code": "TGKPE",
      "name": "Kpeme",
      "country": "TG",
      "lat": 6.2,
      "lon": 1.516667
    },
    {
      "code": "TGLFW",
      "name": "Lome",
      "country": "TG",
      "lat": 6.133333,
      "lon": 1.283333
    },
    {
      "code": "THBKK",
      "name": "Bangkok",
      "country": "TH",
      "lat": 13.75,
      "lon": 100.516667
    },
    {
      "code": "THBSP",
      "name": "Bang Saphan",
      "country": "TH",
      "lat": 11.2,
      "lon": 99.516667
    },
    {
      "code": "THKSI",
      "name": "Ko Sichang",
      "country": "TH",
      "lat": 13.133333,
      "lon": 100.816667
    },
    {
      "code": "THLCH",
      "name": "Laem Chabang",
      "country": "TH",
      "lat": 13.083333,
      "lon": 100.883333
    },
    {
      "code": "THMAT",
      "name": "Map Ta Phut",
      "country": "TH",
      "lat": 12.65,
      "lon": 101.3
    },
    {
      "code": "THPPC",
      "name": "Prachuap Port",
      "country": "TH",
      "lat": 11.2,
      "lon": 99.583333
    },
    {
      "code": "THRNN",
      "name": "Ranong",
      "country": "TH",
      "lat": 9.966667,
      "lon": 98.633333
    },
    {
      "code": "THSAP",
      "name": "Samut Prakan",
      "country": "TH",
      "lat": 13.6,
      "lon": 100.6
    },
    {
      "code": "THSCS",
      "name": "Sahathai Coastal Seaport",
      "country": "TH",
      "lat": 13.65,
      "lon": 100.533333
    },
    {
      "code": "THSRI",
      "name": "Si Racha",
      "country": "TH",
      "lat": 13.166667,
      "lon": 100.883333
    },
    {
      "code": "THURT",
      "name": "Surat Thani",
      "country": "TH",
      "lat": 9.133333,
      "lon": 99.133333
    },
    {
      "code": "TNBIZ",
      "name": "Bizerte",
      "country": "TN",
      "lat": 37.283333,
      "lon": 9.883333
    },
    {
      "code": "TNGAE",
      "name": "Gabes",
      "country": "TN",
      "lat": 33.883333,
      "lon": 10.116667
    },
    {
      "code": "TNLGN",
      "name": "La Goulette Nord (Halqueloued)",
      "country": "TN",
      "lat": 36.8,
      "lon": 10.3
    },
    {
      "code": "TNLSK",
      "name": "La Skhirra",
      "country": "TN",
      "lat": 34.283333,
      "lon": 10.1
    },
    {
      "code": "TNRDS",
      "name": "Rades",
      "country": "TN",
      "lat": 36.766667,
      "lon": 10.266667
    },
    {
      "code": "TNSFA",
      "name": "Sfax",
      "country": "TN",
      "lat": 34.733333,
      "lon": 10.766667
    },
    {
      "code": "TNSUS",
      "name": "Sousse",
      "country": "TN",
      "lat": 35.824722,
      "lon": 10.644722
    },
    {
      "code": "TOTBU",
      "name": "Nuku'alofa",
      "country": "TO",
      "lat": -21.133333,
      "lon": -175.2
    },
    {
      "code": "TRADY",
      "name": "Yumurtalik",
      "country": "TR",
      "lat": 36.766667,
      "lon": 35.783333
    },
    {
      "code": "TRALI",
      "name": "Aliaga",
      "country": "TR",
      "lat": 38.833333,
      "lon": 26.933333
    },
    {
      "code": "TRAYT",
      "name": "Antalya",
      "country": "TR",
      "lat": 36.833333,
      "lon": 30.6
    },
    {
      "code": "TRBDM",
      "name": "Bandirma",
      "country": "TR",
      "lat": 40.35,
      "lon": 27.966667
    },
    {
      "code": "TRCEY",
      "name": "Ceyhan",
      "country": "TR",
      "lat": 37.028889,
      "lon": 35.8125
    },
    {
      "code": "TRDIL",
      "name": "Diliskelesi",
      "country": "TR",
      "lat": 40.77569,
      "lon": 29.52678
    },
    {
      "code": "TRDRC",
      "name": "Derince",
      "country": "TR",
      "lat": 40.75,
      "lon": 29.816667
    },
    {
      "code": "TRDYL",
      "name": "Dortyol",
      "country": "TR",
      "lat": 36.866667,
      "lon": 36.2
    },
    {
      "code": "TRERE",
      "name": "Eregli",
      "country": "TR",
      "lat": 41.283333,
      "lon": 31.4
    },
    {
      "code": "TRGEB",
      "name": "Gebze",
      "country": "TR",
      "lat": 40.783333,
      "lon": 29.416667
    },
    {
      "code": "TRGEM",
      "name": "Gemlik",
      "country": "TR",
      "lat": 40.416667,
      "lon": 29.15
    },
    {
      "code": "TRGIR",
      "name": "Giresun",
      "country": "TR",
      "lat": 40.916667,
      "lon": 38.383333
    },
    {
      "code": "TRHER",
      "name": "Hereke",
      "country": "TR",
      "lat": 40.778105,
      "lon": 29.608795
    },
    {
      "code": "TRIDM",
      "name": "Isdemir",
      "country": "TR",
      "lat": 36.716667,
      "lon": 36.183333
    },
    {
      "code": "TRIDS",
      "name": "Icdas Jetty",
      "country": "TR",
      "lat": 40.45,
      "lon": 27.3
    },
    {
      "code": "TRISK",
      "name": "Iskenderun",
      "country": "TR",
      "lat": 36.583333,
      "lon": 36.166667
    },
    {
      "code": "TRIST",
      "name": "Istanbul",
      "country": "TR",
      "lat": 41.016667,
      "lon": 28.966667
    },
    {
      "code": "TRIZT",
      "name": "Izmit",
      "country": "TR",
      "lat": 40.783333,
      "lon": 29.95
    },
    {
      "code": "TRKFZ",
      "name": "Korfez",
      "country": "TR",
      "lat": 40.783333,
      "lon": 29.733333
    },
    {
      "code": "TRKRB",
      "name": "Karabiga",
      "country": "TR",
      "lat": 40.4,
      "lon": 27.3
    },
    {
      "code": "TRLMA",
      "name": "Limas",
      "country": "TR",
      "lat": 40.716667,
      "lon": 29.883333
    },
    {
      "code": "TRMAR",
      "name": "Marmara Ereglisi",
      "country": "TR",
      "lat": 40.96907,
      "lon": 27.95503
    },
    {
      "code": "TRMER",
      "name": "Mersin",
      "country": "TR",
      "lat": 36.716667,
      "lon": 34.633333
    },
    {
      "code": "TRMRA",
      "name": "Marmara Adasi",
      "country": "TR",
      "lat": 40.583333,
      "lon": 27.55
    },
    {
      "code": "TRSSX",
      "name": "Samsun",
      "country": "TR",
      "lat": 41.283333,
      "lon": 36.333333
    },
    {
      "code": "TRTEK",
      "name": "Tekirdag",
      "country": "TR",
      "lat": 40.966667,
      "lon": 27.516667
    },
    {
      "code": "TRTIR",
      "name": "Tirebolu",
      "country": "TR",
      "lat": 41,
      "lon": 38.8
    },
    {
      "code": "TRTUT",
      "name": "Tutunciftlik",
      "country": "TR",
      "lat": 40.74807,
      "lon": 29.76179
    },
    {
      "code": "TRTZX",
      "name": "Trabzon",
      "country": "TR",
      "lat": 41,
      "lon": 39.733333
    },
    {
      "code": "TRYAL",
      "name": "Yalova",
      "country": "TR",
      "lat": 40.65,
      "lon": 29.266667
    },
    {
      "code": "TRYAR",
      "name": "Yarimca",
      "country": "TR",
      "lat": 40.8,
      "lon": 29.7
    },
    {
      "code": "TRYIK",
      "name": "Yesilovacik",
      "country": "TR",
      "lat": 36.2,
      "lon": 33.666667
    },
    {
      "code": "TRZON",
      "name": "Zonguldak",
      "country": "TR",
      "lat": 41.45,
      "lon": 31.783333
    },
    {
      "code": "TTCHA",
      "name": "Chaguaramas",
      "country": "TT",
      "lat": 10.683333,
      "lon": -61.65
    },
    {
      "code": "TTPTF",
      "name": "Point Fortin",
      "country": "TT",
      "lat": 10.2,
      "lon": -61.7
    },
    {
      "code": "TTPTP",
      "name": "Pointe a Pierre",
      "country": "TT",
      "lat": 10.316667,
      "lon": -61.466667
    },
    {
      "code": "TTPTS",
      "name": "Point Lisas",
      "country": "TT",
      "lat": 10.391667,
      "lon": -61.491666
    },
    {
      "code": "TWHOP",
      "name": "Hoping",
      "country": "TW",
      "lat": 24.30248,
      "lon": 121.75804
    },
    {
      "code": "TWHUN",
      "name": "Hualien",
      "country": "TW",
      "lat": 23.983333,
      "lon": 121.6
    },
    {
      "code": "TWKEL",
      "name": "Keelung (Chilung)",
      "country": "TW",
      "lat": 25.133333,
      "lon": 121.766667
    },
    {
      "code": "TWKHH",
      "name": "Kaohsiung",
      "country": "TW",
      "lat": 22.616667,
      "lon": 120.25
    },
    {
      "code": "TWMLI",
      "name": "Mai-liao",
      "country": "TW",
      "lat": 23.1,
      "lon": 120.133333
    },
    {
      "code": "TWSHL",
      "name": "Sha-lun",
      "country": "TW",
      "lat": 25.1,
      "lon": 121.216667
    },
    {
      "code": "TWTPE",
      "name": "Taipei",
      "country": "TW",
      "lat": 25.033333,
      "lon": 121.516667
    },
    {
      "code": "TWTXG",
      "name": "Taichung",
      "country": "TW",
      "lat": 24.3,
      "lon": 120.5
    },
    {
      "code": "TZDAR",
      "name": "Dar es Salaam",
      "country": "TZ",
      "lat": -6.8,
      "lon": 39.283333
    },
    {
      "code": "TZMYW",
      "name": "Mtwara",
      "country": "TZ",
      "lat": -10.266667,
      "lon": 40.2
    },
    {
      "code": "TZTGT",
      "name": "Tanga",
      "country": "TZ",
      "lat": -5.083333,
      "lon": 39.116667
    },
    {
      "code": "TZZNZ",
      "name": "Zanzibar",
      "country": "TZ",
      "lat": -6.166667,
      "lon": 39.183333
    },
    {
      "code": "UAILK",
      "name": "Chornomorsk",
      "country": "UA",
      "lat": 46.316667,
      "lon": 30.666667
    },
    {
      "code": "UAKHE",
      "name": "Kherson",
      "country": "UA",
      "lat": 46.616667,
      "lon": 32.616667
    },
    {
      "code": "UANLV",
      "name": "Mykolaiv",
      "country": "UA",
      "lat": 46.933333,
      "lon": 32
    },
    {
      "code": "UAODS",
      "name": "Odesa",
      "country": "UA",
      "lat": 46.5,
      "lon": 30.75
    },
    {
      "code": "UAYUZ",
      "name": "Pivdennyi",
      "country": "UA",
      "lat": 46.6,
      "lon": 31.016667
    },
    {
      "code": "USALB",
      "name": "Albany",
      "country": "US",
      "lat": 42.65,
      "lon": -73.75
    },
    {
      "code": "USANC",
      "name": "Anchorage",
      "country": "US",
      "lat": 61.216667,
      "lon": -149.9
    },
    {
      "code": "USASF",
      "name": "Ashtabula",
      "country": "US",
      "lat": 41.9,
      "lon": -80.8
    },
    {
      "code": "USBAL",
      "name": "Baltimore",
      "country": "US",
      "lat": 39.283333,
      "lon": -76.616667
    },
    {
      "code": "USBAY",
      "name": "Bayonne",
      "country": "US",
      "lat": 40.683333,
      "lon": -74.1
    },
    {
      "code": "USBNC",
      "name": "Benicia",
      "country": "US",
      "lat": 38.05,
      "lon": -122.15
    },
    {
      "code": "USBOS",
      "name": "Boston",
      "country": "US",
      "lat": 42.35,
      "lon": -71.05
    },
    {
      "code": "USBPT",
      "name": "Beaumont",
      "country": "US",
      "lat": 30.083333,
      "lon": -94.083333
    },
    {
      "code": "USBRO",
      "name": "Brownsville",
      "country": "US",
      "lat": 25.9,
      "lon": -97.483333
    },
    {
      "code": "USCHI",
      "name": "Chicago",
      "country": "US",
      "lat": 41.883333,
      "lon": -87.6
    },
    {
      "code": "USCHS",
      "name": "Charleston",
      "country": "US",
      "lat": 32.783333,
      "lon": -79.916667
    },
    {
      "code": "USCLQ",
      "name": "Chalmette",
      "country": "US",
      "lat": 29.94296,
      "lon": -89.96537
    },
    {
      "code": "USCMU",
      "name": "Cameron",
      "country": "US",
      "lat": 35.333333,
      "lon": -79.25
    },
    {
      "code": "USCP6",
      "name": "Cove Point",
      "country": "US",
      "lat": 38.366667,
      "lon": -76.383333
    },
    {
      "code": "USCRP",
      "name": "Corpus Christi",
      "country": "US",
      "lat": 27.816667,
      "lon": -97.4
    },
    {
      "code": "USDCI",
      "name": "Delaware City",
      "country": "US",
      "lat": 39.566667,
      "lon": -75.583333
    },
    {
      "code": "USDET",
      "name": "Detroit",
      "country": "US",
      "lat": 42.316667,
      "lon": -83.033333
    },
    {
      "code": "USDUT",
      "name": "Dutch Harbor",
      "country": "US",
      "lat": 53.9,
      "lon": -166.533333
    },
    {
      "code": "USELS",
      "name": "El Segundo",
      "country": "US",
      "lat": 33.916667,
      "lon": -118.433333
    },
    {
      "code": "USFAH",
      "name": "Fairless Hills",
      "country": "US",
      "lat": 40.17955,
      "lon": -74.85516
    },
    {
      "code": "USFDT",
      "name": "Ferndale",
      "country": "US",
      "lat": 48.85,
      "lon": -122.583333
    },
    {
      "code": "USFPO",
      "name": "Freeport",
      "country": "US",
      "lat": 28.95,
      "lon": -95.333333
    },
    {
      "code": "USGHC",
      "name": "Grays Harbor City",
      "country": "US",
      "lat": 46.983333,
      "lon": -123.95
    },
    {
      "code": "USGLS",
      "name": "Galveston",
      "country": "US",
      "lat": 29.316667,
      "lon": -94.783333
    },
    {
      "code": "USGRB",
      "name": "Green Bay",
      "country": "US",
      "lat": 44.516667,
      "lon": -88.016667
    },
    {
      "code": "USGUM",
      "name": "Gulfmex Lightering Area",
      "country": "US",
      "lat": 27.75,
      "lon": -90.833333
    },
    {
      "code": "USHGN",
      "name": "Hawaiian Gardens",
      "country": "US",
      "lat": 33.828611,
      "lon": -118.073611
    },
    {
      "code": "USHNL",
      "name": "Honolulu",
      "country": "US",
      "lat": 21.3,
      "lon": -157.85
    },
    {
      "code": "USHOU",
      "name": "Houston",
      "country": "US",
      "lat": 29.75,
      "lon": -95.35
    },
    {
      "code": "USHPY",
      "name": "Baytown",
      "country": "US",
      "lat": 29.733333,
      "lon": -95.016667
    },
    {
      "code": "USHVN",
      "name": "New Haven",
      "country": "US",
      "lat": 41.233333,
      "lon": -72.916667
    },
    {
      "code": "USILM",
      "name": "Wilmington",
      "country": "US",
      "lat": 34.216667,
      "lon": -77.933333
    },
    {
      "code": "USJAX",
      "name": "Jacksonville",
      "country": "US",
      "lat": 30.316667,
      "lon": -81.65
    },
    {
      "code": "USKAM",
      "name": "Kalama",
      "country": "US",
      "lat": 46.016667,
      "lon": -122.85
    },
    {
      "code": "USLAX",
      "name": "Los Angeles",
      "country": "US",
      "lat": 34.05,
      "lon": -118.25
    },
    {
      "code": "USLCH",
      "name": "Lake Charles",
      "country": "US",
      "lat": 30.216667,
      "lon": -93.25
    },
    {
      "code": "USLGB",
      "name": "Long Beach",
      "country": "US",
      "lat": 33.766667,
      "lon": -118.183333
    },
    {
      "code": "USLU8",
      "name": "Port Of South Louisiana",
      "country": "US",
      "lat": 30.05,
      "lon": -90.5
    },
    {
      "code": "USMAH",
      "name": "Marcus Hook",
      "country": "US",
      "lat": 39.816667,
      "lon": -75.416667
    },
    {
      "code": "USMKE",
      "name": "Milwaukee",
      "country": "US",
      "lat": 43.033333,
      "lon": -87.883333
    },
    {
      "code": "USMOB",
      "name": "Mobile",
      "country": "US",
      "lat": 30.683333,
      "lon": -88.116667
    },
    {
      "code": "USMQI",
      "name": "Quincy",
      "country": "US",
      "lat": 42.25,
      "lon": -70.966667
    },
    {
      "code": "USMRZ",
      "name": "Martinez",
      "country": "US",
      "lat": 38.033333,
      "lon": -122.133333
    },
    {
      "code": "USMSY",
      "name": "New Orleans",
      "country": "US",
      "lat": 29.95,
      "lon": -90.05
    },
    {
      "code": "USNAX",
      "name": "Barbers Point (Oahu)",
      "country": "US",
      "lat": 21.316667,
      "lon": -158.116667
    },
    {
      "code": "USNIK",
      "name": "Nikiski",
      "country": "US",
      "lat": 60.666667,
      "lon": -151.35
    },
    {
      "code": "USNNS",
      "name": "Newport News",
      "country": "US",
      "lat": 36.966667,
      "lon": -76.416667
    },
    {
      "code": "USNSS",
      "name": "Sabine Pass",
      "country": "US",
      "lat": 29.716667,
      "lon": -93.9
    },
    {
      "code": "USNYC",
      "name": "New York",
      "country": "US",
      "lat": 40.7,
      "lon": -74
    },
    {
      "code": "USORF",
      "name": "Norfolk",
      "country": "US",
      "lat": 36.85,
      "lon": -76.3
    },
    {
      "code": "USOTS",
      "name": "Anacortes",
      "country": "US",
      "lat": 48.516667,
      "lon": -122.616667
    },
    {
      "code": "USPAL",
      "name": "Port Allen",
      "country": "US",
      "lat": 21.9,
      "lon": -159.583333
    },
    {
      "code": "USPAS",
      "name": "Pasadena",
      "country": "US",
      "lat": 29.683333,
      "lon": -95.2
    },
    {
      "code": "USPAU",
      "name": "Paulsboro",
      "country": "US",
      "lat": 39.85,
      "lon": -75.25
    },
    {
      "code": "USPBI",
      "name": "West Palm Beach",
      "country": "US",
      "lat": 26.709722,
      "lon": -80.064167
    },
    {
      "code": "USPCV",
      "name": "Port Canaveral",
      "country": "US",
      "lat": 28.4,
      "lon": -80.6
    },
    {
      "code": "USPDX",
      "name": "Portland",
      "country": "US",
      "lat": 45.516667,
      "lon": -122.666667
    },
    {
      "code": "USPEF",
      "name": "Port Everglades",
      "country": "US",
      "lat": 26.1,
      "lon": -80.133333
    },
    {
      "code": "USPGL",
      "name": "Pascagoula",
      "country": "US",
      "lat": 30.35,
      "lon": -88.566667
    },
    {
      "code": "USPHL",
      "name": "Philadelphia",
      "country": "US",
      "lat": 39.95,
      "lon": -75.133333
    },
    {
      "code": "USPLQ",
      "name": "Plaquemine",
      "country": "US",
      "lat": 30.2842,
      "lon": -91.2406
    },
    {
      "code": "USPOA",
      "name": "Port Arthur",
      "country": "US",
      "lat": 29.883333,
      "lon": -93.916667
    },
    {
      "code": "USPVD",
      "name": "Providence",
      "country": "US",
      "lat": 41.8,
      "lon": -71.4
    },
    {
      "code": "USRCH",
      "name": "Richmond",
      "country": "US",
      "lat": 37.916667,
      "lon": -122.366667
    },
    {
      "code": "USRD4",
      "name": "Rodeo",
      "country": "US",
      "lat": 38.016667,
      "lon": -122.25
    },
    {
      "code": "USRIC",
      "name": "Richmond",
      "country": "US",
      "lat": 37.55,
      "lon": -77.45
    },
    {
      "code": "USRSF",
      "name": "Reserve",
      "country": "US",
      "lat": 30.05,
      "lon": -90.55
    },
    {
      "code": "USSAC",
      "name": "Sacramento",
      "country": "US",
      "lat": 38.566667,
      "lon": -121.483333
    },
    {
      "code": "USSAV",
      "name": "Savannah",
      "country": "US",
      "lat": 32.083333,
      "lon": -81.083333
    },
    {
      "code": "USSCK",
      "name": "Stockton",
      "country": "US",
      "lat": 37.95,
      "lon": -121.283333
    },
    {
      "code": "USSFO",
      "name": "San Francisco",
      "country": "US",
      "lat": 37.816667,
      "lon": -122.416667
    },
    {
      "code": "USSRE",
      "name": "Saint Rose",
      "country": "US",
      "lat": 29.95,
      "lon": -90.316667
    },
    {
      "code": "USSSI",
      "name": "Brunswick",
      "country": "US",
      "lat": 31.15,
      "lon": -81.5
    },
    {
      "code": "USTBW",
      "name": "Point Barrow",
      "country": "US",
      "lat": 71.283333,
      "lon": -156.666667
    },
    {
      "code": "USTIW",
      "name": "Tacoma",
      "country": "US",
      "lat": 47.283333,
      "lon": -122.416667
    },
    {
      "code": "USTOL",
      "name": "Toledo",
      "country": "US",
      "lat": 41.7,
      "lon": -83.466667
    },
    {
      "code": "USTPA",
      "name": "Tampa",
      "country": "US",
      "lat": 27.916667,
      "lon": -82.45
    },
    {
      "code": "USTXT",
      "name": "Texas City",
      "country": "US",
      "lat": 29.383333,
      "lon": -94.916667
    },
    {
      "code": "USUAC",
      "name": "Bristol",
      "country": "US",
      "lat": 40.1,
      "lon": -74.85
    },
    {
      "code": "USVAN",
      "name": "Vancouver",
      "country": "US",
      "lat": 45.633333,
      "lon": -122.683333
    },
    {
      "code": "USXAE",
      "name": "Camden",
      "country": "US",
      "lat": 39.116667,
      "lon": -75.533333
    },
    {
      "code": "USYAS",
      "name": "Aransas Pass",
      "country": "US",
      "lat": 27.9,
      "lon": -97.15
    },
    {
      "code": "USYYG",
      "name": "Grayson",
      "country": "US",
      "lat": 33.883333,
      "lon": -83.95
    },
    {
      "code": "USZKH",
      "name": "Fort Klamath",
      "country": "US",
      "lat": 42.7,
      "lon": -121.983333
    },
    {
      "code": "UYFZB",
      "name": "Fray Bentos",
      "country": "UY",
      "lat": -33.116667,
      "lon": -58.316667
    },
    {
      "code": "UYJIT",
      "name": "Jose Ignacio Terminal",
      "country": "UY",
      "lat": -34.95,
      "lon": -54.7
    },
    {
      "code": "UYLAP",
      "name": "La Paloma/Rocha",
      "country": "UY",
      "lat": -34.65,
      "lon": -54.15
    },
    {
      "code": "UYMVD",
      "name": "Montevideo",
      "country": "UY",
      "lat": -34.9,
      "lon": -56.216667
    },
    {
      "code": "UYNVP",
      "name": "Nueva Palmira",
      "country": "UY",
      "lat": -33.883333,
      "lon": -58.416667
    },
    {
      "code": "UYPTP",
      "name": "Punta Pereyra",
      "country": "UY",
      "lat": -34.233333,
      "lon": -58.066667
    },
    {
      "code": "VCKTN",
      "name": "Kingstown",
      "country": "VC",
      "lat": 13.133333,
      "lon": -61.216667
    },
    {
      "code": "VEAMY",
      "name": "Amuay",
      "country": "VE",
      "lat": 11.75,
      "lon": -70.233333
    },
    {
      "code": "VEJOT",
      "name": "Jose Terminal",
      "country": "VE",
      "lat": 10.1,
      "lon": -64.85
    },
    {
      "code": "VEPBL",
      "name": "Puerto Cabello",
      "country": "VE",
      "lat": 10.483333,
      "lon": -68
    },
    {
      "code": "VISTT",
      "name": "Saint Thomas",
      "country": "VI",
      "lat": 18.35,
      "lon": -64.933333
    },
    {
      "code": "VISTX",
      "name": "Saint Croix",
      "country": "VI",
      "lat": 17.75,
      "lon": -64.733333
    },
    {
      "code": "VNCMY",
      "name": "Chan May Port",
      "country": "VN",
      "lat": 16.333333,
      "lon": 108
    },
    {
      "code": "VNCPH",
      "name": "Cam Pha",
      "country": "VN",
      "lat": 21.033333,
      "lon": 107.366667
    },
    {
      "code": "VNCSG",
      "name": "Sai Gon Port",
      "country": "VN",
      "lat": 10.833333,
      "lon": 106.75
    },
    {
      "code": "VNCUA",
      "name": "Cua Lo",
      "country": "VN",
      "lat": 18.816667,
      "lon": 105.716667
    },
    {
      "code": "VNDNA",
      "name": "Dong Nai",
      "country": "VN",
      "lat": 18.083333,
      "lon": 106.316667
    },
    {
      "code": "VNDQT",
      "name": "Dung Quat",
      "country": "VN",
      "lat": 15.383333,
      "lon": 108.8
    },
    {
      "code": "VNGDA",
      "name": "Go Dau A Terminal",
      "country": "VN",
      "lat": 10.65,
      "lon": 107.016667
    },
    {
      "code": "VNHLG",
      "name": "Ha Long",
      "country": "VN",
      "lat": 20.95,
      "lon": 107.066667
    },
    {
      "code": "VNHLP",
      "name": "Hon La Port",
      "country": "VN",
      "lat": 17.933333,
      "lon": 106.516667
    },
    {
      "code": "VNHON",
      "name": "Hongai",
      "country": "VN",
      "lat": 20.95,
      "lon": 107.066667
    },
    {
      "code": "VNHPH",
      "name": "Haiphong",
      "country": "VN",
      "lat": 20.85,
      "lon": 106.683333
    },
    {
      "code": "VNLBT",
      "name": "Long Binh Tan",
      "country": "VN",
      "lat": 10.933333,
      "lon": 106.833333
    },
    {
      "code": "VNNGH",
      "name": "Nghi Son",
      "country": "VN",
      "lat": 19.333333,
      "lon": 105.833333
    },
    {
      "code": "VNONB",
      "name": "Nha Be Oil Port",
      "country": "VN",
      "lat": 10.7,
      "lon": 106.733333
    },
    {
      "code": "VNPHU",
      "name": "Phu My",
      "country": "VN",
      "lat": 10.583333,
      "lon": 107.033333
    },
    {
      "code": "VNQNH",
      "name": "Quang Ninh",
      "country": "VN",
      "lat": 17.4,
      "lon": 106.633333
    },
    {
      "code": "VNSDP",
      "name": "Son Duong Port",
      "country": "VN",
      "lat": 18.1,
      "lon": 106.45
    },
    {
      "code": "VNSGN",
      "name": "Ho Chi Minh City",
      "country": "VN",
      "lat": 10.766667,
      "lon": 106.666667
    },
    {
      "code": "VNTBH",
      "name": "Thai Binh",
      "country": "VN",
      "lat": 20.45,
      "lon": 106.333333
    },
    {
      "code": "VNTHO",
      "name": "Thanh Hoa",
      "country": "VN",
      "lat": 10.816667,
      "lon": 106.766667
    },
    {
      "code": "VNTNA",
      "name": "Thi Nai Port",
      "country": "VN",
      "lat": 13.766667,
      "lon": 109.25
    },
    {
      "code": "VNTOT",
      "name": "Cai Mep",
      "country": "VN",
      "lat": 10.383333,
      "lon": 107.083333
    },
    {
      "code": "VNUIH",
      "name": "Quy Nhon",
      "country": "VN",
      "lat": 13.766667,
      "lon": 109.216667
    },
    {
      "code": "VNVAG",
      "name": "Vung Ang",
      "country": "VN",
      "lat": 18.066667,
      "lon": 106.433333
    },
    {
      "code": "VNVHG",
      "name": "Vinalines Hau Giang Port",
      "country": "VN",
      "lat": 9.15,
      "lon": 105.133333
    },
    {
      "code": "VNVPH",
      "name": "Van Phong",
      "country": "VN",
      "lat": 12.666667,
      "lon": 109.283333
    },
    {
      "code": "VNVUT",
      "name": "Vung Tau",
      "country": "VN",
      "lat": 10.35,
      "lon": 107.066667
    },
    {
      "code": "WSAPW",
      "name": "Apia",
      "country": "WS",
      "lat": -13.816667,
      "lon": -171.766667
    },
    {
      "code": "YTMAM",
      "name": "Mamoudzou",
      "country": "YT",
      "lat": -12.783333,
      "lon": 45.233333
    },
    {
      "code": "ZACPT",
      "name": "Cape Town",
      "country": "ZA",
      "lat": -33.916667,
      "lon": 18.416667
    },
    {
      "code": "ZADUR",
      "name": "Durban",
      "country": "ZA",
      "lat": -29.85,
      "lon": 31.016667
    },
    {
      "code": "ZAELS",
      "name": "East London",
      "country": "ZA",
      "lat": -33.033333,
      "lon": 27.916667
    },
    {
      "code": "ZAMZY",
      "name": "Mossel Bay",
      "country": "ZA",
      "lat": -34.174722,
      "lon": 22.146111
    },
    {
      "code": "ZAPLZ",
      "name": "Gqeberha",
      "country": "ZA",
      "lat": -33.95,
      "lon": 25.6
    },
    {
      "code": "ZARCB",
      "name": "Richards Bay",
      "country": "ZA",
      "lat": -28.81,
      "lon": 32.098333
    },
    {
      "code": "ZASDB",
      "name": "Saldanha Bay",
      "country": "ZA",
      "lat": -33.033333,
      "lon": 17.966667
    },
    {
      "code": "ZAZBA",
      "name": "Coega",
      "country": "ZA",
      "lat": -33.766667,
      "lon": 25.666667
    }
  ]
}
